{
  "accessibility": {
    "closeModal": "Lukke modal",
    "useSetting": "Bruk innstilling",
    "srOnly": {
      "close": "Lukke",
      "loading": "Laster ..."
    }
  },
  "account": {
    "salesResources": {
      "title": "Salgsressurser",
      "searchDocuments": "Søk i dokumenter",
      "minimalRating": "Minimal vurdering",
      "maxRating": "Maks vurdering"
    },
    "saasRebilling": {
      "enableRebillingMessage": "Aktiver omfakturering for denne klienten for å tjene opptil 10 ganger så mye i fortjeneste på bruk av telefon, e-post, automatiseringer osv.",
      "enableRebilling": "Aktiver omfakturering",
      "servicesActivateAfterPayment": "Omfaktureringstjenester vil være aktive etter at kunden har lagt til en betalingsmetode. Inntil da vil kundens kontotilgang være begrenset.",
      "cannotModifyOnHold": "Kan ikke endre konfigurasjoner for omfakturering siden denne kontoen allerede har en SaaS-plan på vent. Omfaktureringstillegg vil bli konfigurert per abonnement når kunden legger til en utbetalingsmetode.",
      "rebillingSettings": "Innstillinger for omfakturering"
    }
  },
  "affiliates": {
    "aboutMe": "Om meg",
    "error": {
      "unableToSend": "Kan ikke laste opp e-post"
    },
    "industriesServed": "Bransjer som betjenes",
    "sendAMessage": "Send en melding",
    "sendMessageIntro": "Send en melding for å presentere deg for denne rådgiveren. Oppgi informasjon om deg selv og hvilke tjenester du er ute etter.",
    "socialSites": "Sosiale mediesteder",
    "success": {
      "emailSent": "E-posten er sendt"
    },
    "validationErrors": {
      "validEmail": "Oppgi gyldig e-post.",
      "validMessage": "Oppgi en gyldig melding.",
      "validName": "Oppgi et gyldig navn."
    },
    "yearsInBusiness": "Antall år i bransjen",
    "yourEmail": "E-posten din",
    "yourName": "Navnet ditt",
    "paymentDetailsAccessMessage": " Kun<strong> byråets eier</strong> kan åpne eller redigere denne delen med betalingsopplysninger. Hvis du trenger hjelp, kan du kontakte <strong>byråeieren ({ agencyOwnerEmail }</strong>).",
    "partnerBadgeAlt": "Partnermerke",
    "photoAlt": "Partnerfoto",
    "defaultCompany": "Ingen bedrift",
    "moreServices": "+ {count} flere tjenester"
  },
  "agency": {
    "saas": {
      "saasMode": "SaaS-modus",
      "pendingPaymentInformation": "Venter på betalingsinformasjon",
      "customerId": "Kunde-ID",
      "noPaymentMethods": "Det ser ut til at ingen betalingsmetoder er lagt til! Legg til en betalingsmetode for å aktivere SaaS-modusen",
      "enableSaasDescription": "Aktiver SaaS på denne underkontoen for å opprette abonnement, omfakturere telefon- og e-postbruk",
      "missingEmailAddress": "E-postadressen til kontoen mangler. Legg til detaljer først.",
      "toConvertToSaaS": "Hvis du vil konvertere denne kontoen til SaaS, må du først legge til en stedsadministrator og prøve på nytt",
      "newUser": "Opprett ny bruker",
      "stripeCustomerConnected": "Stripe-kunde er tilkoblet!",
      "requestClientPaymentDetails": "Be om kundens betalingsdetaljer",
      "saasLocationDescription": "Lokasjoner i SaaS-modus trenger kundens kredittkort for å fungere. Du kan sende en forespørsel via e-post, SMS eller ved å dele en URL",
      "selectSpace": "Velg mellomrom for å fortsette",
      "spaceDescription": "Plassen du velger her, vil bli brukt til å lagre denne kundens informasjon, behandle betalinger og administrere abonnementene deres.",
      "stripe": "Stripe",
      "freeCreditsDescription": "Når en bruker registrerer seg, kan du tilby dem gratis kreditter for å bruke e-post og telefonitjenester.",
      "thatAboutMinsInCalls": "Det er omtrent {count} tekstmeldinger eller {count1} min i samtaler",
      "subscriptionSettings": "Innstillinger for abonnement",
      "toUpgradeOrCancelPlan": "For å oppgradere eller kansellere abonnementet",
      "allowClientUpgrade": "Tillat kunden (underkontoen) å oppgradere til et høyere abonnement.",
      "addNewPlanFeatures": "Legg til det nye abonnementets funksjoner ved oppgradering",
      "upgradeFeatureDescription": "Ved oppgradering til et høyere abonnement, vil underkontoene få tilgang til tilleggsfunksjonene i det nye abonnementet. tilgang til tilleggsfunksjonene i det nye abonnementet.",
      "allowClientCancel": "Tillat kunden (underkontoen) å kansellere abonnementet.",
      "snapshotDescription": "Det valgte øyeblikksbildet vil automatisk bli lagt til i den nyopprettede SaaS-lokasjonen",
      "ownSnapshots": "Egne øyeblikksbilder",
      "selectAndContinue": "Velg og fortsett"
    },
    "advancedSettings": {
      "controlLocationSettings": "Kontroller plasseringsinnstillingene",
      "disableAddSmtp": "Deaktiver knappen Legg til e-posttjeneste i underkontoen Innstillinger for e-posttjenester",
      "disableAddSmtpDescription": "Begrens underkontobrukere fra å legge til sin egen e-postleverandør",
      "enableReVerification": "Aktiver reverifisering i 90 dager",
      "lcEmailNotEnabled": "Plasseringen har ikke LeadConnector som standard e-postleverandør",
      "onlyVisibleForAgency": "Du kan bare se disse innstillingene aktivert for byrået",
      "reVerificationDescription": "Hver e-postbekreftelsesstatus oppheves etter 90 dager (beskytt avsenderens omdømme og sørg for høyest mulig leveringsevne i innboksen)",
      "account": {
        "accountDetails": "Kontodetaljer",
        "advancedEmailSettings": "Avanserte e-postinnstillinger",
        "hipaa": "HIPAA",
        "hipaaCompliant": "HIPAA-kompatibel",
        "smsEmailLimits": "SMS/e-postgrenser",
        "socialProfiles": "Sosiale profiler",
        "subscribed": "Abonnert"
      },
      "activityTracking": {
        "history": "Historikk"
      },
      "addAccount": {
        "accountInfo": "Kontoinformasjon",
        "accountSnapshots": "Øyeblikksbilder av kontoen",
        "businessNiche": "Forretningsnisje",
        "chooseBusinessNiche": "Velg forretningsnisje …",
        "pickSnapshot": "Velg et øyeblikksbilde",
        "selectSnapshot": "Velg øyeblikksbilde",
        "title": "Legg til underkonto",
        "accountInfo1": "Kontoinformasjon"
      },
      "addBalance": {
        "addBalanceToWallet": "Legg til saldo i lommeboken",
        "addMoneyToWallet": "Legg til penger i lommeboken",
        "balanceAddedSuccessfully": "Saldoen er lagt til",
        "cardWillBeCharged": "Kortet som slutter på {cardNumber} vil bli belastet",
        "complimentaryCredits": "Gratis kreditt ({credits})",
        "creditsRemovedByAgency": "Kreditter fjernet av byrået",
        "currentBalance": "Nåværende saldo",
        "customerCCWillNotBeCharged": "Kundens kredittkort vil ikke bli belastet",
        "moneyWillBeAddedToWallet": "Penger vil bli lagt til i lommeboken",
        "pleaseProvideAmountBetween": "Oppgi et beløp mellom {min} og {max}",
        "processing": "Under behandling",
        "removeBalance": "Fjern saldo",
        "transactionSuccessful": "Transaksjonen var vellykket",
        "walletBalance": "Lommebokens saldo ({balance})"
      },
      "addPaymentMethod": {
        "adding": "Legger til …",
        "cardDetails": "Kortdetaljer",
        "cardSuccessfullyAdded": "Kortet har blitt lagt til",
        "errorWhileAddingCard": "Feil når du legger til nytt kort.",
        "maximumCardUpdateLimitReached": "Maksimal grense for kortoppdatering er nådd",
        "rateLimitMessage": "Det ser ut til at du har nådd det maksimale antallet forsøk som er tillatt for å legge til kort i dag. Prøv igjen etter 24 timer."
      },
      "aiProductRebilling": {
        "funnel": " trakt",
        "images": " Bilder,",
        "per1000Words": " /1000 ord, ",
        "perFunnel": " /trakt",
        "perImage": " / Bilde,",
        "pleaseCheckSupport": "sjekk vårt",
        "ratesMayDiffer": "Prisene kan variere avhengig av regionen. Beregningene som vises er i henhold til satser for Storbritannia,",
        "ratesMayDifferUS": "Prisene kan variere avhengig av regionen. Beregninger vist i henhold til Twilio-priser for USA. Sjekk Twilio for mer informasjon.",
        "pleaseCheckTwilioRates": "Utgående SMS for USA/Canada belastes med $0,0079 per segment. Innkommende SMS koster $0,0075/segment.",
        "words": " ord, "
      },
      "api": {
        "advancedFunctionalityNote": "Melding om avansert funksjonalitet",
        "agencyApiKeys": "Byrås API Keys",
        "apiAccess": {
          "partOfAdvancedApi": "Dette er en del av det avanserte API-et som er tilgjengelig i Pro-abonnementet.",
          "toUpgrade": "å oppgradere."
        },
        "createNew": "Opprett ny",
        "developerCouncilInfo": "Informasjon om utviklerrådet",
        "noAccess": "Du har ikke tilgang til denne delen.",
        "securityAlert": "Sikkerhetsvarselmelding",
        "table": {
          "fetchingKeys": "Henter bedriftsnøkler …",
          "noKeysYet": "Du har ingen API keys ennå.",
          "toCreateFirstKeys": "for å opprette dine første api keys."
        },
        "zapierNote": "Zapier-melding"
      },
      "calendarBeta": {
        "abilityChooseGoogleCalendars": "Mulighet til å velge Google-kalendere for å \"Legge til\" i + \"Konflikt\"-kalendere som skal sjekkes for å beregne tilgjengelighet for hver bruker",
        "abilityToAllocateRoundRobin": "Mulighet for å tildele avtaler i rotasjonsordning",
        "abilityToChooseSpecificUser": "Mulighet til å velge en spesifikk bruker som avtalen skal bookes med",
        "adminAbilitySeeEveryUser": "Admin – Mulighet til å se alle brukernes kalenderavtaler",
        "adminAbilityViewAllCalendar": "Admin – Mulighet til å se alle brukernes kalenderavtaler",
        "adminsCanDeleteIntegrations": "Administratorer kan slette alle integrasjoner de ønsker, men brukere kan bare slette sine egne",
        "adminsCanSeeAllIntegrations": "Administratorer kan se alle integrasjoner, uavhengig av hvem som har opprettet dem, mens brukere kan se integrasjoner som de selv har opprettet",
        "contactDetailAppointments": "Kontaktdetaljer > Avtaler (ny)",
        "conversationsScheduleAppointment": "Samtaler > Planlegg avtale (ny)",
        "essentialConsiderations": "Viktige hensyn",
        "funnelsWebsitesCalendar": "Trakter/nettsteder > Kalender (ny)",
        "helpReorientTriggers": "I løpet av samtalen hjelper vi deg med å tilpasse utløserne til den nye kalenderkonfigurasjonen",
        "iAgreeMessage": "Hvis du er komfortabel med de ovennevnte endringene, kan du trykke på \"Jeg godtar\" og komme i gang med Kalendar (Beta) på denne underkontoen",
        "integrationNew": "Integrasjon (Ny)",
        "loseAbilityToViewEdit": "Brukere i den nye versjonen mister muligheten til å \"se/redigere\" avtaler (opprettet i den forrige versjonen) via modalvinduet Mulighetsdetaljer – men de kan fortsette å utføre alle disse handlingene på siden Avtaler",
        "newOldTriggersCoexist": "De nye og gamle utløserne vil eksistere side om side",
        "nonAdminAbilityViewPersonal": "Ikke-administrator – Mulighet til kun å se sine personlige avtaler (Tildelte data/kalendertilordning under TEAMLEDELSE har ingen innvirkning)",
        "nonAdminViewPersonalOnly": "Ikke-administrator – Mulighet til kun å se sine personlige avtaler",
        "notAtMoment": "Ikke for øyeblikket. Men vi jobber hardt for å gjøre den tilgjengelig på mobil så snart som mulig.",
        "oldAppointmentsCanBeViewed": "De gamle avtalene kan vises på avtalesiden via en vekslebryter.",
        "oldAppointmentsDisplayed": "Gamle avtaler vil bli vist sammen med de nye avtalene i den samme avtalelisten",
        "oldCalendarVersionAppointments": "Gammel kalenderversjon + gamle avtaler",
        "onlyNewCalendarWidget": "Bare ny kalender-widget kan legges til",
        "opportunityAddAppointment": "Mulighet > Legg til avtale (ny)",
        "profilePageAdmin": "Profilside for Admin (ny)",
        "profilePageAllUsers": "Profilside (alle brukere)",
        "providesAllOptions": "Har alle alternativer (grupper + tjenester) som er nødvendige for å konfigurere den nye kalenderen",
        "reintegratingConnectionsRequired": "Det kan være nødvendig å integrere alle tilkoblinger på nytt når Kalender Beta er aktivert for en underkonto",
        "roundRobinHighlight": "Muligheten til å fordele avtaler i rotasjonsordning mellom ulike grupper av agenter er det viktigste høydepunktet i denne oppdateringen.",
        "schedulingCalendarAppointments": "Planlegging > Kalender/avtaler (nye filtre + veksling mellom nye og gamle avtaler)",
        "settingsCalendarBeta": "Innstillinger > Kalender (Beta)",
        "surfacingFirstTime": "Avdekke den for første gang",
        "teamManagementAdminOnly": "Teamadministrasjon (kun tilgjengelig for administratorer)",
        "toggleOffNewVersion": "Deaktiver (ny versjon)",
        "toggleOnOldVersion": "Aktiver (gammel versjon)",
        "whatChangesWithNewVersion": "Hvilke endringer er det i den nye versjonen av kalenderen?",
        "whatDoesCalendarEntail": "Hva innebærer kalenderen (privat beta)?",
        "whatHappensToOldAppointments": "Hva skjer med de gamle avtalene våre etter overgangen?",
        "whatWillWeSeeMobile": "Hva vil vi se på mobilen under betaversjonen?",
        "willOldAppointmentsBeFactored": "Vil de gamle avtalene bli tatt med i beregningen når tilgjengeligheten for de nye avtalene beregnes?",
        "willOldCalendarUrlsWork": "Vil de gamle URL-adressene til kalenderen vår fortsette å fungere etter overgangen?",
        "willWeGetNewVersionMobile": "Vil vi få bruke den nye versjonen på mobil under betaversjonen?",
        "yesOldSettingsPageContinues": "Ja. Den gamle innstillingssiden vil faktisk fortsette å eksistere, og det samme gjelder muligheten til å gjøre endringer der. Den gamle og den nye kalenderwidgeten vil fungere uavhengig av hverandre, men likevel være i konstant synkronisering med hverandre for å sikre nøyaktig beregning av tilgjengeligheten din på tvers av de to systemene. For å unngå forvirring oppfordrer vi deg til å bruke de nye URL-adressene der det er mulig, slik at du slipper å overvåke to separate URL-adresser for de samme brukergruppene.",
        "yesSyncOnGoogleCalendar": "Ja, siden enveis synkronisering er aktivert, vil Google-kalenderen sørge for at utilgjengelige tidsluker blir blokkert."
      },
      "companyPlansModal": {
        "billedAnnually": "Faktureres årlig",
        "billedMonthly": "Faktureres månedlig",
        "changePlanFor": "Endre abonnement for {locationName}",
        "notAuthorized": "Du er ikke autorisert til å utføre denne handlingen. Bare byråbrukere/administrator og stedsadministrator kan utføre den.",
        "payAnnually": "Betal årlig",
        "payMonthly": "Betal månedlig"
      },
      "locationBillingHistory": {
        "billingHistory": "Faktureringshistorikk",
        "cardNo": "Kortnummer",
        "errorWhileFetchingInvoices": "Feil under henting av fakturaer, klikk for å prøve på nytt",
        "invoiceDescription": "Fakturabeskrivelse",
        "invoiceNo": "Fakturanr.",
        "noInvoices": "Ingen fakturaer",
        "refunded": "Refundert",
        "succeeded": "utført",
        "view": "VIS"
      },
      "locationWallet": {
        "autoRechargeWith": "Automatisk påfylling med",
        "balance": "Saldo:",
        "credits": "Kreditter",
        "seeTransactions": "Se transaksjoner",
        "whenBalanceLowerThan": "når saldoen er lavere enn"
      },
      "mailTransactionModal": {
        "checkYourEmail": "Sjekk e-posten din ({emails}).",
        "csvSentMessage": "Vi vil sende en CSV-fil til e-postadressen din. Det tar vanligvis 7-10 minutter.",
        "enterEmailAddress": "Skriv inn e-postadresse",
        "exportAndSendCsv": "Eksporter og send CSV",
        "exportTransactions": "Eksporter transaksjoner",
        "itUsuallyArrives": "Den kommer vanligvis innen 10 minutter.",
        "useCommasToSeparate": "Bruk komma for å skille flere e-poster fra hverandre."
      },
      "modifySubscription": {
        "cancelClientDescription": "Kanseller kundens abonnement og avslutt kontoen",
        "cancelDescription": "Kanseller abonnementet ditt og avslutt kontoen",
        "cancelImmediately": "Kanseller umiddelbart",
        "cancelNow": "Kanseller nå",
        "cancelSubscription": "Kanseller abonnement",
        "changedYourMind": "Har du ombestemt deg?",
        "changedYourMindClient": "Du kan gjenoppta kundens abonnement",
        "changedYourMindYou": "Du kan gjenoppta abonnementet ditt",
        "confirmByTyping": "Bekreft ved å skrive {text} nedenfor",
        "confirmCancellation": "Bekreft kansellering",
        "modifySubscription": "Endre abonnement",
        "modifyYourSubscription": "Endre abonnementet ditt",
        "resumeSubscription": "Gjenoppta abonnement",
        "subscriptionWillBeCancelledOn": "Dette vil planlegge at abonnementet ditt blir kansellert den {date}. Du kan når som helst gjenoppta abonnementet ved å avbryte den planlagte kanselleringen.",
        "subscriptionWillBeCancelledOnClient": "Dette vil planlegge at kundens abonnement blir kansellert den {date}. Du og kundene dine kan når som helst gjenoppta abonnementet ved å avbryte den planlagte kanselleringen.",
        "subscriptionWillBeCancelledOnDate": "Abonnementet ditt vil bli kansellert den {date}.",
        "subscriptionWillBeCancelledOnDateClient": "Din kundes abonnement vil bli kansellert den {date}.",
        "subscriptionWillBeResumed": "Abonnementet ditt gjenopptas, og du vil bli fakturert som normalt.",
        "subscriptionWillBeResumedClient": "Kundens abonnement vil bli gjenopptatt, og de vil bli fakturert som normalt.",
        "upgradeDescription": "Flytt til et høyere abonnement",
        "weAreGladYouStaying": "Vi er glade for at du blir værende.",
        "nextBillingDate": "Neste faktureringsdato: {date}",
        "cancelImmediatelyTitle": "Ønsker du virkelig å si opp abonnementet umiddelbart?",
        "cancelNowDescription": "Abonnementet ditt er planlagt å bli kansellert den {date}. Hvis du velger å avbryte nå, vil kontoen din, inkludert all utgående aktivitet som planlagte meldinger og e-post, bli stoppet umiddelbart.",
        "cancelNowDescriptionClient": "Kundes abonnement er planlagt å bli kansellert den {date}. Hvis du velger å avbryte nå, vil kundens konto, inkludert all utgående aktivitet som planlagte meldinger og e-post, bli stoppet umiddelbart.",
        "modifyDescription": "Du kan {action} abonnementet ditt",
        "modifyDescriptionClient": "Du kan {action} kundens abonnement"
      },
      "noPaymentMethodWarning": {
        "addNow": "Legg til nå",
        "youNeedToEnterCardInfo": "Du må oppgi kortinformasjonen din.",
        "youNeedToEnterClientCardInfo": "Du må oppgi kundens kortinformasjon."
      },
      "productRebilling": {
        "chargesBasedOnTokens": "Gebyrer er basert på token. Antall ord som vises nedenfor, er estimater for å hjelpe deg med å forstå bruken. Faktiske kostnader kan variere.",
        "examplePricingGpt4oMini": "Priseksempel – GPT-4o Mini",
        "for750kWords": "(for 750 000 ord) ",
        "gpt4oMini": " GPT-4o-mini ",
        "input": "Inndata",
        "or": "eller ",
        "output": "Utdata",
        "perImage": " / Bilde",
        "perResultSelection": " / Resultatvalg",
        "ratesMayDifferUK": "Prisene kan variere avhengig av regionen. Beregningene som vises er i henhold til priser for Storbritannia. Sjekk våre",
        "ratesMayDifferUS": "Prisene kan variere avhengig av region og type nummer. Beregninger vist i henhold til Twilio-priser for USA,",
        "pleaseCheckSupport": "sjekk vårt",
        "resultSelection": " Resultatvalg",
        "supportDoc": "rundskriv",
        "forMoreDetails": "for mer informasjon",
        "words": " ord"
      },
      "removePaymentMethod": {
        "endingIn": "Slutter på *{cardNo}",
        "no": "Nei",
        "removeCard": "Fjerne kortet?",
        "removing": "Sletter …",
        "yesRemove": "Ja, fjern"
      },
      "requestSaasModal": {
        "requestClientPaymentDetails": "Be om kundens betalingsdetaljer",
        "saasLocationDescription": "Sett opp et SaaS-abonnement for denne lokasjonen",
        "selectSpace": "Velg plass",
        "spaceDescription": "Velg hvor du ønsker å konfigurere fakturering for dette stedet"
      },
      "saasEnableProducts": {
        "disable": "Deaktiver",
        "enableDisableProducts": "Aktiver/deaktiver produkter",
        "feature": "Funksjon",
        "unsavedChanges": "Ulagrede endringer"
      },
      "saasSubscriptionPlan": {
        "agencyStripeFailed": "Neste fakturering for denne kunden ser ut til å være forfalt. Dette skjer når byråets Stripe-konto ikke fungerer som den skal. Logg inn på byråets stripe for å fikse det.",
        "copiedText": "kopiert tekst:",
        "couldNotCopy": "Async: Kunne ikke kopiere tekst: ",
        "multiplier": " X ",
        "nextBillingDatePrefix": " Neste faktureringsdato: ",
        "plan": "Abonnement",
        "pleaseContactAgency": "Ta kontakt med byrået for å aktivere abonnementet ditt.",
        "stripeSubscriptionId": "Abonnements-ID for Stripe:",
        "subscriptionPlans": "Abonnementstyper",
        "subscriptionWillBeCancelledOn": "Abonnementet ditt vil bli kansellert den {date}",
        "subscriptionWillBeCancelledOnClient": "Din kundes abonnement vil bli kansellert den {date}",
        "toModifyClientSubscription": "for å endre din kundes abonnement",
        "toModifyYourSubscription": "for å endre abonnementet ditt",
        "whatsappNumberSubscription": "WhatsApp-nummerabonnement",
        "yourBillingDatePast": "Neste faktureringsdato ser ut til å være i fortiden. Kontakt {email} for å fikse dette. I mellomtiden vil alt fortsette som vanlig."
      },
      "salesResources": {
        "certifiedUser": "Sertifisert bruker",
        "clearFilter": "Fjern filter",
        "dateRange": "Datoperiode"
      },
      "upgradePlanProcessedModal": {
        "paymentInfo": "Du betaler $ {amount} / måned fakturert {interval}",
        "planUpgradeFailed": "Abonnementet ditt kunne ikke oppgraderes.",
        "planUpgraded": "Abonnementet ditt har blitt oppgradert.",
        "retryUpgrade": "Prøv oppgraderingen på nytt",
        "upgradeFailed": "Kunne ikke oppdatere abonnementet ditt. Prøv igjen.",
        "upgradedSuccessfully": "Du har oppgradert abonnementet ditt fra {oldPlan} til {newPlan}"
      },
      "upgradePlanSelectionModal": {
        "billedAsMonthlyCharge": "fakturert som månedlig kostnad på {amount} /måned",
        "billedAsYearlyCharge": "fakturert som årlig kostnad på {amount} /år",
        "upgradeFrom": "Oppgrader fra",
        "whatYouWillGet": "Dette får du:"
      },
      "walletTransactionModal": {
        "balanceAfterTransaction": "Saldo etter transaksjon:",
        "callDuration": "Samtalevarighet:",
        "callSid": "Samtalens SID:",
        "charge": "Kostnad:",
        "contact": "Kontakt:",
        "contactName": "Kontaktnavn:",
        "contactPhone": "Kontakttelefon:",
        "credit": "Kreditt:",
        "creditsAfterTransaction": "Kreditt etter transaksjon:",
        "dateSent": "Sendt dato",
        "deleted": "<Deleted>",
        "discount": "Rabatt:",
        "eventId": "Hendelses-ID:",
        "from": "Fra:",
        "noContactFound": "Fant ingen kontakt",
        "noOfSegments": "Antall segmenter:",
        "openContactPage": "Åpne kontaktside",
        "openConversation": "Åpne samtale",
        "openEvent": "Åpen hendelse",
        "originalCharge": "Opprinnelig pris:",
        "received": "Mottatt",
        "smsSid": "SMS SID:",
        "timeBilled": "Fakturatid:",
        "timeOfCall": "Tidspunkt for telefonsamtale",
        "transactionDetails": "Transaksjonsdetaljer –",
        "transactionId": "Transaksjons-ID:",
        "type": "Type:",
        "segments": "Segmenter"
      },
      "calendarSettings": {
        "meetings": "Møter",
        "services": "Tjenester",
        "hideCalendarWarning": "Hvis du vil skjule kalendermodulen helt, gjør du det fra underkontoinnstillingene > mine ansatte > roller og tillatelser",
        "calendarSettingsUpdated": "Kalenderinnstillingene er oppdatert",
        "meetingDescription": "Aktiver dette alternativet for å gi underkontoer mulighet til å bruke Møter-funksjonen, som er utformet for å administrere salgskalendere, onboarding-samtaler, rotasjonsplanlegging, gruppesamarbeid, klassebestillinger, intervjuer og mer. Perfekt for bedrifter som trenger fleksible og samarbeidsorienterte planleggingsverktøy.",
        "serviceDescription": "Aktiver Tjenester for å gi underkontoer tilgang til en fullstendig bestillingsløsning for tjenestebaserte bedrifter. Dette inkluderer å opprette bestillingssider med flere tjenester, administrere ressurser, håndtere flere lokasjoner, angi personalspesifikk prissetting, legge til tjenestevariasjoner eller tillegg, og mer."
      }
    },
    "apiKeys": {
      "apiKey": "ApiKey",
      "copied": "Kopiert.",
      "copyApiKey": "Kopier Api-nøkkel",
      "createApiKey": "Opprett API-nøkkel",
      "deleteAllKeys": "Slette alle nøkler",
      "nameRequired": "Navnefeltet er påkrevd.",
      "somethingWentWrong": "Oops! Noe gikk galt. Prøv igjen.",
      "updatedSuccessfully": "Oppdatert"
    },
    "billing": {
      "accountPaused": "Kontoen din {name} har blitt satt på pause.",
      "accountProvisioned": "Kontoen din blir klargjort.",
      "activateSubAccount": "Aktiver underkonto",
      "activeServices": "Aktive tjenester",
      "addNewCard": "Legg til nytt kort",
      "addNewService": "Legg til ny tjeneste",
      "addPaymentMethod": "legg til en betalingsmetode",
      "alertIcon": "alertIcon",
      "approve": "Godkjenn",
      "authenticateCardMessage": "For ekstra sikkerhet må du autentisere kortopplysningene dine på nytt.",
      "badActorWarning": "Hvis du tror at denne underkontoen er opprettet av en ondsinnet aktør, anbefaler vi at du sletter denne underkontoen og avslutter det tilhørende abonnementet.",
      "callUs": "Ring oss",
      "cancelAndDelete": "Avbryt abonnement og slett underkonto",
      "completeFormNextStep": "Fullfør Skjemaet på neste trinn",
      "congratulations": "🎉 Gratulerer! 🎉",
      "contactAgency": "Ta kontakt med byrået ditt for å løse dette problemet",
      "contactThroughEmailOrPhone": "Du kan enten kontakte oss via e-post eller telefon for å løse dette",
      "dataSafe": "Alle dataene dine er trygge, og alle automatiseringer, nettsider osv. vil fortsette å fungere etter vellykket betaling.",
      "declineSubAccount": "Avslå underkontoen",
      "deleteRecommendation": "Det anbefales å slette denne underkontoen. Eller du kan gjøre det senere fra Underkontoer > Administrer kunde-siden.",
      "emailUsAt": "Send oss en e-post på",
      "moveToDashboard": "Flytt til dashbordet",
      "noPaymentMethods": "Det ser ut til at ingen betalingsmetoder er lagt til! Vennligst",
      "paymentMethod": "Betalingsmetode",
      "paymentMethodUpdated": "Din betalingsmetode har blitt oppdatert",
      "paymentNotCompleted": "Du ser denne meldingen fordi betalingen ikke ble fullført.",
      "proceedToNextStep": "Fortsette til neste trinn",
      "questionMark": "?",
      "reachOutMessage": "ta kontakt med oss hvis du har spørsmål.",
      "reactivateBillingFor": "Reaktiver fakturering for {location}",
      "retryPayment": "Prøv betaling på nytt",
      "secureSystemMessage": "Vi har gått over til et sikrere faktureringssystem.",
      "setupMessage": "Noen vil kontakte deg for å opprette kontoen. Det tar vanligvis 12–24 timer,",
      "signout": "Logg ut",
      "subAccountId": "Underkonto-ID:",
      "successfullyInitiated": "{product} har blitt initiert",
      "systemError": "Det har oppstått en systemfeil",
      "toReactivate": "for å reaktivere kontoen",
      "userImage": "userImage",
      "verificationSkipped": "E-post- og telefonbekreftelsen hoppes over for denne underkontoen, og kunden vil kunne få tilgang til den.",
      "verifyAccount": "Verifiser konto",
      "verifyAfterAttempt": "Du kan verifisere denne kontoen etter minst ett verifiseringsforsøk fra en underkontoadministrator",
      "verifySubAccount": "Verifiser underkontoen",
      "recommendedPlans": "Anbefalte abonnementer",
      "buildYourOwnPlan": "BYGG DIN EGEN PLAN",
      "resetToDefaults": "Tilbakestill til standardinnstillinger",
      "paymentMethodChange": "Hvis du må å endre betalingsmetode",
      "approveSubAccount": "Godkjenn underkontoen",
      "approveSubAccountDescription": "Underkontoen vil bli gjenopprettet, og underkontoadministratorene vil kunne få tilgang til og bruke den.",
      "productInitiated": "Produkt initialisert"
    },
    "deleteConfirmation": {
      "actionCannotBeReversed": "Denne handlingen kan ikke reverseres.",
      "cancelKeep": "Avbryt, behold det",
      "confirmDeletionInstructions": "Bekreft slettingen ved å skrive {word} nedenfor:",
      "enterConfirm": "Skriv inn {word} for å regenerere",
      "message": "Denne lokasjonens API-nøkkel vil bli slettet.",
      "title": "Slett api-nøkkel for plasseringen?",
      "yesDelete": "Ja, slett det"
    },
    "generalDetails": {
      "noPermission": "Du har ikke tillatelse til å laste opp fil. Sjekk tillatelser med byråadministratoren din.",
      "relatedContacts": "Relaterte kontakter ({count})"
    },
    "locationApiKeys": {
      "deleteAllConfirmMessage": "Er du sikker på at du vil slette alle api-nøklene for plasseringene?",
      "deleteAllConfirmTitle": "Slette alle API-nøkler for plasseringen?",
      "deleteConfirmMessage": "Dette vil slette api-nøkkelen for plasseringen: {location}. Ønsker du å fortsette?",
      "deleteAgencyApiKeyConfirmMessage": "Dette vil slette API-nøkkelen. Ønsker du å fortsette?",
      "fetchingLocations": "Henter steder ...",
      "maxApiKeysMessage": "Du kan ha maksimalt 5 API-nøkler.",
      "noLocationsFound": "Fant ingen steder",
      "old": "Gammel",
      "proPlanRequiredMessage": "Dette er en del av det avanserte API-et som er tilgjengelig i Pro-abonnementet.",
      "searchLocation": "Søke etter sted",
      "title": "API-nøkkel for lokasjon"
    },
    "locationCard": {
      "deletionScheduledMessage": "Denne underkontoen vil bli slettet på {date}, hvis du har ombestemt deg –",
      "emailUsageNotRebilled": "E-postbruk blir ikke fakturert på nytt",
      "emailUsageRebilled": "E-postbruken faktureres videre til kunden din",
      "listings": "Oppføringer",
      "manageClient": "Administrere kunde",
      "paymentPending": "Betaling er avventende",
      "remainingWalletBalance": "Gjenværende lommeboksaldo for dette SaaS-stedet",
      "requestPaymentAgain": "Be om utbetaling igjen",
      "saasModeActivated": "SaaS-modus er aktivert",
      "saasModeNotActivated": "SaaS-modus er ikke aktivert",
      "saasSubscriptionNotEnabled": "SaaS-abonnement er ikke aktivert",
      "saasSubscriptionRunning": "SaaS-abonnement er gjeldende",
      "social": "Sosiale medier",
      "switchToSaaS": "Bytt til SaaS",
      "switchToSubAccount": "Bytt til underkonto",
      "telephoneUsageNotBilled": "Telefonbruk blir ikke fakturert",
      "telephoneUsageRebilled": "Telefonbruken gjenfaktureres til kunden din",
      "wordpressActive": "Wordpress aktiv",
      "wordpressInactive": "WordPress inaktiv",
      "wordpressNotSoldYet": "WordPress er ikke solgt ennå",
      "wordpressSaleSuccessful": "WordPress-salget er utført",
      "yextActive": "Yext aktiv",
      "yextInactive": "Yext inaktiv",
      "yextNotSoldYet": "Yext er ikke solgt ennå",
      "yextSaleSuccessful": "Yext-salget er utført",
      "reviews": "Vurderinger"
    },
    "messageUsage": {
      "acceptTnc": "Aksepter bruksvilkår",
      "cannotPerformAction": "Kan ikke utføre denne handlingen. Ta kontakt med kundestøtte.",
      "currentLimit": "Nåværende grense",
      "days": "Dag(er)",
      "failedToUpdate": "Kunne ikke oppdatere meldingsbruk",
      "helpCentre": "Hjelpesenter",
      "increaseLimitFurther": "Øke grensen ytterligere",
      "increaseLimitNow": "Øk grensen nå",
      "lessThanUsage": "Nåværende bruk er {usage}, og valgt bruk er mindre enn nåværende bruk.",
      "lessThanUsageModal": "Nåværende bruk er {usage}, grensen kan ikke være mindre enn den nåværende bruken",
      "limitAlreadyUnlocked": "Begrensning er allerede låst opp",
      "limitReached": "Grensen er nådd",
      "limitUpdatedFrom": "Grensen for {type} er oppdatert fra {old} til {new}",
      "lookingForSmsLimit": "Leter du etter SMS-grensen?",
      "minLimitShould": "Minstegrense bør være {limit}",
      "newLimit": "Ny grense for {type}",
      "perDay": "/ Dag",
      "sameLimit": "Valgt grense er den samme som den nåværende grensen!",
      "smsLimitLocation": "SMS-grense kan nå finnes på underkontonivå",
      "smsLimitSettingsInfo": "Du finner nå disse innstillingene under \"Meldingsgrense\" i \"Avanserte innstillinger\"",
      "timesInLast30Days": "Antall ganger i siste måned",
      "todaysUsage": "Dagens bruk",
      "typePerDay": "{type} / dag",
      "updateLimit": "Oppdatere grense",
      "updateLimitFor": "Oppdater {type}-grense for {name}"
    },
    "prospectDetails": {
      "activeCampaignsWorkflows": "Aktive {type}",
      "contactSource": "Kontaktkilde",
      "customer": "Kunde",
      "noPastCampaignsWorkflows": "Ingen tidligere {type}",
      "pastCampaignsWorkflows": "Tidligere {type}"
    },
    "settings": {
      "affiliateSettings": "Innstillinger for partnere",
      "agencyBilling": "Fakturering for byrået",
      "agencyTeamManagement": "Ledelse av byrået",
      "apiKeys": "API-nøkler",
      "compliance": "Overholdelse",
      "customMenuLink": "Tilpasset menylenke",
      "launchpadSettings": "Launchpad-innstillinger",
      "phoneSystemTwilio": "Telefonsystem – Twilio",
      "smtpService": "SMTP-tjeneste",
      "userSettings": "Brukerinnstillinger",
      "agencySettings": "Byråinnstillinger",
      "mailgun": "MailGun"
    },
    "snapshot": {
      "errorCreating": "Feil under oppretting av øyeblikksbilde",
      "pickAnAccount": "Du må velge en konto.",
      "snapshotName": "Navn på øyeblikksbilde",
      "snapshotNameRequired": "Du må gi øyeblikksbildet et navn."
    },
    "socialDetails": {
      "blogRss": "Blogg-RSS",
      "foursquare": "Foursquare",
      "foursquareUrl": "Foursquare-URL",
      "googlePlacesId": "Google Places-ID",
      "googlePlus": "Google+",
      "googlePlusUrl": "Google+-URL",
      "instagramUrl": "Instagram-URL",
      "linkedInUrl": "LinkedIn-URL",
      "pinterest": "Pinterest",
      "pinterestUrl": "Pintrest URL",
      "yelp": "Yelp",
      "yelpUrl": "Yelp-URL",
      "youTube": "YouTube"
    },
    "requestSms": "Forespørsel via SMS",
    "iAlreadyHaveACustomer": "Jeg har allerede en kunde",
    "noAccountFound": "Ingen konto funnet!",
    "thisIs": "Dette er",
    "pleaseEnterValueBetween0To30Days": "Angi en verdi mellom 0 og 30 dager",
    "learnHowToAddOneTimeSetupFeeToThesePlans": "Finn ut hvordan du legger til en engangsavgift for oppsett av disse abonnementene",
    "doNotDeleteStripeProductsWarning": "<span style=\"font-weight: bold;\">Ikke slett</span> disse produktene i Stripe-kontoen din",
    "opportunityStats": "Mulighetsstatistikk",
    "createNewSnapshot": "Opprett et nytt øyeblikksbilde",
    "stripeSettings": {
      "agencyDashboardVisibleTo": "Byrå-dashbord synlig for",
      "onlyMe": "Bare meg",
      "allAgencyAdmins": "Alle byråadministratorer",
      "stripeConnect": "Vil snart bli avviklet. Bytt til Stripe Connect",
      "recommendStripe": "Vi anbefaler å bruke Stripe Connect for bedre sikkerhet",
      "switchToStripeConnect": "Bytt til Stripe Connect",
      "highLevelAccess": "HighLevel vil ha tilgang til dataene dine, og kan opprette betalinger og kunder på dine vegne",
      "stripeAccountWarning": "Når Stripe-kontoen er koblet til, kan den ikke endres senere. Vi anbefaler å bruke en ny Stripe-konto dedikert til Highlevel-inntekter.",
      "connectToStripeAccount": "Koble til Stripe-kontoen deres",
      "unverified": "Stripe-kontoen som er koblet til dette byrået er ubekreftet og kan ikke ta imot betalinger. Fullfør verifiseringen ved å logge på Stripe-kontoen.",
      "loginToStripe": "Logg inn på Stripe",
      "connectedAccount": "Tilkoblet konto",
      "verified": "VERIFISERT",
      "totalPendingBalance": "Totalt utestående saldo",
      "disconnectStripe": "Koble fra Stripe",
      "removeSaasPlanConfigurations": "Fjerne alle SaaS-abonnementskonfigurasjoner?",
      "haveSaasPlans": "Du har SaaS-abonnementer som er opprettet i Stripe-kontoen.",
      "disconnectWarning": "Hvis du kobler det fra, vil alle SaaS-abonnementer gå tapt, og du må opprette dem på nytt.",
      "acknowledgeDisconnect": "Jeg erkjenner at alle mine SaaS-abonnementer vil gå tapt, og jeg må lage dem på nytt",
      "disconnect": "Koble fra"
    },
    "zoomSuccess": {
      "title": "Håper du hadde en flott opplevelse!",
      "message": "Takk for at du er med på samtalen. Vi ser frem til å ha deg med igjen!"
    },
    "supportDashboard": {
      "trialExperienceSpecialist": "Din prøveopplevelsesspesialist",
      "successSpecialist": "Din suksesspesialist",
      "supportSpecialist": "Din kundestøttespesialist",
      "jumpOnZoomCall": "Bli med på en Zoom-samtale med meg for en oppstartssamtale",
      "jumpOnChat": "Bli med på en chat med meg for å få hjelp",
      "joinVideoCallNow": "Bli med på videosamtale nå",
      "whatToExpect": "Hva kan du forvente?",
      "helpArticles": "Hjelpeartikler",
      "changelog": "Endringslogg",
      "ideasBoard": "Idétavle"
    },
    "saasDashboard": {
      "title": "SaaS-dashbord",
      "plansAndPricing": "Abonnementer og priser"
    },
    "listAccounts": {
      "newInterfaceAvailable": "Denne siden har nå fått et ryddigere og raskere grensesnitt. Test den ut!",
      "enableInLabs": "Aktiver i Labs",
      "pendingTransferRequests": "Du har ventende forespørsler om overføring av underkonto.",
      "otherAgenciesRequested": "Andre byråer har bedt om å overføre underkontoer til deg.",
      "reviewRequests": "Gjennomgå forespørsler",
      "clientList": "Kundeliste (underkontoer)",
      "subAccountTransfers": "Overføringer av underkontoer"
    },
    "implementationModal": {
      "title": "Din HighLevel Video-samtaleopplevelse starter snart!",
      "videoCall": "Videosamtale",
      "whatsNext": "Hva skjer etterpå?",
      "enteringLobby": "Du vil gå inn i lobbyen vår sammen med andre Highlevelers som deg!",
      "successConcierge": "Vår suksessconcierge vil hilse på deg og koble deg til den neste tilgjengelige rådgiveren for en 1:1-økt.",
      "haveReady": "Ha følgende klart",
      "stableInternet": "Stabil Internett-forbindelse.",
      "videoNameMatches": "Videonavnet ditt samsvarer med HighLevel-brukernavnet ditt.",
      "estimatedDuration": "Anslått øktvarighet",
      "firstVisit": "Første besøk: HighLevel onboarding-økt: (45–60 minutter).",
      "returning": "Senere besøk: Fortsatt hjelp med implementeringsoppsett (15–25 minutter).",
      "meetingBegins": "Møtet ditt starter automatisk om <span class=\"text-[#155EEF]\">{ countdown } sekunder.</span>  Eller du kan bli med umiddelbart ved å klikke på knappen nedenfor:",
      "joinNow": "Bli med nå"
    },
    "gdpr": {
      "logo": "GDPR-logo",
      "dataProtection": "Personvern og GDPR",
      "introduction": "Introduksjon",
      "intro1": "HighLevel er forpliktet til å beskytte personvernet til våre brukere og deres kunder. Vi holder oss oppdatert på utviklinger i personvernlovgivningen for å sikre at du kan føle deg trygg når du bruker plattformen vår.",
      "intro2": "Denne siden er ment å forklare hva reglene er, hvordan de gjelder for din bruk av HighLevel-plattformen, og hvilke tiltak vi har iverksatt for å overholde dem.",
      "intro3": " Du bør lese gjennom dette dokumentet sammen med personvernerklæringen vår og kontakte en jurist hvis du trenger mer informasjon eller råd.",
      "gdprRegulation": "Personvernforordningen (GDPR)",
      "regulation1": "Forordning (EU) 2016/679, bedre kjent som personvernforordningen (GDPR), er en EU-forordning som har som mål å harmonisere datavern og personvernlovgivningen i hele EU. Bestemmelsene i personvernforordningen (GDPR) gjelder overalt der personopplysninger om en registrert i EU er involvert.",
      "regulation2": "GDPR fokuserer på å gi enkeltpersoner mer kontroll over hvordan opplysningene deres brukes av bedrifter samt gjøre innsamling og behandling av data mer transparent.",
      "regulation3": "Personvernforordningen (GDPR) ble innlemmet direkte i britisk lov etter utløpet av overgangsperioden for Brexit, noe som betyr at britiske virksomheter fortsatt må overholde bestemmelsene i forordningen gjennom \"UK GDPR\".",
      "basicConcepts": "Grunnleggende GDPR-konsepter",
      "controllerAndProcessor": "Behandlingsansvarlig og databehandler",
      "controllerProcessorObligation": "GDPR pålegger en person ulike forpliktelser avhengig av om vedkommende er behandlingsansvarlig eller databehandler.",
      "controllerDefinition": " En behandlingsansvarlig er en enhet som bestemmer seg for å behandle personopplysninger, og som tar beslutninger om grunnlaget for behandlingen og hvilke metoder som skal brukes. Behandlingsansvarlige har visse plikter når det gjelder personopplysninger, som du bør sette deg inn i før du samler inn personopplysninger fra kundene dine.",
      "processorDefinition": "En databehandler er en enhet som behandler opplysninger for og på vegne av en behandlingsansvarlig. De tar ingen selvstendige beslutninger om opplysningene eller behandlingen av dem, ettersom de kun behandler dem på vegne av den behandlingsansvarlige og må følge alle instruksjoner fra den behandlingsansvarlige.",
      "youAreController": "Når du bruker HighLevel-tjenesten, er du en behandlingsansvarlig. Du har kontroll over hvilke opplysninger du laster opp til HighLevel-systemet, hva du gjør med dem og hvorfor. Du er derfor ansvarlig for å sikre at du har et rettslig grunnlag for å behandle opplysningene, og at du ikke oppbevarer opplysningene lenger enn nødvendig.",
      "highlevelIsProcessor": "Du bør sørge for at du forstår dine forpliktelser som behandlingsansvarlig, og oppdatere dine egne systemer og retningslinjer for å tillate lovlig overføring av personopplysninger til HighLevel. HighLevel er en databehandler. Vi, gjennom HighLevel-plattformen, lagrer og administrerer dataene du har samlet inn etter dine instruksjoner. Vi vil aldri bruke personopplysninger som du har lastet opp til HighLevel-systemet til våre egne formål eller uten din instruksjon.",
      "legalBasisForProcessing": "Rettslig grunnlag for behandling",
      "legalBasisRequirement": "Personopplysninger kan bare samles inn og behandles hvis det finnes et rettslig grunnlag for å gjøre det. De tillatte rettslige grunnlagene er beskrevet i personvernforordningen (GDPR).",
      "processorReliesOnCustomers": "Som databehandler er HighLevel avhengig av at kundene våre velger riktig grunnlag for innsamling og behandling av personopplysninger, og at de sørger for å ha de nødvendige varslene og samtykkene på plass. Før du bruker HighLevel-tjenesten, bør du ta deg tid til å identifisere hvilket rettslig grunnlag som kan være tilgjengelig for deg, og bare samle inn og beholde personopplysninger i den grad det er nødvendig for å utføre det aktuelle grunnlaget. Du bør ikke endre grunnlaget du har samlet inn personopplysninger på uten svært god grunn, så det er viktig å sette seg inn i kravene til de ulike grunnlagene og sørge for at du velger det riktige fra starten av.",
      "dataSubjectAccessRights": "Den registrertes tilgangsrettigheter",
      "dataSubjectRights": "GDPR gir de registrerte (dvs. dine kunder) visse rettigheter knyttet til personopplysningene deres, inkludert retten til å få tilgang til, korrigere og/eller slette alle opplysninger om dem.",
      "highlevelEasySystems": "HighLevel har innført enkle systemer slik at du kan informere oss hvis du mottar en slik forespørsel fra en registrert person, og for at vi skal kunne informere deg dersom vi mottar en slik forespørsel. Vi vil sørge for at disse forespørslene etterkommes umiddelbart, i tråd med dine instruksjoner. Du bør gjøre deg kjent med forpliktelsene som vil bli pålagt deg, inkludert de som gjelder personopplysninger du har i dine egne systemer eller tjenester andre enn HighLevel.",
      "transfersToUSA": "Overføring av data til USA",
      "transfersRestrictions": "Personopplysninger kan ikke overføres til land utenfor EØS annet enn under spesifikke omstendigheter. Vi bruker standardkontraktsklausulene som en del av databehandlingsavtalen vår, som vi inngår med alle kundene våre.",
      "dataSecurity": "Datasikkerhet",
      "securitySafeguards": "Vi har innført strenge sikkerhetstiltak og -tiltak for å sikre at alle personopplysninger vi har, lagres trygt. Vi tester produktene våre regelmessig for å avdekke feil og sårbarheter.",
      "backupSystems": "Vi sørger for at vi har regelmessige sikkerhetskopieringssystemer på plass, og at vi har systemer og prosesser for datagjenoppretting og dataintegritet for å minimere risikoen for ødeleggelse eller tap av personopplysninger.",
      "stepsForCompliance": "Tiltak vi har iverksatt for å sikre overholdelse av GDPR",
      "dutyAsProcessor": "Vi tar våre plikter som databehandler svært alvorlig. Vi har innført en rekke prosedyrer og tatt en rekke skritt for å sikre at vi overholder GDPR og at du lovlig kan sende oss personopplysninger som du har samlet inn, for eksempel:",
      "standardContractualClauses": "Databehandlingsavtalen vår bruker standardkontraktsklausulene for å sikre at du lovlig kan sende personopplysninger til oss i USA.",
      "detectBreaches": "Vi er i stand til å oppdage personlige brudd og informere våre kunder så snart som mulig.",
      "dealWithAccessRequests": "Vi er i stand til å håndtere forespørsler om innsyn i personopplysninger og forespørsler om sletting, og sikre at vi informerer deg når en registrert har sendt en slik forespørsel til oss.",
      "assessedDocumented": "Vi har vurdert og dokumentert personopplysningene vi behandler på dine vegne.",
      "assessedSecurity": "Vi har vurdert sikkerheten vår og oppgradert den der det har vært nødvendig for å sikre at den passer risikonivået vi står overfor i forbindelse med brudd på datasikkerheten.",
      "dataProcessingAgreement": "Databehandlingsavtale",
      "dateUpdated": "Dato oppdatert: 01. april 2023",
      "downloadAgreement": "Last ned avtale",
      "supportEmail": "support{'@'}gohighlevel.com",
      "anyQuestions": "Har du noen spørsmål?"
    },
    "sendGridSettings": {
      "title": "SendGrid-innstillinger",
      "settingsForLocations": "SendGrid-innstillinger for underkontoer",
      "sendGrid": "SendGrid",
      "last12Months": "Siste 12 måneder",
      "totalSent": "Totalt sendt",
      "opens": "Åpninger",
      "clicks": "Klikk",
      "bounces": "Avvisninger"
    },
    "launchpadSettings": {
      "disableLaunchpad": "Deaktiver Launchpad for alle mine underkontoer.",
      "description1": "Launchpad er en gjennomtenkt landingsside som har vist seg å øke kundetilfredshet og -lojalitet ved å øke bruken av produktet. ",
      "description2": "Tilkobling av GMB, FB, webchat-plugin, bruk av mobilapp osv. har vist seg å være gode funksjoner som holder på kundene lenger.",
      "confirmDisable": "Er du sikker på at du vil deaktivere Launchpad?"
    },
    "affiliateSettings": {
      "affiliateLinkDescription": "Dette er din partnerlenke. Bruk denne lenken til å la folk du kjenner registrere en konto, og du vil motta 40 % av deres månedlige gjentakende inntekter for livet.",
      "appendToUrls": "Legg dette til slutten av URL-ene dine:",
      "needToSignUp": "Trenger du å registrere deg?",
      "goToUrl": "Gå til URL-en:",
      "andSignUpUsing": "og registrer deg ved å bruke e-postadressen",
      "asYourEmailAddress": "som e-postadresse for FirstPromoter.",
      "pageSettings": "Innstillinger for siden",
      "facebookPixelId": "Facebook Pixel ID",
      "pixelId": "Pixel ID"
    },
    "agencyAPIKeySettings": {
      "enhancedAccountSecurity": "Fra og med 17. juni 2024, vil utvidet kontosikkerhet bli automatisk aktivert på kontoen din som standard. De forbedrede sikkerhetstiltakene inkluderer:",
      "discontinuationOfAutoGeneration": "Avvikling av automatisk generering av API-nøkler for sted",
      "exclusionOfApiKeysInLocationCrudApis": "Ekskludering av API-nøkler i API-er for steds-CRUD",
      "optOutLink": "For å velge bort denne endringen, deaktiver forbedret kontosikkerhet i <a href=\"/settings/company\">Innstillinger &gt; Bedrift</a>",
      "advancedFunctionalityNote": "Denne API-en er for avansert funksjonalitet. Supportteamet vårt kan ikke gi direkte hjelp med API-konfigurasjonen.",
      "developerCouncilInfo": "Vi har et utviklerråd som møtes en gang i måneden i kontortiden (<a href=\"https://gohighlevel.com/events\">https://gohighlevel.com/events</a>), og en Slack-kanal for utviklerfellesskapet der du kan få hjelp fra fellesskapet og API-teamet vårt. (<a href=\"https://www.gohighlevel.com/dev-slack\">https://www.gohighlevel.com/dev-slack</a>)",
      "zapierNote": "For å bruke zapier må du bruke API-nøkkelen for den spesifikke plasseringen. Du kan finne den fra listen nedenfor eller ved å bytte til kontoen ved hjelp av bryteren i menyen til venstre.",
      "partOfAdvancedApi": "Dette er en del av det avanserte API-et som er tilgjengelig i Pro-abonnementet.",
      "upgradeMessage": "Dette er en del av det avanserte API-et som er tilgjengelig i Pro-abonnementet. <a>Klikk her</a> for å oppgradere."
    },
    "accountMap": {
      "addAccountManually": "Legg til konto manuelt"
    },
    "accountTeamsManagement": {
      "settingsAsGroups": "Innstillinger som grupper."
    },
    "accountDetails": {
      "basicDetails": "Grunnleggende detaljer",
      "saas": "SaaS",
      "rebilling": "Omfakturering",
      "marketplaceApps": "Marketplace-apper",
      "advancedEmailSettings": "Avanserte innstillinger",
      "calendarSettings": "Kalenderinnstillinger"
    },
    "advancedEmailSettings": {
      "controlLocationSettings": "Kontroller plasseringsinnstillingene",
      "disableAddEmailService": "Deaktiver knappen Legg til e-posttjeneste i underkontoen Innstillinger for e-posttjenester",
      "disableAddSmtp": "Deaktiver knappen Legg til e-posttjeneste i underkontoen Innstillinger for e-posttjenester",
      "restrictSubAccountEmailProvider": "Begrens underkontobrukere fra å legge til sin egen e-postleverandør",
      "disableAddSmtpDescription": "Begrens underkontobrukere fra å legge til sin egen e-postleverandør",
      "enableReVerification": "Aktiver re-verifisering i 90 dager",
      "locationNoLeadConnector": "Plasseringen har ikke LeadConnector som standard e-postleverandør",
      "lcEmailNotEnabled": "Plasseringen har ikke LeadConnector som standard e-postleverandør",
      "onlyForAgency": "Du kan bare se disse innstillingene aktivert for byrået",
      "onlyVisibleForAgency": "Du kan bare se disse innstillingene aktivert for byrået",
      "reVerificationDescription": "Hver e-postbekreftelsesstatus oppheves etter 90 dager (beskytt avsenderens omdømme og sørg for høyest mulig leveringsevne i innboksen)"
    }
  },
  "attributes": {
    "addAttribute": "Legg til attributt",
    "attributeName": "Attributtnavn",
    "enterAttributeName": "Skriv inn attributtnavn",
    "number": "Nummer",
    "selectAttributeType": "Velg attributtype"
  },
  "audit": {
    "changeModal": {
      "additionalMetaData": "Ytterligere metadata",
      "title": "Lagt til / oppdatert felt"
    }
  },
  "bulkActions": {
    "additionalDetails": "Ytterligere detaljer",
    "allOnGivenDate": "Alle på en gitt dato",
    "attempted": "Forsøkt",
    "batchQuantity": "Antall per bulk",
    "bulkActionProcessing": "Behandling av massehandlinger",
    "bulkActionTitle": "Bulk-handling",
    "campaignRequired": "Kampanje er påkrevd",
    "currentStatus": "Nåværende status",
    "delayBetweenBatches": "Forsinkelse mellom bulker",
    "dispatchMode": "Utsendelsesmodus: {mode}",
    "editBatchQuantity": "Rediger bulkantall",
    "emailStats": "E-poststatistikk",
    "enterBatchSprintLimit": "Angi en sprint-grense for bulk",
    "hideStats": "Skjul statistikk",
    "mode": "Modus",
    "nextProcessingOn": "Neste behandling på",
    "noStatsFound": "Ingen statistikk ble funnet",
    "parentBulkActionID": "Overordnet massehandlings-ID",
    "pleaseEnterQuantity": "Oppgi antall",
    "processAllAsSoonAsPossible": "Behandle alt så fort som mulig",
    "processAllOnGivenDate": "Behandle alt på gitt dato",
    "processDuring": "Behandle under",
    "processGraduallyDrip": "Behandle gradvis (drypp)",
    "processingAllowedOn": "Behandling tillatt på",
    "restoredBulkActionId": "Gjenopprettet massehandlings-ID:",
    "revert": "Tilbakestill",
    "revertedBulkActionId": "Tilbakestilt massehandlings-ID:",
    "saveChanges": "Lagre endringer",
    "scheduledStart": "Planlagt start",
    "showErrorLog": "Vis feillogg",
    "showImported": "Vis importert",
    "showStats": "Vis statistikk",
    "skipped": "Hoppet over",
    "statistics": "Statistikk",
    "statuses": {
      "complete": "Fullstendig",
      "next-drip": "Neste drypp",
      "notStarted": "Ikke startet",
      "processing": "Under behandling",
      "queueing": "I kø",
      "reading": "Leser",
      "resumed": "Gjenopptatt",
      "reverted": "tilbakestilt",
      "waiting": "Venter"
    },
    "successful": "Utført",
    "tagsAdded": "Tagger lagt til",
    "tagsRemoved": "Tagger fjernet",
    "tagsRestored": "Tagger gjenopprettet",
    "timeElapsed": "Tid forløpt",
    "totalExported": "Totalt eksportert",
    "totalMerge": "Totalt slått sammen",
    "unknownError": "Ukjent feil",
    "updateBatchQuantity": "Oppdater bulkantall",
    "updated": "Oppdatert",
    "usesDynamicList": "** Bruker dynamisk liste",
    "workflowRequired": "Arbeidsflyt er påkrevd"
  },
  "business": {
    "addedToCompany": "Kontakt(er) er lagt til bedriften",
    "cantAddMoreContacts": "Kan ikke legge til mer enn 50 kontakter om gangen",
    "cleanerUi": "Ryddigere brukergrensesnitt",
    "common": {
      "addContact": "Legg til kontakt",
      "internalServerError": "Intern serverfeil",
      "to": "til"
    },
    "companiesNowHave": "Bedrifter har nå",
    "companyNoteLabsText": "Bedriftsnotater er en Labs-funksjon",
    "contactRemoveCompany": "Er du sikker på at du vil fjerne denne kontakten fra bedriften?",
    "moreFunctionalUx": "Flere funksjonelle brukeropplevelser",
    "newCompanyUpdate": "Ny oppdatering fra bedriften!",
    "tabs": "Faner",
    "tasks": {
      "assignTask": "Tilordne oppgave",
      "assignee": "Mottaker",
      "deleteTask": "Slett oppgave",
      "editTask": "Rediger oppgave",
      "markAsComplete": "Merk som fullført",
      "markAsPending": "Merk som ventende",
      "nameAndDescription": "Navn og beskrivelse",
      "noTasksAvailable": "Ingen aktiviteter tilgjengelig"
    },
    "visitLabs": "Gå til Labs"
  },
  "calendar": {
    "googleCalendar": "Google Kalender",
    "noSync": "Ingen synkronisering",
    "outlookCalendar": "Outlook-kalender"
  },
  "common": {
    "topBar": {
      "toggleFrontendDebugger": "Veksle frontend-feilsøker"
    },
    "icons": {
      "star": ""
    },
    "errorOccurred": "Det oppstod en feil, prøv igjen",
    "tabs": "Faner",
    "showPassword": "Vis passord",
    "hidePassword": "Skjul passord",
    "goToHomepage": "Gå til startsiden",
    "leadConnectorHqLogo": "Lead Connector HQ logo",
    "companyLogo": "Firmalogo",
    "countries": {
      "australia": "Australia",
      "austria": "Østerrike",
      "czechRepublic": "Tsjekkia",
      "belgium": "Belgia",
      "brazil": "Brasil",
      "canada": "Canada",
      "chile": "Chile",
      "denmark": "Danmark",
      "switzerland": "Sveits",
      "germany": "Tyskland",
      "estonia": "Estland",
      "spain": "Spania",
      "finland": "Finland",
      "france": "Frankrike",
      "uk": "Storbritannia",
      "hongKong": "Hong Kong",
      "hungary": "Ungarn",
      "ireland": "Irland",
      "italy": "Italia",
      "japan": "Japan",
      "kenya": "Kenya",
      "lithuania": "Litauen",
      "mexico": "Mexico",
      "netherlands": "Nederland",
      "newZealand": "New Zealand",
      "norway": "Norge",
      "philippines": "Filippinene",
      "puertoRico": "Puerto Rico",
      "poland": "Polen",
      "portugal": "Portugal",
      "sweden": "Sverige",
      "singapore": "Singapore",
      "unitedStates": "USA",
      "vietnam": "Vietnam",
      "southAfrica": "Sør-Afrika"
    },
    "countryshortcodes": {
      "ca": "CA",
      "eu": "EU",
      "in": "IN",
      "na": "Gjelder ikke",
      "us": "US"
    },
    "misc": {
      "0": "0",
      "1": "1",
      "10": "10",
      "10x": "10x",
      "1 (555) 987-6543": "+1 (555) 987-6543",
      "1x": "1x",
      "3x": "3x",
      "720_x_720_px": " 720 x 720 px",
      "x": "x",
      "g": "G",
      "m": "/M",
      "s": "s",
      "k": " K",
      "esc": "ESC",
      "fb": "fb",
      "ghl": "GHL",
      "mrr": "MRR",
      "dnd": "DND",
      "gbp": "GBP",
      "sms": "SMS",
      "api": "API",
      "otp": "OTP",
      "tcr": "TCR",
      "ein": "EIN",
      "acn": "ACN",
      "cbn": "CBN",
      "vat": "MVA",
      "cvv": "CVV",
      "amex": "AMEX",
      "visa": "VISA",
      "mastercard": "MasterCard",
      "dinersClub": "Diners Club",
      "2fa": "2FA",
      "ivr": "IVR",
      "ppc": "PPC",
      "cpaas": "CPaaS",
      "lc": "LC",
      "a2p": "A2P",
      "sha": "SHA",
      "_frameborder0_scrollingauto_width100_height500ifra": "&quot; frameborder=&quot;0&quot; scrolling=&quot;auto&quot; width=&quot;100%&quot; height=&quot;500&quot;&gt;</iframe>",
      "iframe_src": "<iframe src=\"",
      "editNumberPoolStrongnamestrong": "Rediger nummerpulje - <strong>{name}</strong>",
      "displayphonenumber": "visTelefonnummer",
      "js_heap_memory": "JS Heap Memory",
      "vuex_store_modules": "Vuex Store-moduler",
      "vuex_store_size": "Vuex Store-størrelse",
      "admanagerlogo": "ad-manager-logo",
      "seosearchatlaslogo": "seo-search-atlas-logo",
      "modelimage": "modellbilde",
      "tipaltiiframe": "tipalti-iframe",
      "fileimage": "bildefil",
      "urlimage": "url-bilde",
      "msgsndr8": "msgsndr8",
      "testmaindomaincom": "testmain{'@'}domain.com",
      "webdevexamplecom": "web-dev{'@'}example.com",
      "httpexamplecom": "http://example.com",
      "smtpgmailcom": "smtp.gmail.com",
      "xyzcomOrUtmcampaignxyz": "xyz.com eller utm_campaign=xyz",
      "websitecom": "website.com",
      "strongshakenstirstrongVerifica": "<strong>SHAKEN/STIR</strong> -verifisering er fullført for underkontoen din. Bygg tillit hos kundene dine gjennom verifiserte samtaler.",
      "mp3wavfile": "mp3/wav-fil",
      "usd": "$",
      "1_555_9876543": "+1 (555) 987-6543"
    },
    "stepProgress": "Trinn {currentStep} av {totalSteps}",
    "loadMore": "Last inn mer",
    "1_segment_is_equal_to_a_sms_of_160_characters_clic": "1 segment tilsvarer en SMS på 160 tegn. Klikk på ikonet for å få mer informasjon om prisdetaljer.",
    "1_segment_is_equal_to_an_sms_of_160_characters_cli": "1 segment tilsvarer en SMS på 160 tegn. Klikk på ikonet for å få mer informasjon om prisdetaljer.",
    "_email": "/ e-post",
    "_ip": "/ IP",
    "_min": " / min",
    "_of_total": "% av totalen",
    "_please_add_a_payment_method_for": "Legg til en betalingsmetode for ",
    "_segment": " / segment",
    "_used": "% brukt",
    "a_new_twilio_account_needs_to_be_created_before_we": "En ny Twilio-konto må opprettes før vi kan begynne å omfakturere",
    "a_sub_account_can_have_up_to_10_custom_objects_if_": "En underkonto kan ha opptil ti egendefinerte objekter. Hvis grensen overskrides, opprettes ingen egendefinerte objekter fra dette øyeblikksbildet.",
    "a_twilio_account_is_already_setup_for_this_location": "En Twilio-konto er allerede satt opp for denne plasseringen",
    "accountName": "Kontonavn",
    "account_sid": "Konto SID:",
    "action": "Handling",
    "actions": "Handlinger",
    "activate": "Aktiver",
    "active": "Aktiv",
    "active_listeners": "Aktive lyttere",
    "active_subscriptions": "Aktive abonnementer",
    "ad_manager": " Annonsebehandler",
    "add": "Legg til",
    "addAction": "Legg til handling",
    "add_eliza": "Legg til Eliza",
    "add_image": "Legg til bilde",
    "add_payment_method": "Legg til betalingsmetode",
    "add_to_account": "Legg til konto",
    "add_user_icon": "Legg til brukerikon",
    "add_your_first_email": "Legg til din første e-post.",
    "address": "Adresse",
    "adwords_reporting": "AdWords-rapportering",
    "affiliate_manager": "Tilknyttet ansvarlig",
    "agency": "Byrå",
    "agency_logo": "byrålogo",
    "agency_settings": "Byråinnstillinger",
    "agent_reporting": "Agentrapportering",
    "ai_employee": " AI-ansatt ",
    "all": "Alle",
    "allow_subaccounts_to_cancel_their_subscription": "Tillat underkontoer å kansellere abonnementet sitt",
    "allow_subaccounts_to_upgrade_to_a_higher_plan": "Tillat at underkontoer oppgraderes til et høyere abonnement",
    "allowed_format": "Tillatt format:",
    "am": "AM",
    "announcements_click_to_open_in_new_tab": "Kunngjøringer – klikk for å åpne i en ny fane",
    "answers": "Svar",
    "app_name": "App-navn",
    "appointments": "Avtaler",
    "apps": " apper",
    "ask_ai": "Spør AI",
    "ask_anything": "Spør om hva som helst …",
    "assigned_to_another_user": "(Tildelt til en annen bruker)",
    "at_least_one_location_is_required": "Minst én lokasjon er påkrevd",
    "attach_snapshot": "Legg ved øyeblikksbilde",
    "attribution_reporting": "Attribusjonsrapportering",
    "authorized_representative": "Autorisert representant",
    "automation_type": "Automatiseringstype",
    "available_hours": "Ledige timer",
    "avg_memoryinstance": "Avg. minne/instans",
    "back": "Tilbake",
    "base_url": "Bunn-URL",
    "between_10_kb_and_5_mb": " Mellom 10 KB og 5 MB",
    "birthday_sms": "Birthday-SMS",
    "birthday_sms_with_image": "Bursdags-SMS med bilde",
    "blogging": "Blogging",
    "bounced": "Avvist",
    "bulk_requests": "Masseforespørsler",
    "business_email": "Bedriftens e-post",
    "business_hours_configurations": "Konfigurasjoner av åpningstider",
    "business_industry": "Bedriftens bransje",
    "business_information": "Bedriftsinformasjon",
    "business_logo": "Bedriftslogo",
    "business_niche": "Forretningsnisje",
    "business_phone": "Bedriftens telefon",
    "business_physical_address": "Bedriftens fysiske adresse",
    "business_regions_of_operations": "Bedriftens driftsregioner",
    "business_registration_id_type": "Type bedriftsregistrerings-ID",
    "business_registration_number": "Bedriftens registreringsnummer",
    "business_type": "Virksomhetstype",
    "business_website": "Bedriftens nettsted",
    "busy": "Opptatt",
    "buttons": {
      "cancel": "Kansellere",
      "confirm": "Bekreft",
      "deleteAll": "Slett alle",
      "view": "Vise",
      "close": "Lukke",
      "previous": "Forrige",
      "next": "Neste",
      "clear": "Fjerne",
      "save": "Lagre",
      "edit": "Redigere",
      "delete": "Slette",
      "reset": "Tilbakestille",
      "refresh": "Oppdatere",
      "nextLoading": "Neste …",
      "copied": "Kopiert",
      "notNow": "Ikke nå",
      "send": "Send",
      "send1": "Send",
      "download": "Last ned",
      "sendNow": "Send nå",
      "saved": "Lagret",
      "back": "Tilbake",
      "update": "Oppdater",
      "add": "Legg til",
      "submit": "Send inn",
      "submitting": "Sender inn",
      "done": "Fullført",
      "manageUsers": "Administrere brukere",
      "no": "Nei",
      "yes": "Ja"
    },
    "calendar": "Kalender",
    "calendar_groups": "Kalendergrupper",
    "call": "Ring",
    "call_reporting": "Anropsrapportering",
    "call_tracking_is_disabled": "Samtalesporing er deaktivert",
    "call_voicemail_settings": "Innstillinger for anrop og talepost",
    "calls": " anrop",
    "campaign": "Kampanje",
    "campaigns": "Kampanjer",
    "cancel": " Kanseller ",
    "cancel_subscription": "Kanseller abonnement",
    "cancelled": "Kansellert",
    "certificates": "Sertifikater",
    "change": "Endre",
    "changed_data": "Endret data",
    "charge": " Kostnad",
    "charged_to_customer": "Belastet kunden",
    "chat": "Chat",
    "chat_user": "Chatbruker",
    "chat_widget_icon": "Chat-widget-ikon",
    "chats_will_be_saved_for_2_days": "Chatter lagres i 2 dager",
    "check": "sjekk",
    "check_number_validity_before_first_sms_block_incom": "Sjekk nummerets gyldighet før første SMS, blokker innkommende spam-anrop og søk etter navn på ukjente innringere før du svarer på telefonen. Ekstrakostnader påløper",
    "cinque_terre": "Cinque Terre",
    "city": "By",
    "clear_history": "Fjern historikk",
    "click_here": "Klikk her",
    "click_on_create_new_snapshot_to_add_one": " Klikk på Opprett nytt øyeblikksbilde for å legge til ett.",
    "click_to_access_the_highlevel_welcome_course": "Klikk for å få tilgang til HighLevels velkomstkurs",
    "click_to_upgrade": "Klikk for å oppgradere",
    "clicked": "Klikket på",
    "clio": "Clio",
    "cloning": "Kloning",
    "close_debugger": "Lukk debugger",
    "close_whatsapp_template_creator": "Lukk WhatsApp-malskaper",
    "collection": "Samling",
    "columns": "Kolonner",
    "coming_soon": "Kommer snart",
    "company_email_": "Bedriftens e-post (",
    "complete_component_data": "Fullstendige komponentdata",
    "complete_event_data": "Fullfør hendelsesdata",
    "complete_query_data": "Fullfør spørringsdata",
    "completed": "Fullført",
    "complimentary_credits": "Gratis kreditt",
    "component": "Komponent",
    "component_name": "Komponentnavn",
    "component_type": "Komponenttype",
    "components": " komponenter",
    "condition": "Betingelse",
    "confirm": "BEKREFT",
    "confirmation_message": "Bekreftelsesmelding",
    "confirmed": "Bekreftet",
    "connect_with_a_certified_admin_click_to_open_in_ne": "Koble til en sertifisert administrator – klikk for å åpne i ny fane",
    "connect_with_us_start_live_chat": "Koble til med oss – start en direktechat",
    "connect_your_stripe_account": "koble til Stripe-kontoen din ",
    "connect_zoom": "Koble til Zoom",
    "consider_leaving_it_blank_should_you_choose_to_use": "Vurder å la det stå tomt, hvis du velger å bruke det forhåndskonfigurerte møtestedet",
    "contact": "Kontakt",
    "contact_support": "kontakt kundestøtte",
    "contact_us_call_highlevel_at_18887324197": "Kontakt oss - ring HighLevel på +1(888)732-4197",
    "contacts": "Kontakter",
    "content_ai": "Content AI",
    "controls": "Kontroller",
    "conversations": "Samtaler",
    "copied": "Kopiert",
    "cost_borne_by_you": " kostnader som du belastes",
    "count": "Antall",
    "country": "Land",
    "createNewFolder": "Opprett ny mappe",
    "credit_balance": "KREDITTSALDO",
    "current_location_id": "Nåværende steds-ID",
    "custom": "Tilpasset",
    "custom_email": "Egendefinert e-post",
    "custom_niche": "Tilpasset nisje",
    "customer_notifications": "Kundevarsler",
    "customize": "Tilpasse",
    "customize_chat_widget": "Tilpass chat-widget",
    "dashboard_stats": "Dashboard-statistikk",
    "data_keys": "Datataster",
    "date": "Dato",
    "days": "Dager",
    "dedicated_ip": "Dedikert IP ",
    "default": "Standard",
    "default_snapshots": "Standard øyeblikksbilder",
    "delete": "Slett",
    "deleted": "slettet",
    "delivered": "Levert",
    "description": "beskrivelse",
    "details": "Detaljer",
    "disable_gbp_messaging_not_recommended": "deaktiver GBP-meldinger (ikke anbefalt)",
    "disable_tracking": "Deaktiver sporing",
    "disabled": "Deaktivert",
    "dismiss": "Fjern",
    "display_name": "Visningsnavn",
    "do_not_delete": "ikke slett",
    "do_something": "GJØR NOE",
    "do_you_want_to_keep_the_same_or_create_a_new_one": "Vil du beholde den samme eller opprette en ny?",
    "download_application_icon": "Last ned applikasjonsikon",
    "draft": "Utkast",
    "dropdown_icon": "rullegardinikon",
    "duplicate": "Dupliser",
    "duration": "Varighet",
    "eliza": "Eliza",
    "eliza_bypass_tag_optional": "Eliza Bypass-tagg (valgfritt)",
    "eliza_is_required": "Eliza er nødvendig.",
    "eliza_service": "Eliza-tjeneste",
    "email": "E-post",
    "email_resell_settings": "Innstillinger for videresalg av e-post",
    "email_sending": "Sending av e-post",
    "email_signature": "E-postsignatur",
    "enable": "Aktivere",
    "enable_beta": " Aktiver Beta",
    "enable_company_automation": "Aktiver bedriftsautomatisering",
    "enable_disable_deprecated_features": "Aktivere / deaktivere utdaterte funksjoner",
    "enable_gbp_call_tracking": " Aktiver GBP-samtalesporing ",
    "enable_gbp_messaging": "aktiver GBP-kommunikasjon",
    "enable_signature_on_all_outgoing_messages": "Aktiver signatur på alle utgående meldinger",
    "enabled": "Aktivert",
    "notEnabled": "Ikke aktivert",
    "enter_a_logical_name": "Skriv inn et logisk navn",
    "enter_the_exact_business_address_as_it_appears_in_": "Skriv inn den nøyaktige forretningsadressen slik den vises i EIN-oppføringen.",
    "enter_the_exact_legal_business_name_as_registered_": "Skriv inn det eksakte juridiske firmanavnet, slik det er registrert hos EIN.",
    "enter_the_full_street_address_as_it_appears_in_the": "Skriv inn hele gateadressen slik den vises i EIN-oppføringen.",
    "enter_user_email": "Skriv inn brukerens e-postadresse",
    "enter_user_phone_number": "Skriv inn brukerens telefonnummer",
    "enter_your_business_registration_id_type": "Angi type bedriftsregistrerings-ID",
    "enter_your_business_vertical_eg_travel": "Angi din bransje (f.eks. reise)",
    "error_code": "Feilkode",
    "error_code_chart": "Feilkodediagram",
    "error_while_copying_api_key": "Feil ved kopiering av API-nøkkel!",
    "event": "Hendelse",
    "event_bus_listeners": "Eventbuslyttere",
    "events": " hendelser",
    "everything_in": "Alt i ",
    "exact": "Nøyaktig",
    "execute_this_action_if_the_current_time_falls_in_t": "Utfør denne handlingen hvis det aktuelle tidspunktet faller innenfor dette vinduet, ellers venter du til neste vindu med å utføre denne handlingen.",
    "extension": "Utvidelse",
    "facebook": "Facebook",
    "facebook_ads": "Facebook Ads",
    "facebook_ads_reporting": "Facebook Ads-rapportering",
    "facebook_adsets": "Facebook AdSets",
    "facebook_campaigns": "Facebook-kampanjer",
    "facebook_icon": "Facebook-ikon",
    "facebook_page": "Facebook-side",
    "feature_image": "funksjonsbilde",
    "features": "Funksjoner:",
    "feedback": "Tilbakemelding: ",
    "file_path": "Filbane",
    "firestore_listeners": "Firestore-lyttere",
    "forms": "Skjemaer",
    "free": "Gratis",
    "fri": "Fre",
    "friendly_business_name": "Bedriftens markedsnavn",
    "from": " fra ",
    "funnels": "Trakter",
    "gbp_call_tracking": "GBP-samtalesporing",
    "gbp_configuration": "GBP-konfigurasjon",
    "general": "Generelt",
    "general_information": "Generell informasjon",
    "generating_link_please_wait": "Genererer lenke, vent litt …",
    "google_ads_adgroups": "Google Ads-annonsegrupper",
    "google_ads_ads": "Google Ads-annonser",
    "google_ads_campaigns": "Google Ads-kampanjer",
    "google_ads_keywords": "Google Ads-nøkkelord",
    "google_business_messaging": "Google Business-meldinger",
    "google_business_profile": "Google-bedriftsprofil",
    "google_my_business_icon": "Google My Business-ikon",
    "hello": "Hei ",
    "here": "her",
    "hhmm_a": "tt:mm A",
    "hi": "Hei ",
    "hide": "Skjul",
    "highlevel_events_click_to_open_in_new_tab": "Highlevel Events – klikk for å åpne i ny fane",
    "how_can_i_help_you_today": "Hva kan jeg hjelpe deg med i dag?",
    "how_did_the_call_go": "Hvordan gikk telefonsamtalen?",
    "how_do_i_calculate_my_email_cost_click_on_the_icon": "Hvordan beregner jeg e-postkostnaden min? Klikk på ikonet for å finne ut mer",
    "how_does_it_work": "Hvordan fungerer det?",
    "htmlElement": "HTML-element (TODO):",
    "html_element_todo": "HTML-element (TODO): ",
    "id": "ID: ",
    "if": "Hvis",
    "if_activated_the_sender_information_will_be_automa": "Hvis den er aktivert, vil avsenderinformasjonen automatisk legges til den første SMS-meldingen i alle massemeldinger for å sikre samsvar og øke leveringsratene.",
    "if_activated_we_will_insert_unsubscribe_links_in_y": "Hvis aktivert, vil vi sette inn lenker for avmelding i e-postbunntekstene, slik at mottakere kan avslutte abonnementet uten å merke e-posten som plagsom/spam.",
    "ignore_this_update": "Ignorer denne oppdateringen",
    "image": "bilde",
    "image_turned_on": "Bilde slått på",
    "imported_date": "Importert dato",
    "imported_snapshots": "Importerte øyeblikksbilder",
    "inbound": "Innkommende",
    "inbound_number": "Innkommende nummer",
    "incoming_call_timeout": "Tidsavbrudd for innkommende anrop",
    "instance_id": "Forekomst-ID",
    "instances": "Forekomster: ",
    "instructions_mentioned_in_this_page": "instruksjonene nevnt på denne siden",
    "internal": "Intern",
    "intro_message": "Introduksjonsmelding",
    "intro_question": "Introspørsmål",
    "invalid": "Ugyldig",
    "invoicing": "Fakturering",
    "is_scheduled_for_deletion_on": " er planlagt for sletting den ",
    "job_position": "Stilling",
    "job_title": "Stillingstittel",
    "join_our_facebook_group_click_to_open_in_new_tab": "Bli med i vår Facebook-gruppe – klikk for å åpne i en ny fane",
    "jpg_or_png": " JPG eller PNG ",
    "just_one_sec": "Et øyeblikk …",
    "key_sizes": "Viktige størrelser",
    "label": "etikett",
    "labels": {
      "sortDirection": "Sorteringsretning",
      "tableStyling": "Tabellutseende",
      "loadingMore": "Laster inn mer …",
      "loading": "Laster ...",
      "filter": "Filtrere",
      "search": "Søke ...",
      "sortBy": "Sortere etter",
      "perPage": "Per side",
      "date": "Dato",
      "time": "Tid",
      "readMore": "Les mer",
      "day": "Dag",
      "slot": "Tidsluke",
      "template": "Mal",
      "city": "By",
      "country": "Land",
      "state": "Stat",
      "customerName": "Kundenavn",
      "friendlyName": "Kallenavn",
      "required": "* påkrevd",
      "addressLine1": "Adresselinje 1",
      "addressLine2": "Adresselinje 2",
      "postalCode": "Postnummer",
      "searchUsers": "Søk etter brukere",
      "unknown": "Ukjent",
      "businessName": "Bedriftsnavn"
    },
    "last_updated": "Sist oppdatert",
    "launchpad_icon": "launchpad-ikon",
    "lead": "Lead",
    "leadconnector": "LeadConnector",
    "learn_how": "(Lær hvordan?)",
    "legal_business_name": "Bedriftens juridiske navn",
    "limit_updated_from": " grense oppdatert fra ",
    "listeners": " lyttere",
    "loading_your_conversation_history": "Laster inn samtaleloggen din …",
    "location": "Sted",
    "locations": " underkontoer",
    "logical_name": "Logisk navn",
    "logical_name_is_required": "Logisk navn er obligatorisk.",
    "logo": "Logo",
    "mailgun": "MailGun",
    "making_calls": "Gjøre anrop",
    "manage_custom_email": "Administrer tilpasset e-post",
    "marketing": "Markedsføring",
    "maximize": "Maksimer",
    "me_": "Meg (",
    "member_since": "Medlem siden",
    "membership": "Medlemskap",
    "memory_analysis": "Minneanalyse",
    "memory_api_not_available": "Memory-API ikke tilgjengelig",
    "message": "Melding",
    "minimize": "Minimer",
    "minimum_must_be": " Minimum må være ",
    "miscellaneous_charges": "Diverse gebyrer",
    "missed_call_text_back": "Tekstmelding tilbake ved tapt anrop",
    "missed_text_back_call_message": "Melding om ubesvart tekst tilbakekall",
    "model": "Modell",
    "module": "Modul",
    "modules": " moduler",
    "mon": "Man",
    "month": "/måned",
    "monthly": "månedlig",
    "more_emails_in_thread": " flere e-poster i tråden",
    "mount_count": "Monteringsantall",
    "mount_time": "Monteringstid",
    "moved_to_calendar_settings": "Flyttet til kalenderinnstillinger",
    "multiple_locations_using_same_twilio_account": "Flere lokasjoner bruker samme Twilio-konto",
    "must_be_in_range_of_0": " Må være i området 0-",
    "must_be_less_than_monthly_plan_12": " Må være mindre enn månedlig abonnement * 12 ",
    "my_business_is": "Min virksomhet er ",
    "my_snapshots": "Mine øyeblikksbilder",
    "name": "Navn",
    "name_of_other_registration_id_type": "Navn på annen type registrerings-ID",
    "newFolder": "Ny mappe",
    "new_task_update": "Ny oppdatering av oppgave!",
    "next": "Neste",
    "no_answer": "Ingen svar",
    "no_bigger_than_25mb": "ikke større enn 2,5 MB",
    "no_customer_selected": "Ingen kunde er valgt",
    "no_error_data_found": "Ingen feildata funnet",
    "no_payment_method_available": "Ingen betalingsmetode tilgjengelig",
    "no_provider_found": "Ingen leverandør ble funnet",
    "no_snapshots_found": "Fant ingen øyeblikksbilder.",
    "noshow": "Møtte ikke opp",
    "not": "Ikke",
    "not_now": "Ikke nå",
    "not_saved": "Ikke lagret",
    "notes": "Notater",
    "notifications": "Varsler",
    "now": "Nå",
    "numbers_and": " nummer/numre og ",
    "objective": "Målsetting:",
    "of": "av",
    "onboarding_video_tutorials_click_to_open_in_new_ta": "Videoopplæring om onboarding – klikk for å åpne i ny fane",
    "online_listings": "Nettbaserte oppføringer",
    "only_assigned_data": "Kun tildelt data",
    "open_performance_debugger": "Åpne Performance Debugger",
    "opened": "Åpnet",
    "opportunities": "Potensielle kunder",
    "options": {
      "ascending": "Stigende",
      "descending": "Synkende",
      "none": "-- Ingen --"
    },
    "or_drag_and_drop": "eller dra og slipp",
    "outbound": "Utgående",
    "pagination": "Paginering",
    "pass_body_content_here": " Send hoveddelinnholdet hit ",
    "password": "Passord",
    "paused": "Satt på pause",
    "payment_links": "Betalingslenker",
    "payment_methods": "Betalingsmetoder",
    "payment_refund": "Betalingsrefusjon",
    "payment_settings_navigation": "Navigasjon for betalingsinnstillinger",
    "payments": "Betalinger",
    "payments_integration": "Betalingsintegrasjon",
    "pending": "Avventer",
    "per_page": "Per side",
    "percentage": "Prosentdel",
    "permanently_delete_this_email": "Slett denne e-posten permanent",
    "personal_logo": "Personlig logo",
    "phone": "Telefon",
    "phone_number_with_country_code": "Telefonnummer (med landskode)",
    "pick_a_niche": "Velg en bransje",
    "pick_a_snapshot": "Velg et øyeblikksbilde",
    "pick_business_industry": "Velg bedriftens bransje",
    "pick_business_registration_id_type": "Velg type bedriftsregistrerings-ID",
    "pick_business_type": "Velg virksomhetstype",
    "pick_job_position": "Velg stilling",
    "plans_pricing": "Abonnementer og priser",
    "please_enter_a_value_greater_than_20": "Angi en verdi som er større enn 20.",
    "pm": "PM",
    "points": "Poeng",
    "postalzip_code": "Postnummer",
    "previous": "Forrige",
    "privacy_policy_url": "Personvernerklæring URL",
    "privacy_policy_url_will_be_shown_on_your_google_ag": "Personvernerklæringens URL vises på informasjonen til Google-agenten din.",
    "process_your_payment": "Behandle betalingen din",
    "profile_picture": "Profilbilde",
    "profit": "Fortjeneste",
    "prospecting": " Prospektering ",
    "provide_prebuild_snapshots_to_the_new_accounts": "Gi forhåndsbygde øyeblikksbilder til de nye kontoene.",
    "queries": " spørringer",
    "questions": "Spørsmål",
    "quick_actions_icon": "Ikon for raske handlinger",
    "re_generate_key": "Generer nøkkel på nytt",
    "read_only": "Skrivebeskyttet",
    "receipts_settings": "Kvitteringsinnstillinger",
    "receiving_calls": "Motta anrop",
    "recent_events": "Nye hendelser",
    "recommended": "Anbefalt",
    "recommended_resolution": "Anbefalt løsning:",
    "reconnect": "Koble til på nytt ",
    "record_payment": "Registrer betaling",
    "registered": " registrert.",
    "renameFolder": "Gi nytt navn til mappe",
    "replied": "Besvart",
    "representative_email": "Representantens e-post",
    "resell_settings": " Innstillinger for videresalg",
    "reset": "Tilbakestill",
    "resolve_now": "Løs nå",
    "resource_counts": "Ressurstellinger",
    "restore": "Gjenopprett",
    "results": "Resultater",
    "reviews": "Anmeldelser",
    "rollover_unused_credits_to_next_month": "Overfør ubrukte kreditter til neste måned",
    "row": " rad",
    "runNow": "Kjør nå",
    "sample_data": "(Eksempeldata)",
    "sat": "Lør",
    "save": "Lagre",
    "save_missed_call_text_settings": "Lagre innstillinger for tekstmelding ved tapte anrop",
    "save_staging_url": "Lagre URL for nettstedskopier",
    "saved": "Lagret",
    "saving": "Lagrer …",
    "search": "Søke",
    "search_active_apps": "Søk etter aktive apper …",
    "search_components": "Søk etter komponenter …",
    "search_customer": "Søk etter kunde",
    "search_email": "Søk etter e-post",
    "search_history": "Søkehistorikk …",
    "search_icon": "søkeikon",
    "search_listeners": "Søk etter lyttere …",
    "search_modules": "Søk i moduler …",
    "search_queries": "Søk forespørsler …",
    "see_this_review_on_gbp": "Se denne anmeldelsen på GBP ",
    "segments": " segmenter",
    "select": "Velg",
    "select_a_snapshot": "Velg et øyeblikksbilde",
    "monetary": "MONETÆR",
    "pleaseSelectAValue": "Velg en verdi",
    "select_account": "Velg konto",
    "select_an_account": "Velg en konto",
    "select_eliza_bypass_tag": "Velg Eliza Bypass-tagg",
    "select_phone_number": "Velg telefonnummer",
    "select_send_to_eliza_tag": "Velg Send til Eliza-tagg",
    "select_snapshot": " Velg øyeblikksbilde",
    "select_upto": "Velg opptil ",
    "selected": "Valgt: ",
    "send": "Send",
    "send_to_eliza_tag_optional": "Send til Eliza-tagg (valgfritt) ",
    "seo": " SEO ",
    "settings": "Innstillinger",
    "setup_pending": "Oppsett venter",
    "share": "Del",
    "shared_snapshots": "Delte øyeblikksbilder",
    "shared_type": "Delt type",
    "shipping_and_delivery": "Frakt og leveranse",
    "shipping_origin": "Forsendelsens opprinnelse",
    "show": "Vis",
    "showed": "Vist",
    "signin_with_single_signon": "Logg inn med enkel pålogging",
    "size": "Størrelse",
    "sms_message_sent_to_customer": "SMS-melding sendt til kunden",
    "snapshot_date": "Øyeblikksbilde-dato",
    "snapshot_name": "Navn på øyeblikksbilde",
    "social_planner": "Sosial planlegger",
    "sortBy": "Sorter via",
    "sortOptions": {
      "createdDate": "Opprettet dato"
    },
    "source": "Kilde",
    "sources": "Kilder:",
    "spent": "Brukt",
    "staging_url_settings_for_db_event": "Innstillinger for oppsamlingsadresse (for Db-hendelse)",
    "state": "Stat",
    "state_prov_region_": "Stat/provins/region *",
    "states": {
      "alabama": "Alabama",
      "alaska": "Alaska",
      "arizona": "Arizona",
      "arkansas": "Arkansas",
      "california": "California",
      "colorado": "Colorado",
      "connecticut": "Connecticut",
      "delaware": "Delaware",
      "district_of_columbia": "District Of Columbia",
      "florida": "Florida",
      "georgia": "Georgia",
      "hawaii": "Hawaii",
      "idaho": "Idaho",
      "illinois": "Illinois",
      "indiana": "Indiana",
      "iowa": "Iowa",
      "kansas": "Kansas",
      "kentucky": "Kentucky",
      "louisiana": "Louisiana",
      "maine": "Maine",
      "maryland": "Maryland",
      "massachusetts": "Massachusetts",
      "michigan": "Michigan",
      "minnesota": "Minnesota",
      "mississippi": "Mississippi",
      "missouri": "Missouri",
      "montana": "Montana",
      "nebraska": "Nebraska",
      "nevada": "Nevada",
      "new_hampshire": "New Hampshire",
      "new_jersey": "New Jersey",
      "new_mexico": "New Mexico",
      "new_york": "New York",
      "north_carolina": "North Carolina",
      "north_dakota": "North Dakota",
      "ohio": "Ohio",
      "oklahoma": "Oklahoma",
      "oregon": "Oregon",
      "pennsylvania": "Pennsylvania",
      "rhode_island": "Rhode Island",
      "south_carolina": "South Carolina",
      "south_dakota": "South Dakota",
      "tennessee": "Tennessee",
      "texas": "Texas",
      "utah": "Utah",
      "vermont": "Vermont",
      "virginia": "Virginia",
      "washington": "Washington",
      "west_virginia": "West Virginia",
      "wisconsin": "Wisconsin",
      "wyoming": "Wyoming",
      "noRecordsFound": "Fant ingen oppføringer",
      "noEntriesToShow": "Ingen oppføringer kan vises",
      "unsuccessful": "Mislykket",
      "pending": "Avventer",
      "noUsersFound": "Ingen brukere funnet"
    },
    "status": "Status",
    "stop_delete_operation": "Stopp slettingen",
    "street_address": "Gateadresse",
    "street_address_as_it_appears_in_the_ein_listing": "Gateadresse slik den vises i EIN-oppføringen.",
    "stripe_icon": "Stripe-ikon",
    "stripe_integration": "Stripe-integrasjon",
    "stripe_secret_key": "Stripe hemmelig nøkkel",
    "subscriptions": "Abonnementer",
    "sun": "Søn",
    "surveys": "Spørreundersøkelser",
    "suspend_subaccount_when_their_saas_subscription_fa": "Suspender underkontoen når SaaS-abonnementet deres feiler.",
    "switchAccount": "Bytt konto",
    "switch_off_sections_below_to_disable": "Deaktiver seksjonene nedenfor for å slå dem av",
    "tags": "Tagger",
    "tax_settings": "Skatteinnstillinger",
    "team_management": "Teamledelse",
    "team_notifications": "Teamvarsler",
    "template": "Mal",
    "terms_and_conditions": "Vilkår og betingelser",
    "test_mobile_no": "Test mobilnummer",
    "text_messages": "Tekstmeldinger",
    "the_proposed_size_is_350px_180px": "Den foreslåtte størrelsen er 350 piksler * 180 piksler",
    "the_proposed_size_is_512512px": "Den foreslåtte størrelsen er 512x512 piksler",
    "the_selected_language_will_be_used_by_the_system_a": "Systemet bruker det valgte språket som standard.",
    "the_welcome_message_automatically_appears_after_a_": "Velkomstmeldingen vises automatisk etter at en bruker starter en ny samtale.",
    "these_are_margins_that_are_billed_to_your_clients_": "Dette er marginer som faktureres kundene dine over ",
    "this_data_will_be_used_for_future_compliance_regis": "Disse dataene vil bli brukt til fremtidig registrering av overholdelse.",
    "this_is_my_twilio_use_same": "Dette er min Twilio, bruk den samme",
    "this_is_visible_to_both_agency_and_location": "Dette er synlig for både byrået og stedet",
    "this_name_will_be_visible_to_leads_chatting_with_y": "Dette navnet vil være synlig for potensielle kunder som chatter med bedriften din",
    "this_setting_is_applicable_with_only_team_calendar": "Denne innstillingen er kun gjeldende for teamkalendere.",
    "this_stripe_customer_is_already_connected_to_anoth": "Denne Stripe-kunden er allerede koblet til en annen underkonto.",
    "thu": "Tor",
    "tiktok": "Tiktok",
    "time_signed": " Tid signert: ",
    "time_zone_": "Tidssone *",
    "timestamp": "Tidsstempel",
    "title": "Tittel",
    "to_resolve_this_problem_follow_the": "For å løse dette problemet, følg ",
    "token": "Token:",
    "total": "Totalt: ",
    "trigger_link": "Utløserlenke",
    "triggers": "Triggere",
    "tue": "Tir",
    "twilio": "Twilio",
    "twilio_setup_pending": "Twilio-oppsett venter",
    "type": "Type",
    "type_campaign_objective": "Skriv inn kampanjemål",
    "type_message": "Skriv melding",
    "unsavedChangesWarning": "Endringene dine vil ikke bli lagret. Er du sikker på at du vil gå ut?",
    "unsaved_changes": "Ulagrede endringer",
    "unsubscribed": "Avmeldt",
    "unsuccessful": "Mislykket",
    "update_business_profile_details": "Oppdatere detaljer om bedriftsprofilen",
    "update_is_inprogress_visit_integrations_page_to_fi": "Oppdatering pågår. Besøk integrasjonssiden for å finne ut mer.",
    "update_url": "Oppdater URL",
    "updated_date": "Oppdatert dato",
    "updates": " oppdateringer",
    "updating": "Oppdaterer …",
    "upgrade_to_agency_pro": "oppgrader til Agency Pro ",
    "upload": "Last opp",
    "upload_a_file": "Last opp en fil",
    "usd": " USD",
    "use_this_for_zapier_and_api_integration": "Bruk dette for Zapier og API-integrering.",
    "user_email": "Brukerens e-postadresse",
    "user_permissions": "Brukertillatelser",
    "user_role": "Brukerrolle",
    "user_type": "Brukertype",
    "valid": "Gyldig",
    "verification_status": "Bekreftelsesstatus",
    "verify": "Verifiser",
    "verify_email_using_otp": "Bekreft e-post ved hjelp av OTP",
    "view_less": " Vis mindre ",
    "visiblehidden": "Synlig/skjult",
    "visit_our_help_center_click_to_open_in_new_tab": "Besøk vårt hjelpesenter – klikk for å åpne i ny fane",
    "voicemail": "Telefonsvarer",
    "wave_integration": "Wave-integrasjon",
    "we_have_found_some_errors_in_your_contact_fields_c": "Vi har funnet noen feil i kontaktfeltene dine. Klikk på mappen for å se og løse.",
    "websites": "Nettsteder",
    "wed": "Ons",
    "welcome_message": "Velkomstmelding",
    "whatsapp": " WhatsApp",
    "whatsapp_icon": "WhatsApp-ikon",
    "when": "Når",
    "when_selected_calls_will_be_routed_to_your_mobile_": "Hvis valgt, blir anrop rutet til mobilappen. (Støttes i både iOS og Android)",
    "when_selected_calls_will_be_routed_to_your_web_app": "Hvis valgt, blir anrop rutet til nettappen.",
    "which_business_do_you_want_to_link_to_this_locatio": "Hvilken bedrift ønsker du å koble til dette stedet?",
    "widget_code": "Widget-kode",
    "will_give_you_about": " vil gi deg omtrent",
    "wordpress": "WordPress",
    "wordpress_icon": "WordPress-ikon",
    "workflows": "Arbeidsflyter",
    "xero_integration": "Xero-integrasjon",
    "you_need_to_complete_few_easy_steps_to_delete_this": "Du må fullføre noen enkle trinn for å slette dette stedet",
    "you_are_not_authorized_to_perform_this_action_only": "Du er ikke autorisert til å utføre denne handlingen. Kun byråadministratorer kan slette underkontoer.",
    "your_email_cost": "E-postkostnaden din",
    "your_facebook_page_has_been_integrated_however_the": "Facebook-siden din er integrert. Men følgende funksjoner vil ikke fungere fordi LeadConnector ikke har de nødvendige tillatelsene: ",
    "your_outlook_connection_has_expired_please_disconn": "Outlook-tilkoblingen din har utløpt. Koble fra og koble deretter til kontoen igjen for å opprette forbindelsen.",
    "zip_code": "Postnummer",
    "zoom_connected_please_close_this_modal": "Zoom tilkoblet. Lukk dette modalvinduet",
    "hidden": "Skjult",
    "messageDetails": "Meldingsdetaljer",
    "openOptions": "Åpne alternativer",
    "progress": "Framgang",
    "close": "Lukk",
    "loading": "Laster",
    "fullName": "Fullt navn",
    "languages": "Språk",
    "phoneNumber": "Telefonnummer",
    "phoneNumberWithCountry": "Telefonnummer (med landskode)",
    "sendMessage": "Send melding",
    "services": "Tjenester",
    "servicesProvided": "Tjenester som tilbys",
    "pleaseProvideAValid": "Oppgi et gyldig telefonnummer.",
    "copy": "Kopier",
    "editApiKey": "Rediger API-nøkkel",
    "confirmPay": "Bekreft og betal",
    "contactUs": "Kontakt oss",
    "decline": "Avslå",
    "deleteSubaccount": "Slett underkonto",
    "disabled1": "deaktivert",
    "purchaseSummary": "Sammendrag av kjøp",
    "subscriptionPlan": "Abonnement",
    "businessName": "Bedriftsnavn",
    "chooseOne": "Velg en …",
    "stateProvRegion": "Stat/provins/region",
    "streetAddress": "Gateadresse",
    "timeZone": "Tidssone",
    "website": "Nettsted",
    "zipPostalCode": "Postnummer",
    "apiKey": "API Key",
    "createdAt": "Opprettet på",
    "deleteAllLocationApi": "Slett alle API-nøkler for plasseringen",
    "deleteApiKey": "Slett API-nøkkel",
    "generatedBy": "Generert av",
    "lastUsedAt": "Sist brukt",
    "pageNavigation": "Sidenavigasjon",
    "somethingWentWrong": "Noe gikk galt!",
    "clickHere": "Klikk her",
    "emailRebillingActive": "Omfakturering via e-post er aktiv",
    "saasSubscriptionActive": "SaaS-abonnement er aktivt",
    "scheduledForDeletion": "Planlagt for sletting",
    "twilioRebillingActive": "Twilio-omfakturering er aktiv",
    "iAcknowledgeThisIs": "Jeg bekrefter at dette er en gyldig underkonto, og jeg har verifisert brukstilfellet med å sende mer enn {limit} {type} / dag",
    "iAcknowledgeThisIs1": "Jeg bekrefter at dette er en gyldig underkonto, og jeg har verifisert brukstilfellet med å sende, og dermed justere den daglige SMS-grensen",
    "emailSentByLocation": "E-post sendt av underkontoen så langt i dag.",
    "goToSmsLimit": "Gå til SMS-grenseinnstillinger",
    "toIncreaseTheLimit": "Vil du øke grensen ytterligere, ta kontakt med brukerstøtte.",
    "newLimitOfLimit": "Ny grense for {limit} er ugyldig. Oppgi en verdi mellom {min} og {max}",
    "typeLimitUpdatedSuccessfully": "Grensen for {type} ble oppdatert",
    "locationsCurrentLimitIs": "Plasseringens nåværende grense er {current}. Du kan bare oppdatere grensen mellom {min} og {max} herfra. For eventuelle grenseoppdateringer utover {maxAllowed}, kontakt kundestøtte.",
    "notNow": "Ikke nå",
    "smsSentByLocation": "SMS sendt av underkontoen så langt i dag.",
    "youHaveSuccessfullyUpdated": "Du har oppdatert grensen",
    "willAutoUnlockIn": "Låses automatisk opp om",
    "contactType": "Kontakttype",
    "createdBy": "Opprettet av:",
    "createdOn": "Opprettet:",
    "dateOfBirth": "Fødselsdato",
    "emailAddress": "E-postadresse",
    "firstName": "Fornavn",
    "lastName": "Etternavn",
    "twilioLookupMarkedThis": "Twilio Lookup markerte dette telefonnummeret som ugyldig.",
    "twilioLookupStatedThis": "Twilio Lookup opplyste at dette er et {type}-nummer, så det vil ikke motta SMS.",
    "accountSnapshot": "Kontosammendrag",
    "auditLogs": "Revisjonslogger",
    "account": "Konto",
    "selectAccount": "Velg konto",
    "facebookUrl": "Facebook-URL",
    "instagram": "Instagram",
    "linkedin": "LinkedIn",
    "twitter": "Twitter",
    "twitterUrl": "Twitter-URL",
    "youtubeUrl": "YouTube-URL",
    "text": "Tekst",
    "allTagsLinkedTo": "Alle tagger knyttet til de valgte kontaktene bør fjernes",
    "automation": "Automatisering",
    "bulkOperation": "Masseoperasjon",
    "campaign1": "Kampanje",
    "created": "Opprettet",
    "dateTime": "Dato og tid",
    "description1": "Beskrivelse",
    "drip": "Drypp",
    "edit": "Rediger",
    "someStatsAreNot": "Noen statistikker er ikke tilgjengelige hvis leverandøren er SMTP. Nøyaktigheten til statistikken avhenger av mottakerens domene.",
    "error": "Feil",
    "from1": "Fra",
    "immediately": "Umiddelbart",
    "pause": "Sett på pause",
    "processed": "Behandlet",
    "queued": "I kø",
    "restored": "Gjenopprettet",
    "resume": "Gjenoppta",
    "sent": "Sendt",
    "scheduled": "Planlagt",
    "success": "Vellykket",
    "templateName": "Navn på mal",
    "total1": "Totalt",
    "totalAttempted": "Totale forsøk",
    "user": "Bruker",
    "viewDetails": "Vis detaljer",
    "workflow": "Arbeidsflyt",
    "company": "Bedrift",
    "note": "Merknad",
    "perPage": "per side",
    "showing": "Visning",
    "task": "Oppgave",
    "tasks": "Oppgaver",
    "customFields": "Egendefinerte felt",
    "dueDate": "Forfallsdato",
    "tryNow": "Prøv nå!",
    "archive": "Arkiver",
    "markAsRead": "Merk som lest",
    "markAsUnread": "Merk som ulest",
    "youNeedToAdd": "Du må legge til en kalender for å begynne å planlegge avtaler.",
    "additionalNotes": "Tilleggsnotater",
    "appointmentStatus": "Avtalestatus",
    "appointmentTitle": "Avtaletittel",
    "contactName": "Kontaktnavn",
    "contactTimezoneUsedFor": "Kontakttidssone (brukes til påminnelse)",
    "day": "Dag",
    "editAppointment": "Rediger avtale",
    "nameRequired": "Navn er påkrevd",
    "slotRequired": "Tidsluke er påkrevd",
    "teamMemberIsRequired": "Teammedlem er påkrevd.",
    "meetingLocation": "Møtested",
    "pickTeamMember": "Velg teammedlem",
    "phoneNumbers": "Telefonnumre",
    "roundRobin": "Rotasjonsordning",
    "selectCalendar": "Velg kalender",
    "selectTeamMember": "Velg teammedlem",
    "actionRequired": "Handling kreves",
    "scheduleAppointment": "Planlegg avtale",
    "considerLeavingItBlank": "Vurder å la det stå tomt, hvis du velger å bruke den forhåndskonfigurerte avtaletittelen",
    "assignedTo": "Tildelt til",
    "download": "Last ned",
    "loadingTranscription": "Laster inn transkripsjon …",
    "mute": "Slå av lyden",
    "playpause": "Spill av/pause",
    "playbackSpeed": "Avspillingshastighet",
    "remove": "Fjern",
    "stop": "Stopp",
    "timePlayedTotalTime": "Spilletid : Totaltid",
    "viewTranscript": "Se transkripsjon",
    "below": "nedenfor",
    "calls1": "Anrop",
    "liveChat": "Direktechat",
    "whatsapp1": "WhatsApp",
    "chatConversationAssigned": "Chatsamtale tildelt",
    "youAreChoosingNot": "Du velger å ikke slette og lukke LC Phone-underkontoen. Dette betyr at du fortsatt vil bli belastet for all bruk, uavhengig av om du blir belastet for lokasjon eller ikke.",
    "thingsAreJustGetting": "Vi har bare så vidt begynt, så la oss utforske hvordan GHL kan bidra til å bygge opp virksomheten din.\nI mellomtiden kan du fortsette å sende meldinger så mye du vil",
    "wohooConversationsAreFlowing": "Flott! Samtalene flyr nå.",
    "conversationBegan": "Samtalen begynte",
    "fetchOlderMessages": "Hent eldre meldinger",
    "inboundDndHasBeen": "Innkommende DND er aktivert for denne kontakten",
    "internalComment": "Intern kommentar",
    "confirmByTyping": "Bekreft ved å skrive",
    "iConfirmToDisconnect": "Jeg bekrefter å koble fra og stenge LC Telefon-kontoen for dette stedet. Jeg er klar over at dette vil bety at alle numrene og A2P-kampanjene vil bli slettet og ikke kan hentes tilbake.",
    "iConfirmThatI": "Jeg bekrefter at jeg har diskutert dette med min kunde og har myndighet til å iverksette denne handlingen",
    "connect": "Koble til",
    "disputeThisReview": "Bestrid denne anmeldelsen",
    "dndIsActiveFor": "DND er aktiv for samtaler",
    "off": "AV",
    "done": "Fullført",
    "downloadFile": "Last ned fil",
    "AddAccount": "+ Legg til konto",
    "attachFile": "Legg ved fil",
    "clickHereToAdd": "Klikk her for å legge til en.",
    "customerName": "Kundenavn",
    "customerPhone": "Kundens telefon",
    "orEnterAMessage": "Eller skriv inn en melding",
    "fromEmail": "Fra e-post",
    "fromName": "Avsenders navn",
    "youDontHaveAny": "Du har ingen maler ennå.",
    "requestPayment": "Be om betaling",
    "schedule": "Tidsplan",
    "selectATemplate": "Velg en mal",
    "sendNow": "Send nå",
    "smtpProvidersHasSome": "SMTP-leverandører har noen begrensninger. Klikk her for å lese mer.",
    "subject": "Emne",
    "useATemplateSnippet": "Bruk en mal (utdrag)",
    "deliveredtotalDelivered": "{delivered}/{total} levert",
    "countMoreEmailsIn": "{count} flere e-poster i tråden",
    "primary": "(Primær)",
    "reply": "Svar",
    "respond": "Svar",
    "retry": "Prøv på nytt",
    "to": "Til:",
    "fbCommentReplyDm": "FB-kommentarsvar – DM",
    "fbMessage": "FB-melding",
    "theseAttachmentsMayNot": "Disse vedleggene støttes kanskje ikke lenger.",
    "urlCannotBeFound": "URL-adressen finnes ikke",
    "activity": "Aktivitet",
    "filters": "Filtre",
    "goToPost": "Gå til innlegget",
    "inboundCall": "Innkommende anrop",
    "instagramDm": "Instagram-DM",
    "internalChat": "Intern chat",
    "search2": "Søk ...",
    "starred": "Stjernemerket",
    "leftAVoicemail": "La igjen en talebeskjed",
    "manual": "Manuell",
    "mergeFields": "Slå sammen felt",
    "addToDocuments": "Legg til dokumenter",
    "failedToAddAttachments": "Kunne ikke legge vedlegg til dokumentene",
    "attachmentsAddedToDocuments": "Vedlegg ble lagt til dokumenter",
    "newCommentOnPagename": "Ny kommentar på {pageName}-innlegg.",
    "outboundCall": "Utgående anrop",
    "replyAsDm": "Svar som DM",
    "replyingAsAPrivate": "Det er ikke mulig å svare med en privat DM for kommentarer som er eldre enn 7 dager.",
    "reportFeedbackForAi": "Rapporter tilbakemelding for AI",
    "storyMention": "Omtale av historien",
    "storyReply": "Svar på historien",
    "bulkRequest": "Bulk-forespørsel",
    "eventsAreCurrentlyCaptured": "Hendelser registreres for øyeblikket kun for kontaktens e-postadresse.",
    "failed": "Mislyktes",
    "gbpMessage": "GBP-melding",
    "pageName": "Sidenavn",
    "unknown": "Ukjent",
    "typeAMessage": "Skriv en melding",
    "new": "Ny",
    "newAppointmentBookedBy": "Ny avtale bestilt av",
    "customerNameRequired": "Kundenavn er påkrevd",
    "messageIsRequired": "Melding er påkrevd",
    "pickATemplateTo": "Velg en mal å bruke.",
    "newMessage": "Ny melding",
    "newTask": "Ny oppgave",
    "toMakeACall": "For å ringe, skriv inn et telefonnummer i dette feltet.",
    "primary1": "Primær",
    "provider": "Leverandør",
    "refresh": "Oppdater",
    "resetPassword": "Tilbakestill passord",
    "thisReviewHasAlready": "Denne anmeldelsen er allerede publisert på {network}. Er du sikker på at du vil legge den ut på nytt?",
    "seeThisReviewOn": "Se denne anmeldelsen på GBP",
    "reviewResponse": "Anmeldelsessvar",
    "searchUsers": "Søk etter brukere",
    "sendEmail": "Send e-post",
    "sending": "Sender …",
    "thisSubaccountHasPhonenumberco": "Denne underkontoen har {phoneNumberCount} numre og {campaignsCount} A2P-kampanje(r). Hvis du sletter denne kontoen, vil det fortsatt påløpe kostnader hvis LC Phone System-kontoen ikke er frakoblet og lukket.",
    "thisSubaccountDoesNot": "Denne underkontoen har verken numre eller A2P-kampanjer. Å sette denne kontoen på pause vil ikke påføre deg noen kostnader, men vi anbefaler at du kobler fra og lukker LC Phone-kontoen.",
    "summary": "Sammendrag",
    "unassigned": "Ikke tilordnet",
    "viewSubmission": "Vis innlevering",
    "contactSupport": "Kontakt kundestøtte",
    "create": "Opprett",
    "illDoThisLater": "Jeg vil gjøre dette senere",
    "enterBusinessName": "Skriv inn bedriftsnavn",
    "firstNameOfThe": "Fornavn til bedriftseier",
    "mobileBusinessPhone": "Mobil/bedriftstelefon",
    "iDontHaveA": "Jeg har ikke et nettsted",
    "clientName": "Kundenavn",
    "letUsSetupYour": "La oss sette opp din egen konto eller din første kunde",
    "clientNameIsRequired": "Kundenavn er påkrevd",
    "pleaseEnterAValid": "Skriv inn en gyldig e-postadresse",
    "emailAddressIsRequired": "E-postadresse er påkrevd",
    "firstNameIsRequired": "Fornavn er påkrevd",
    "lastNameIsRequired": "Etternavn er påkrevd",
    "phoneNumberIsRequired": "Telefonnummer er påkrevd",
    "copyOfName": "Kopi av {name}",
    "goToDashboard": "Gå til dashbord",
    "permissionsNotEnabled": "Tillatelser er ikke aktivert!",
    "createAndSellCustom": "Opprett og selg tilpassede produkter med print-on-demand dropshipping",
    "viewApp": "Vis app",
    "seamlessFulfillmentRealtimeShi": "Sømløs oppfyllelse og fraktpriser i sanntid for nettbutikkene dine",
    "learnMore": "Les mer",
    "activateFormMapping": "Aktiver skjematilordning",
    "avatarName": "Avatar-navn",
    "formFields": "Skjemafelter",
    "formName": "Skjemanavn",
    "mapFields": "Kartfelt",
    "update": "Oppdater",
    "pauseSubaccount": "Sett underkonto på pause",
    "pausing": "Setter på pause …",
    "subaccount": "underkonto",
    "howItWorks": "Slik fungerer det",
    "uponCompletingThisAction": "Når denne handlingen er fullført, vil overføringsforespørselen bli sendt til det mottakende byrået ({relNo}). Underkontoen vil bli overført umiddelbart etter at de aksepterer den. Merk at denne handlingen er irreversibel.",
    "ejectSubaccount": "Utløs underkonto",
    "newAgencyCreationMail": "Ny e-post om opprettelse av byrå sendt til valgt bruker. Brukeren kan opprette et nytt byrå ved å klikke på lenken i e-posten.",
    "unableToTransferSubaccount": "Kan ikke laste opp underkonto til dette byrået.",
    "nominateAccountOwnerFor": "Utpek kontoeier for den nye kontoen",
    "pleaseConfirmOwnershipWill": "Bekreft at eierskapet skal overføres til",
    "scheduledDate": "Planlagt dato",
    "thisDateIsBased": "Denne datoen er basert på denne bedriftens tidssone, som er {timezone}",
    "campaignName": "Kampanjenavn",
    "copyCampaign": "Kopier kampanje",
    "endTime": "Sluttid",
    "event10xEmail4": "Hendelse: 10X E-post 4 (distribusjon av lister) ",
    "10xEmail1Reviews": "10X E-post 1 (anmeldelser)",
    "fromAddress": "Fra adresse",
    "leadValue": "Lead-verdi",
    "option1": "Alternativ 1",
    "option2": "Alternativ 2",
    "option3": "Alternativ 3",
    "preview": "Forhåndsvisning",
    "selectCampaign": "Velg kampanje",
    "startTime": "Starttid",
    "time": "Tid",
    "users": "Brukere",
    "noRecordsFound": "Fant ingen oppføringer",
    "pageDetail": "Sidedetaljer",
    "selectAll": "Velg alle",
    "submission": "Innlevering",
    "addProduct": "Legg til produkt",
    "visitors": "besøkende",
    "By": " av",
    "conversions": "Konverteringsfrekvens ",
    "liveReviews": "Live anmeldelser",
    "liveVisitors": "Live besøkende",
    "pageVisits": "Sidebesøk",
    "stream": "Strøm",
    "addOneOrMore": "Legg til én eller flere URL-adresser, eller kopier dem direkte fra nettleseren din.",
    "WeWillAutomatically": " Vi vil automatisk spore besøkende på nettstedet ditt i sanntid. ",
    "connectYourLocationsFacebook": "Koble til underkontoens Facebook-konto",
    "connected": "Tilkoblet!",
    "Contains": " inneholder ",
    "expression": "Uttrykk",
    "facebookAccount": "Facebook-konto",
    "wowYouDontNeed": "Du trenger ikke å konfigurere noe her, du kan gå videre.",
    "Regex": " regex ",
    "selectUrlMatchType": "Velg type URL-samsvar",
    "Simple": " enkel ",
    "LivePreview": " Live-forhåndsvisning",
    "seconds": "sekunder",
    "launch": "Lanser ",
    "decorativeVector1": "Dekorativ vektor 1",
    "showingFromToTo": "Viser {from} til {to} av {total} oppføringer",
    "cloneProduct": "Klone produkt",
    "connectFacebookInstagram": "Koble til Facebook og Instagram",
    "connectPage": "Koble til side!",
    "everythingIn": "Alt i",
    "agentChat25": "Agentchat (ca. 2–5 min ventetid)",
    "aiSupportChat": "AI-støttechat",
    "startChat": "Start chat",
    "locations1": "underkontoer",
    "phone1": "telefon",
    "slack": "Slack",
    "segments1": "segmenter",
    "areYouSureYou": "Er du sikker på at du vil slette denne mappen?",
    "verified": "Verifisert",
    "highlevelPrice": "HighLevel-pris",
    "howDoesItWork": "Hvordan fungerer det?",
    "payNow": "Betal nå",
    "priceMustBeMore": "Prisen må være høyere enn eller lik HighLevel-prisen",
    "saving2": "Lagrer",
    "yourPrice": "Din pris",
    "yourProfit": "Din fortjeneste",
    "youNeedToComplete": "Du må fullføre noen få enkle samsvarstrinn for å deaktivere SaaS-modus for denne underkontoen",
    "youAreNotAuthorized": "Du er ikke autorisert til å utføre denne handlingen. Kun byråadministratorer kan gjøre dette.",
    "disableSaasModeFor": "Deaktiver SaaS-modus for {name}",
    "companyBilling": "Bedriftsfakturering",
    "bccEmailsCommaDelimited": "BCC-e-poster (kommaavgrenset)",
    "unableToDeleteMailgun": "Kan ikke slette Mailgun-kontoen, kontakt kundestøtte.",
    "forwardingAddress": "Videresendingsadresse",
    "forwardingAddressesCommaDelimi": "Videresendingsadresser (kommaavgrenset)",
    "amount": "Beløp",
    "billingDate": "Faktureringsdato",
    "debugWalletTransactionsTotal": "DEBUG transaksjoner i lommebok, totalt: {count}",
    "detailedTransactions": "Detaljerte transaksjoner",
    "transactionsOnlyAfter26th": "Kun transaksjoner etter 26. apr 2022 er oppført og tilgjengelig for eksport",
    "someRecordsMayTake": "Noen oppføringer kan ta 24 timer å oppdatere her.",
    "totalBalance": "Total saldo",
    "walletTransactions": "Transaksjoner i lommebok",
    "walletTransactionsAllDate": "Transaksjoner i lommebok - Alle - {date}",
    "enterMessage": "Skriv inn en melding",
    "applyThisChangeTo": "Bruk denne endringen på alle underkontoer.",
    "characters": "Tegn",
    "iConfirmThatI1": "Jeg bekrefter at jeg har diskutert dette med kunden, og jeg har deres godkjenning.",
    "iConfirmThatI2": "Jeg bekrefter at jeg vil sørge for at alle SMS-meldinger sendt fra denne kontoen er i samsvar med gjeldende retningslinjer.",
    "theContentsOfThis": "Innholdet i denne meldingen blir automatisk lagt til den første SMS-en som sendes via massemeldinger.",
    "iConfirmThatSms": "Jeg bekrefter at SMS-meldinger kun vil bli sendt til kontakter som har samtykket til å motta SMS.",
    "quickTip": "Hurtigtips",
    "messageWillBeAppended": "Meldingen vil bli lagt til i den første SMS-en i en konvertering hvis den ikke inneholder språk for avmelding",
    "readMore": "Les mer",
    "noncompliantActivityMayLead": "Ikke-samsvarende aktivitet kan føre til suspensjon av SMS- og tale-relaterte funksjoner på kontoen din.",
    "typeConfirmBelowTo": "Skriv bekreft nedenfor for å fortsette",
    "products": "Produkter",
    "chooseCountry": "Velg land …",
    "email2": "E-post*",
    "firstName1": "Fornavn*",
    "lastName1": "Etternavn*",
    "brandDetails": "Merkevaredetaljer",
    "brandName": "Navn på merkevare*",
    "useEitherLegalName": "Bruk enten det juridiske navnet til organisasjonen som sender meldingene, eller ditt eget navn hvis denne merkevaren ikke er for en organisasjon.",
    "businessIndustry": "Bedriftens bransje*",
    "chooseVertical": "Velg bransje …",
    "mobileNumberForOtp": "Mobilnummer for OTP-verifisering (med landskode)*",
    "pleaseProvideAMobile": "Angi et mobilnummer som du har tilgang til så du kan bekrefte OTP-verifisering. Kun amerikanske/kanadiske numre vil bli godkjent. Du kan ikke bruke et CPaaS-telefonnummer, for eksempel et som du har fått fra LeadConnector. Du kan ikke bruke det samme mobilnummeret til å registrere mer enn tre enkeltpersonforetak. Denne grensen administreres av TCR.",
    "increasedDeliveryRate": "Økt leveringsgrad",
    "sendUpto3000Segments": "Send opptil 3000 segmenter per dag",
    "businessDetails": "Bedriftsdetaljer",
    "thereWasSomeIssue": "Det oppstod et problem under innsending av profilen.",
    "yourProfileSubmissionFailed": "Profilen din ble ikke sendt inn.",
    "endUserConsent": "Samtykke fra sluttbruker",
    "minLength40Characters": "Min. lengde: 40 tegn. Maks. lengde: 2048 tegn.",
    "closeExamples": "Lukk eksempler",
    "sampleMessage1": "Eksempelmelding #1*",
    "seeExamples": "Se eksempler",
    "enterCampaignDetails": "Angi kampanjedetaljer",
    "youWillReceiveAn": "Du vil motta en OTP-melding på ditt oppgitte mobilnummer for verifisering fra TCR. Svar Ja innen 24 timer etter å ha mottatt SMS-en.",
    "brandNameIsRequired": "Navn på merkevare er påkrevd.",
    "businessVerticalIsRequired": "Bedriftens område er påkrevd.",
    "mobileNumberIsRequired": "Mobilnummer er påkrevd.",
    "hideDetail": "Skjul detaljer",
    "showDetail": "Vis detaljer",
    "people": "mennesker",
    "person": "person",
    "after": "etter",
    "before": "før",
    "hour": "time",
    "hours": "timer",
    "minute": "minutt",
    "minutes": "minutter",
    "triggerLinksEmbeddedIn": "trigger-lenker (innebygd i melding) klikket som % av meldinger sendt",
    "addNewEvent": "Legg til ny hendelse",
    "addTask": "Legg til oppgave",
    "manualCall": "Manuell telefonsamtale",
    "manualSms": "Manuell SMS",
    "messenger": "Messenger",
    "wait": "Vent",
    "webhook": "Webhook",
    "about": "Om",
    "accessRestricted": "Begrenset tilgang",
    "addPartner": "Legg til partner",
    "addPartnerForm": "Legg til partnerskjema",
    "affiliatePortal": "Partnerportal",
    "badges": "Skilt",
    "aBriefBio": "En kort biografi",
    "dashboard": "Dashbord",
    "experience": "Erfaring",
    "industryServed": "Betjent bransje",
    "instagramAccount": "Instagram-konto",
    "invoiceHistory": "Fakturahistorikk",
    "englishGermanHindi": "Engelsk, tysk, hindi",
    "linkToWebsite": "lenke til nettsted",
    "linkedinAccount": "LinkedIn-konto",
    "locationId": "Sted-ID",
    "partnerName": "Partnernavn",
    "partnerStatus": "Partnerstatus",
    "paymentDetails": "Betalingsdetaljer",
    "paymentHistory": "Betalingshistorikk",
    "profilePhoto": "Profilbilde",
    "profilePhotoUrl": "URL for profilbilde",
    "promoterReports": "Promotørrapporter",
    "searchPartner": "Søk etter partner",
    "twitterAccount": "Twitter-konto",
    "updatePartner": "Oppdater partner",
    "updatePartnerForm": "Oppdater partnerskjema",
    "yearOfExperience": "års erfaring",
    "youtubeAccount": "YouTube-konto",
    "serviceProvided": "Tjeneste levert",
    "controlTheSubaccountSettings": "Kontroller innstillingene for underkontoer",
    "generalInfo": "Generell informasjon",
    "okay": "OK",
    "proceed": "Fortsett",
    "addCard": "Legg til kort",
    "makeThisCardPrimary": "Gjør dette kortet til primærkortet",
    "nameOnCard": "Navn på kortet",
    "chargedToCustomer": "Belastet kunden",
    "clientBillingPage": "Kundes faktureringsside",
    "companyStripeIntegrationPage": "Bedriftens Stripe-integrasjonsside",
    "enableRebilling": "Aktiver omfakturering",
    "enabling": "Aktiverer …",
    "forMoreDetails": "for mer informasjon.",
    "youreOnTheFreelancer": "Du er på Frilanser-abonnement, som begrenser deg til påslag på 1,05x.",
    "minimumAmountShouldBe": "Minstebeløpet skal være mellom ${min} og ${max}",
    "beforeEnablingThisFeature1": "Før du aktiverer denne funksjonen, må du koble til Stripe-kontoen din på",
    "planToSetYour": "abonnementet for å sette høyere marginer.",
    "rebillAmount": "Omfaktureringsbeløp",
    "supportDoc": "rundskriv",
    "10WillGiveYou": "$10 vil gi deg omtrent",
    "minimumMustBeBetween": "Minimum må være mellom 0,0001 og 0,005",
    "sorryYouCannotRebillAtTheMarkup": "Beklager! Du kan ikke omfakturere med påslaget på Freelancer-abonnementet.",
    "modifyingTheseSettingsWillChange": "Endring av disse innstillingene vil endre kostnadene som kundene dine pådrar seg fremover.",
    "pleaseDoNotModifyThese": "Ikke endre disse hvis du ikke er sikker på effekten av dem.",
    "theseSettingsWillApply": "Disse innstillingene vil gjelde for dine nye kunder fremover",
    "congratulationsYourDedicatedIp": "Gratulerer! Din dedikerte IP-videresalgsverdi har blitt lagret.",
    "youHaveAgreedToProvide": "Du har avtalt å levere dedikerte IP-adresser direkte til en underkonto. Byrået vil dekke kostnadene på vegne av byråunderkontoen.",
    "youHaveDiscontinuedToProvide": "Du har sluttet å tilby dedikerte IP-adresser direkte til en underkonto. Byrået vil ikke lenger dekke kostnadene på vegne av byråunderkontoen.",
    "oopsSomethingWentWrongAndWeCouldnt": "Oops! Noe gikk galt, og vi klarte ikke å lagre konfigurasjonen for videresalg av dedikert IP. Prøv igjen senere.",
    "pleaseAgreeToTheTerms": "Godta vilkårene",
    "errorWhileFetchingDomains": "Feil under henting av domener",
    "sameStripeCustomerProfileCantBeMapped": "Samme Stripe-kundeprofil kan ikke knyttes til mer enn én underkonto.",
    "pleasePickADifferentStripeCustomer": "Velg en annen Stripe-kundeprofil eller bruk \"Del en lenke\" slik at vi kan opprette en ny Stripe-kundeprofil for denne underkontoen.",
    "clickNextToChooseAPlan": "Klikk på \"Neste\" for å velge en plan og opprette et nytt abonnement.",
    "youDontHaveAnyActiveSubscriptions": "Du har ingen aktive abonnementer",
    "youCanEitherSelectAnExistingSubscription": "De kan enten velge et eksisterende abonnement, eller opprette et nytt abonnement i neste trinn.",
    "useCommasToSeparateMultipleEmails": "Bruk komma for å skille flere e-poster fra hverandre.",
    "useCommasToSeparateMultiplePhoneNumbers": "Bruk komma for å skille flere telefonnumre fra hverandre.",
    "noUserFoundInThisLocation": "Ingen brukere funnet på denne lokasjonen",
    "noPhoneNumberAttached": "Ingen telefonnummer er vedlagt",
    "pleaseUseTheFollowingLinkToAttachYourPaymentMethod": "Bruk følgende lenke for å legge ved betalingsmetoden din.",
    "allowDuplicateContact": "Tillat duplikatkontakt",
    "allowDuplicateOpportunity": "Aktivere dupliserte muligheter",
    "mergeFacebookContactsByName": "Slå sammen Facebook-kontakter etter navn",
    "onlyIncomingMessagesFromFacebookWillBeMerged": "Kun innkommende meldinger fra Facebook vil bli slått sammen hvis de samsvarer med navnet til en eksisterende kontakt. Navn skiller mellom store og små bokstaver.",
    "disableContactTimezone": "Deaktiver kontaktens tidssone",
    "markEmailsAsInvalidDueToHardBounce": "Merk e-poster som ugyldige på grunn av hard avvisning",
    "contactsEmailsWillBeMarkedAsInvalid": "Kontaktens e-poster vil automatisk bli merket som Utløpt når de blir permanent avvist. E-postaktiviteter i automatiseringer hoppes over for kontakter med ugyldige e-poster.",
    "gatherIntelligenceOnUnknownPhoneNumbers": "Samle inn informasjon om ukjente telefonnumre",
    "makeSmsCompliantByAddingAnOptOutMessage": "Gjør SMS kompatibel ved å legge til en avmeldingsbeskjed.",
    "ifActivatedTheOptOutMessageWillBeAutomaticallyAdded": "Hvis den er aktivert, vil avmeldingsbeskjeden automatisk legges til den første SMS-en som sendes via massemeldinger for å sikre samsvar og øke leveringsratene.",
    "platformLanguage": "Plattformspråk",
    "outboundCommunicationLanguageForCustomValues": "Språk for utgående kommunikasjon for egendefinerte verdier",
    "updateInformation": "Oppdater detaljer",
    "upgradeToTheAgency": "Oppgrader til Agency Pro",
    "yourCost": "Din kostnad",
    "addACalendarTo": "Legg til en kalender for å starte booking av avtaler.",
    "addselectAContactTo": "Legge til/velg en kontakt for å planlegge avtaler",
    "appointmentSlotIsNot": "Avtaletidsluke er ennå ikke valgt",
    "loading1": "Laster . . .",
    "teamMemberIsRequired1": "Teammedlem er påkrevd",
    "currentPlan": "Nåværende abonnement",
    "features1": "Funksjoner",
    "upgrade": "Oppgradere",
    "viewLess": "Vis mindre",
    "viewMoreCount": "Vis mer (+{count})",
    "cardNumber": "Kortnummer",
    "expiryDate": "Utløpsdato",
    "paymentMethods": "Betalingsmetoder",
    "primaryCard": "Hovedkort",
    "removeCurrentCard": "Fjern det nåværende kortet",
    "AddBalance": "+ Legg til saldo",
    "complimentaryCredits": "Gratis kreditt:",
    "expiringOnDate": "Utløper {date}",
    "apiVersion": "API-versjon",
    "application": "Applikasjon",
    "ipAddress": "IP-adresse",
    "related": "Relatert",
    "request": "Forespørsel",
    "yourAccountIncludingAll": "Kontoen din, inkludert all utgående aktivitet som planlagte meldinger og e-poster, vil bli stoppet umiddelbart.",
    "yourAccountIncludingAll1": "Kontoen din, inkludert all utgående aktivitet som planlagte meldinger og e-poster, vil bli stoppet umiddelbart.",
    "nextBillingDateDate": "Neste faktureringsdato: {date}",
    "scheduledForCancellation": "Planlagt for kansellering",
    "abandoned": "Ufullstendig",
    "add1": "Legg til",
    "addOpportunity": "Legg til mulighet --",
    "addOpportunityName": "Legg til navn på mulighet",
    "Task": "+ Oppgave",
    "bookupdateAppointment": "Book/oppdater avtale",
    "companyName": "Firmanavn",
    "areYouSureYou1": "Er du sikker på at du vil slette denne muligheten?",
    "contactInfo": "Kontaktinformasjon",
    "editOpportunity": "Rediger mulighet --",
    "enterValue": "Angi verdi",
    "goToContactDetail": "Gå til kontaktdetaljsiden",
    "leads": "Leads",
    "lost": "Tapt",
    "nameIsRequired": "Navn er påkrevd.",
    "youreNotAllowedTo": "Du har ikke lov til å endre kundenavn! Sjekk tillatelsene dine med byråadministratoren.",
    "open": "Åpne",
    "opportunity": "Mulighet",
    "opportunityAlreadyExistsIn": "Muligheten finnes allerede i denne prosessen",
    "opportunityInfo": "Informasjon om mulighet",
    "opportunityName": "Navn på mulighet",
    "opportunitySource": "Mulighetskilde",
    "owner": "Eier",
    "pipeline": "Pipeline",
    "removeOwner": "Fjern eier",
    "selectPipeline": "Velg prosess",
    "selectStage": "Velg skritt",
    "stage": "Etappe",
    "countTasks": "{count} aktiviteter",
    "won": "Vunnet",
    "and": "og ",
    "addASubscription": "Legg til et abonnement",
    "noSaasPlanEnabled": "Ingen SaaS-plan aktivert",
    "per": "per",
    "assignTo": "Tildele til",
    "assignedTo1": "Tildelt til:",
    "areYouSureYou2": "Er du sikker på at du vil slette denne oppgaven?",
    "due": "Forfaller:",
    "dueDateIsRequired": "Forfallsdato er påkrevd",
    "dueIn": "Forfaller om",
    "dueToday": "Forfaller i dag",
    "late": "Sen",
    "notAssigned": "Ikke tildelt",
    "taskDescription": "Oppgavebeskrivelse",
    "taskTitle": "Oppgavenavn",
    "annually": "årlig",
    "attachments": "Vedlegg",
    "areYouSureYou3": "Er du sikker på at du vil slette denne masseforespørselen?",
    "startImmediately": "Start umiddelbart",
    "customers": "Kunder",
    "tag": "Tagg",
    "pickType": "Velg type",
    "whoShouldItRun": "Hvem skal den kjøre for?",
    "addBulkRequest": "Legg til masseforespørsel",
    "editBulkRequest": "Rediger masseforespørsel",
    "scheduledDateIsRequired": "Planlagt dato er påkrevd",
    "newCampaignName": "Nytt kampanjenavn",
    "areYouSureYou4": "Er du sikker på at du vil slette denne kampanjen?",
    "moveToFolder": "Flytt til mappe",
    "pleaseRename": "gi nytt navn",
    "removeFromFolder": "Fjern fra mappe",
    "photoPreview": "forhåndsvisning av foto",
    "pleaseWait": "Vent litt …",
    "customValues": "Egendefinerte verdier",
    "whatActionShouldWe": "Hvilken handling bør vi utføre?",
    "entitynameName": "Navn på {entityName}",
    "useLcEmail": "Bruk LC Email",
    "21Jun2018": "21. juni 2018",
    "930Am": "09:30 AM",
    "Via": " via ",
    "createdTrackingNumbers": "Opprettede sporingsnumre",
    "iUnderstandImBuyingadding": "Jeg forstår at jeg kjøper/legger til {count} nye telefonnumre.",
    "forwardCallsTo": "Videresend anrop til",
    "numberName": "Nummernavn",
    "numberPoolName": "Navn på nummerpulje",
    "numberToSwap": "Nummer som skal byttes",
    "sameAsForwardingNumber": "Samme som videresendingsnummer",
    "callFromSource": "Telefonsamtale fra [Kilde].",
    "callRecording": "Opptak av samtale",
    "84Complete": "84 % fullført",
    "thisCallWillBe": "Denne samtalen vil bli tatt opp for kvalitetssikring.",
    "whisperMessage": "Diskret melding",
    "allExceptDirect": "Alle unntatt direkte",
    "allExceptDirectOrganic": "Alle unntatt direkte og organisk trafikk",
    "allSearch": "Alle søk",
    "allVisitorsRecommended": "Alle besøkende (anbefalt)",
    "bing": "Bing",
    "direct": "Direkte",
    "visitorsWithoutAReferring": "Besøkende uten et henvisende nettsted",
    "for": "for",
    "google": "Google",
    "landingPageOrUrl": "Landingsside eller URL-parameter",
    "organic": "Organisk",
    "paid": "Betalt",
    "pickOneYouCan": "Velg én – du kan alltid endre dette senere.",
    "ppcSearch": "PPC-søk",
    "visitorsFromGoogleBing": "Besøkende fra Google, Bing og Yahoo PPC-søk",
    "referringPage": "Henvisende side",
    "visitorsFrom": "Besøkende fra",
    "visitorsFromGoogleAds": "Besøkende fra Google Ads",
    "visitorsWhoAreReferred": "Besøkende som henvises fra",
    "visitorsWhoLandOn": "Besøkende som ankommer",
    "whichVisitorsDoYou": "Hvilke besøkende ønsker du å spore?",
    "yahoo": "Yahoo",
    "17Complete": "17 % fullført",
    "callTimeoutS": "Tidsavbrudd for anrop (s)",
    "callWhisper": "Diskret beskjed ved svar",
    "disableVoicemailDetect": "Deaktiver gjenkjenning av telefonsvarer",
    "eventName": "Hendelsesnavn",
    "timeoutSeconds": "Tidsavbrudd (sekunder)",
    "editCall": "Rediger anrop",
    "callWillPatchInstantly": "Telefonsamtalen vil bli koblet umiddelbart. Vi vil ikke lytte for å se om telefonsvareren ble aktivert hos den potensielle kunden. Dette betyr at kampanjen vil bli markert som besvart selv om telefonsvareren blir plukket opp.",
    "thisIsTheMessage": "Dette er meldingen du vil at personen som tar telefonen skal høre. Du kan bruke egendefinerte variabler for å tilpasse denne.",
    "pleaseCheckTheLinks": "Sjekk lenkene der du har en tilpasset verdi. Det er en ekstra '%20' mellom {{ og custom_values.",
    "anErrorOcurredPlease": "Det oppstod en feil, prøv igjen.",
    "pleaseInsertATo": "Skriv inn en mottaksadresse.",
    "pickEmailTemplate": "Velg e-postmal",
    "sendTest": "Send test",
    "composeEmail": "Skriv e-post",
    "composeEmailTemplate": "Mal for å skrive e-post",
    "toAddress": "Til adresse",
    "addFileThroughUrl": "Legg til dokument via URL",
    "appCharacters": "App-tegn:",
    "approximateCost": "Omtrentlig kostnad:",
    "estimatedCostForUs": "Anslått kostnad kun for SMS fra USA til USA.",
    "mobilePhoneNumber": "Mobiltelefonnummer",
    "numSegments": "Ant. segmenter",
    "pickMessageTemplate": "Velg meldingsmal",
    "pleaseProvideAPhone": "Oppgi et telefonnummer som du vil sende testen til.",
    "composeEventtype": "Opprett {eventType}",
    "composeEventtypeTextTemplate": "Opprett {eventType} tekstmal",
    "unsupportedSmsContentType": "Innholdstype for SMS som ikke støttes {fileType}",
    "countOfTheProvided": "{count} av de utstedte URL-vedleggene er {plural} ikke et bilde. Dette kan forårsake feil i Twilio. Ønsker du å lagre likevel?",
    "dropFileHereOr": "Slipp fil her eller klikk for å laste opp",
    "ifYouHaveAdditional": "Hvis du har flere spørsmål, kan du se vanlige spørsmål om fjerning av talemelding i hjelpeseksjonen.",
    "editVoicemail": "Rediger telefonsvarer",
    "selectAMp3Or": "Velg en mp3- eller wav-fil, vi støtter ikke andre formater.",
    "voicemailFile": "Telefonsvarerfil",
    "warningVoicemailDropsAre": "Advarsel: Fjerning av talemelding er et system med beste forsøk og fungerer omtrent 70 % av tiden.",
    "youNeedToPick": "Du må velge minst én dag",
    "editWait": "Rediger Vent",
    "url": "URL",
    "customTime": "Tilpasset tid",
    "executeThisActionIf": "Utfør denne handlingen hvis det aktuelle klokkeslettet faller innenfor dette vinduet. Hvis det aktuelle klokkeslettet er utenfor dette vinduet, hopper du over dette trinnet og går videre til neste handling.",
    "pickDays": "Velg dager",
    "pickTime": "Velg tid",
    "noRecordsFound1": "Ingen oppføringer ble funnet.",
    "formAnalyze": "Statistikk skjema",
    "totalSubmission": "Total innlevering",
    "forgotPassword": "Har du glemt passordet ditt?",
    "orContinueWith": "Eller fortsett med",
    "signIn": "Logg inn",
    "signIntoYourAccount": "Logg inn på kontoen din",
    "thePasswordYouPicked": "Passordet du valgte",
    "yourEmailAddress": "E-postadressen din",
    "newEmailFrom": "Ny e-post fra",
    "newMessageFrom": "Ny melding fra",
    "hasLeftANew": "har lagt igjen en ny anmeldelse.",
    "repliedToTheReview": "svarte på anmeldelsen.",
    "loaded": "Lastet",
    "snapshot": "Øyeblikksbilde",
    "appointment": "Avtale",
    "appointmentDueInMinutes": "Avtale forfaller om {minutes} min for {contactName}",
    "appointmentReminder": "Avtalepåminnelse",
    "completedCount": "Fullført: {count}",
    "conversation": "Samtale",
    "facebookReview": "Facebook-anmeldelse",
    "failedCount": "Mislyktes: {count}",
    "googleReview": "Google-anmeldelse",
    "internalChatMessage": "Intern chatmelding",
    "usernameMentionedYouIn": "{userName} nevnte deg i en samtale med {contactName}",
    "newAppointmentAssigned": "Ny avtale tildelt",
    "aNewAppointmentWith": "Du har fått en ny avtale med {contactName}.",
    "newAppointmentBooked": "Ny avtale bestilt",
    "youHaveNewAppointment": "Du har en ny avtale med {contactName}",
    "newCall": "Nytt anrop",
    "aNewChatWith": "En ny chat med {contactName} har blitt tildelt deg.",
    "newEmail": "Ny e-post",
    "newMention": "Ny omtale",
    "newReviewReceivedFrom": "Ny anmeldelse mottatt fra {contactName}",
    "aNewTypeIs": "En ny {type} er mottatt fra {contactName}",
    "notification": {
      "noRecentActivity": "Ingen nylig aktivitet"
    },
    "subAccount": "Underkonto",
    "subaccount1": "Underkonto:",
    "titleOnDateAt": "{title} på {date} kl. {time} for {contactName}",
    "titleDueInDuetime": "{title} forfaller om {dueTime} {unitOfTime} for {contactName}",
    "taskReminder": "Oppgavepåminnelse",
    "youHaveCountTasks": "Du har {count} oppgaver som forfaller i dag",
    "youHaveCountTasks1": "Du har {count} forfalte oppgaver hittil",
    "droppedVoicemailTo": "Droppet talemelding til",
    "errorWhileCloningProduct": "Feil under kloning av produktet!",
    "productName": "Produktnavn",
    "selectLocations": "Velg steder",
    "selectUptoMaxselectablelocatio": "Velg opptil {maxSelectableLocations} steder",
    "highlevelInc": "HighLevel Inc.",
    "CountMore": "+ {count} flere",
    "emails": "E-poster",
    "accountNotification": "Kontovarsel",
    "customerCare": "Kundeservice",
    "deliveryNotification": "Varsel om levering",
    "fraudAlertMessaging": "Meldinger om svindelvarsler",
    "higherEducation": "Høyere utdanning",
    "lowVolumeMixedRecommended": "Lavt volum blandet (anbefalt)",
    "mixed": "Hybrid",
    "pollingAndVoting": "Meningsmåling og avstemning",
    "publicServiceAnnouncement": "Offentlig kunngjøring",
    "securityAlert": "Sikkerhetsvarsel",
    "mixedRecommended": "Hybrid (anbefalt)",
    "australiaCompanyNumberFrom": "Australia: Firmanummer fra ASIC (ACN)",
    "canadaCanadianBusinessNumber": "Canada: Kanadisk firmanummer (CBN)",
    "indiaCorporateIdentityNumber": "India: Bedriftsidentifikasjonsnummer",
    "greatBritainCompanyNumber": "Storbritannia: Firmanummer",
    "usaEmployerIdentificationNumbe": "USA: Arbeidsgiveridentifikasjonsnummer (EIN)",
    "other": "Annen/annet",
    "israelRegistrationNumber": "Israel: Registreringsnummer",
    "estoniaVatNumber": "Estland: MVA-nummer",
    "cooperative": "Kooperativ",
    "corporation": "Bedrift",
    "limitedLiabilityCompanyOr": "Aksjeselskap eller enkeltpersonforetak",
    "nonprofitCorporation": "Ideell organisasjon",
    "partnership": "Partnerskap",
    "ceo": "CEO",
    "cfo": "CFO",
    "director": "Direktør",
    "generalCounsel": "Generell rådgiver",
    "onlineTrainingEducation": "Online opplæring og utdanning",
    "financialServices": "Finansielle tjenester",
    "fitnessLifestyle": "Fitness og livsstil",
    "healthMedical": "Helse og medisin",
    "homeServices": "Hjemmetjenester",
    "legalServices": "Juridiske tjenester",
    "marketingAdvertising": "Markedsføring og annonsering",
    "others": "Andre",
    "realEstate": "Eiendom",
    "restaurants": "Restauranter",
    "retailEcommerce": "Detaljhandel og e-handel",
    "yourInformationHasBeen": "Informasjonen din er sendt inn.",
    "somethingWentWrong1": "Noe gikk galt",
    "newPassword": "Nytt passord",
    "proceedToLogin": "Gå videre til innlogging",
    "anyTime": "når som helst.",
    "callUsHighlevelSupport": "Ring HighLevel Support på",
    "troubleLoggingIn": "Problemer med å logge inn?",
    "sendSecurityCode": "Send sikkerhetskode",
    "sendCodeToEmail": "Send kode til e-post",
    "verifySecurityCode": "Bekreft sikkerhetskode",
    "privacyPolicy": "Personvernerklæring",
    "businessProfile": "Bedriftsprofil",
    "reserveWithGoogleIntegration": "Reserver med Google-integrasjon",
    "friendlyName": "Kallenavn",
    "updateCallerId": "Oppdater anroper-ID",
    "internationalFormat": "Internasjonalt format",
    "localFormat": "Lokalt format",
    "poolNumbers": "Puljenumre",
    "swappingNumbers": "Bytte av telefonnumre",
    "selectField": "Velg felt",
    "surveyAnalyze": "Analyser undersøkelse",
    "locationIsRequired": "Sted er obligatorisk.",
    "newSurveyName": "Nytt navn på spørreundersøkelse",
    "copySurvey": "Kopier spørreundersøkelse",
    "primaryCalendar": "Primær kalender",
    "cloneEntityname": "Klone {entityName}",
    "youHaveSuccessfullySubmitted": "Du har sendt inn dokumenter",
    "addCustomValue": "Legg til egendefinert verdi",
    "value": "Verdi",
    "youHaveSuccessfullyDeleted": "Du har slettet pakken.",
    "bundleDeletedSuccessfully": "Pakken er slettet",
    "thereIsAnIssue": "Det er et problem med et av støttedokumentene dine. Se gjennom støttedokumentene og årsaken(e) til avslaget.",
    "connect1": "Koble til!",
    "itSeemsEitherThe": "Det ser ut til at enten Google-tilkoblingen er brutt, eller at den ikke er koblet til den nåværende plasseringen. Sjekk innstillingene for integrasjoner og integrer på nytt hvis tilkoblingen allerede eksisterer.",
    "selectPage": "Velge side",
    "somethingWentWrongPlease": "noe gikk galt, prøv igjen",
    "accept": "Godta",
    "moreThan1Phone": "Mer enn ett telefonnummer tillatt",
    "byContinuingToUse": "Ved å fortsette å bruke HighLevel-plattformen, godtar du disse nye {termsLink} og {privacyLink}.",
    "byContinuingToUse1": "Ved å fortsette å bruke HighLevel-plattformen, godtar du disse nye",
    "termsOfService": "Tjenestevilkår",
    "weHaveUpdatedOur": "Vi har oppdatert våre vilkår for bruk og personvernerklæring, så husk å sjekke dem!",
    "newTriggerName": "Navn på ny utløser",
    "triggerName": "Navn på utløser",
    "disableDndForSpecific": "Deaktiver DND for spesifikke kanaler",
    "selectAdAccount": "Velge annonsekonto",
    "selectAppointmentStatus": "Velg avtalestatus",
    "below1": "nedenfor.",
    "Required": "* påkrevd",
    "whenYouGetA": "Når du får en ny anmeldelse, legger vi den automatisk ut på Facebook-siden din. Husk at beste praksis er å publisere ikke mer enn 3 anmeldelser per dag på kontoen din.",
    "skip": "Hopp over",
    "copyShareLink": "Kopier delingslenke",
    "agencyRelationshipNumbers": "Byrårelasjonsnumre",
    "alteast1AgencyRelationship": "Minst ett byrårelasjonsnummer er påkrevd.",
    "alteast1SubaccountId": "Minst én underkonto-ID er påkrevd.",
    "somethingWentWrongWhile": "Noe gikk galt under lagringen. Prøv igjen senere.",
    "5PerPage": "5 per side",
    "10PerPage": "10 per side",
    "amountMustGreaterOr": "Beløp må være større enn eller lik 1 dollar AUD.",
    "regions": {
      "africa": "Afrika",
      "asia_pacific": "Asia / Stillehavet",
      "europe": "Europa",
      "latin_america": "Latin-Amerika",
      "usa_and_canada": "USA og Canada",
      "asia": "Asia",
      "latinAmerica": "Latin-Amerika",
      "usaCanada": "USA og Canada"
    },
    "expandIcon": "►",
    "noEntriesToShow": "Ingen oppføringer å vise",
    "clear": "Fjern",
    "filter": "Filtrere",
    "test": "Test",
    "createNewTwilioSubAccountText": "Du må opprette en ny Twilio-konto, oppdatere legitimasjonen for denne kontoen under Twilio-innstillinger og flytte telefonnumre før du aktiverer omfakturering.",
    "viewing": "Visning",
    "makeSmsCompliantByAddingASenderInformation": "Gjør SMS kompatibel ved å legge til avsenderinformasjon.",
    "makeEmailCompliantByAddingAnUnsubscribeLinkInYourEmail": "Gjør e-posten kompatibel ved å legge til en avmeldingslenke i e-posten",
    "enableMissedCallTextBack": "Aktivere tekstmelding ved tapt anrop",
    "productInventory": "Produktbeholdning",
    "viewProductVariants": "Se produktvarianter",
    "smtpSettings": "SMTP-innstillinger",
    "locationOPMTrafficStatis": "Plassering OPM trafikkstatistikk",
    "locationGPMTrafficStatis": "Plassering GPM trafikkstatistikk",
    "blacklistMonitorReports": "Svartelisteovervåkingsrapporter",
    "twoFactorAuthentication": "Tofaktorautentisering (2FA)",
    "recent": "Nylig",
    "noPermission": "Du har ikke tillatelse til å administrere maler for dette produktet. Omdirigerer til dashbordet.",
    "tasksNowHave": "Oppgaver har nå",
    "option": "Alternativ",
    "facebookAdsReporting": "Facebook Ads-rapportering",
    "googleAdsReporting": "Google Ads-rapportering",
    "adsDatePicker": "Annonse-datovelger",
    "feedbackSubmitBtn": "Tilbakemeldingsknapp for innsending",
    "ifYouThinkMistakePleaseContact": "Hvis du tror dette er en feil, kontakt",
    "forResolution": "for en løsning.",
    "live": "Direkte",
    "payouts": "Utbetalinger",
    "greatChoice": "Godt valg!",
    "toNavigate": "å navigere",
    "teams": "Grupper",
    "role": "Rolle",
    "searchAccounts": "Søk etter kontoer",
    "searchByNameEmailPhone": "Søk etter navn, e-post eller telefon",
    "addEmployee": "Legg til ansatt",
    "removeFromLocation": "Fjern fra underkonto",
    "knowMore": "Finn ut mer",
    "usingNumberPool": "Bruke nummerpulje",
    "numbers": {
      "zero": "0",
      "one": "1"
    },
    "multiplier": "x",
    "reviewer": "Anmelder",
    "cancel1": "Avbryt",
    "delete1": "Slett",
    "call1": "Ring",
    "message1": "Melding",
    "name1": "Navn",
    "voicemail1": "Telefonsvarer",
    "title1": "Tittel",
    "choose_one": "Velg en …",
    "select_page": "Velg side",
    "confirm1": "Bekreft",
    "conversations1": "Samtaler",
    "copied1": "Kopiert",
    "timeOfDay": {
      "am": "AM",
      "pm": "PM"
    },
    "back1": "Tilbake",
    "details1": "Detaljer",
    "month1": "/måned",
    "select1": "Velg",
    "share1": "Del",
    "facebook1": "Facebook",
    "sidebar": {
      "blacklistMonitorReports": "Svartelisteovervåkingsrapporter",
      "domainPurchase": "Domenekjøp"
    },
    "confirmDelete": "Er du sikker på at du vil slette {name}?",
    "clicked1": "Klikket på",
    "delivered1": "Levert",
    "invalid1": "Ugyldig",
    "open_options": "Åpne alternativer",
    "_add_account": "Legg til konto",
    "setTimezoneWarning": "Angi tidssone for din underkonto for å få riktige ledige tider.",
    "save1": "Lagre",
    "action1": "Handling",
    "actions1": "Handlinger",
    "all1": "Alle",
    "previous1": "Forrige",
    "results1": "Resultater",
    "next1": "Neste",
    "payments1": "Betalinger",
    "settings1": "Innstillinger",
    "total_js_heap": "Total JS Heap",
    "table": {
      "pagination": {
        "previous": "Forrige",
        "next": "Neste"
      },
      "rowsSelected": "{count} rader valgt",
      "cantRearrange": "{type} kan ikke omorganiseres"
    },
    "ivrCall": "IVR-anrop",
    "sms": "SMS",
    "username": "Brukernavn",
    "stay": "Fortsett",
    "placeholders": {
      "selectCountry": "Velg landet ditt",
      "nameOfBusiness": "Bedriftsnavn",
      "line1": "Linje 1",
      "line2": "Linje 2",
      "enterState": "Skriv inn delstat",
      "enterCity": "Skriv inn by",
      "enterPostalCode": "Skriv inn postnummer",
      "chooseCountry": "Velg land …"
    },
    "addressLine1": "Adresselinje 1",
    "addressLine2": "Adresselinje 2",
    "postalCode": "Postnummer",
    "nameOfBusiness": "Bedriftsnavn",
    "dispute_this_review": "Bestrid denne anmeldelsen",
    "story_mention": "Omtale av historien",
    "story_reply": "Svar på historien",
    "no": "Nei",
    "yes": "Ja",
    "annual": "årlig",
    "plan": "Plan",
    "errors": {
      "somethingWrong": "Noe gikk galt"
    },
    "zero": "0",
    "perMonth": "per måned",
    "emailCheckLinks": "Sjekk lenkene der du har en tilpasset verdi. Det er en ekstra \"%20\" mellom {{ og custom_values.",
    "fileSizeTooLarge": "Filstørrelsen er større enn 5 MB",
    "fileSizeTooLargeDescription": "Filen du prøver å laste opp er for stor. Prøv med en mindre filstørrelse.",
    "minMaxLength40Characters2048Characters": "Min. lengde: 40 tegn. Maks. lengde: 2048 tegn.",
    "sampleMessage2": "Eksempelmelding #2*",
    "pleaseSelectWorkflow": "Velg en arbeidsflyt",
    "childrens": "Barn",
    "brandAndCampaignRegistration": "Merkevare- og kampanjeregistreringsavgift på $20,95 belastes én gang. En ekstra kampanjeavgift på opptil $2,25 per måned vil påløpe i henhold til TCR-reglene.",
    "einRequiredForRegistration": "EIN er påkrevd for registrering",
    "changed_props": "Endrede rekvisitter",
    "total_memory": "Totalt minne",
    "total_store_size": "Total butikkareal",
    "total_watchers": "Totalt antall seere",
    "update_count": "Oppdateringsantall"
  },
  "contacts": {
    "bulkRequests": {
      "bulkActions": "Massehandlinger",
      "clickHere": "Klikk her for å se listen over massehandlinger.",
      "mergedMessage": "Denne siden er slått sammen med listen over massehandlinger.",
      "title": "Kontaktforespørsler"
    }
  },
  "conversations": {
    "noConversationsFound": "Ingen {status} samtaler funnet",
    "create_new": "Opprett ny melding​",
    "validations": {
      "minCharsRequired": "Minimum 3 tegn er påkrevd",
      "twoMoreCharsRequired": "2 tegn til er påkrevd",
      "oneMoreCharRequired": "1 tegn til er påkrevd"
    },
    "sortLabels": {
      "latestAllMessages": "Nyeste – Alle meldinger",
      "oldestAllMessages": "Eldste – Alle meldinger",
      "latestManualMessages": "Nyeste – Manuelle meldinger",
      "oldestManualMessages": "Eldste – Manuelle meldinger",
      "latestAll": "Nyeste – Alle",
      "oldestAll": "Eldste – Alle",
      "latestManual": "Nyeste – Manuelt",
      "oldestManual": "Eldste – Manuelt",
      "highToLow": "{name} (høy til lav)",
      "manualMessagesTooltip": "Sorteringsalternativet vil gjelde for meldinger etter 18. mai 2023."
    },
    "deleteConversation": {
      "title": "Bekreftelse",
      "confirmWithName": "Er du sikker på at du vil slette samtalen med {name} permanent? Dette kan ikke angres.",
      "confirmWithoutName": "Er du sikker på at du vil slette denne samtalen permanent? Dette kan ikke angres."
    },
    "makeCall": {
      "enterPhoneNumber": "For å ringe, skriv inn et telefonnummer i dette feltet.",
      "invalidPhoneNumber": "Twilio Lookup markerte dette telefonnummeret som ugyldig."
    },
    "actions": {
      "markAsStarred": "Merk som stjernemerket",
      "unarchive": "Fjern arkivering",
      "unmarkAsStarred": "Fjern merking som stjernemerket"
    },
    "send": {
      "perMonthPerIp": "/ Måned / IP",
      "perIp": "/ IP",
      "replyingTo": "Svarer på",
      "requestClientsPaymentDetails": "Be om kundens betalingsdetaljer",
      "saasModeCreditCardRequired": "SaaS-modus krever at det er et kredittkort registrert for kunden.",
      "please": "Vennligst",
      "firstBeforeEnablingSaaS": "først før du aktiverer SaaS-modus.",
      "shareALink": "Del en lenke",
      "shareLinkInstructions": "Del en lenke med kunden for å samle inn betalingsopplysningene deres",
      "requestViaEmail": "Forespørsel via e-post",
      "twilioRebillingDescription": "Omfakturer Twilio-kostnader ({twilioCopy}) til kundene dine og inkluder et påslag",
      "seeHow": "Se hvordan",
      "phoneRebillingCardInfoRequired": "Telefonomfakturering krever at kortinformasjon er lagret for kunden.",
      "clientsCompanyBillingPage": "faktureringsside for kundens bedrift",
      "ifYouPayForTwilioKeepUsing": "Hvis du betaler for Twilio, kan du fortsette å bruke den samme Twilio-kontoen",
      "ifClientPaysForTwilioCreateNew": "Hvis kunden betaler for Twilio, oppretter du en ny Twilio-konto",
      "learnHow": "Lær hvordan",
      "createNewTwilioAccountInstructions": "Opprett en ny Twilio-konto for denne lokasjonen",
      "learnHowToMovePhoneNumbers": "Lær hvordan du flytter telefonnumre",
      "thisIsMyClientsTwilioCreateNew": "Dette er min kundes Twilio. Opprett en ny konto",
      "featureUnderDevelopment": "Denne funksjonen er under utvikling",
      "emailRebillingDescription": "Omfakturer e-postkostnader til kundene dine og inkluder et påslag",
      "emailRebillingCardInfoRequired": "Omfakturering av e-post krever kortinformasjon som er registrert for kunden.",
      "emailRebillingMarginsDescription": "Dette er marginer som faktureres til kundene dine utover e-postkostnadene",
      "provider": "Leverandør",
      "morePlanCustomizationsAvailable": "Flere tilpasninger av planer tilgjengelig",
      "plansAndPricing": "Abonnementer og priser",
      "connectYourStripeAccountFirst": "Koble til Stripe-kontoen din først",
      "createRecommendedPlansOnStripe": "Opprett anbefalte planer på Stripe",
      "createdPlanInStripe": "Opprettet plan i Stripe",
      "customizeYourSaasPlans": "Tilpass SaaS-planene dine",
      "youCanOfferRecommendedPlansOrBuildYourOwn": "Du kan tilby anbefalte planer eller bygge dine egne",
      "trialPeriod": "Prøveperiode",
      "enterNumberOfDaysForTrial": "Angi antall dager for prøveversjonen",
      "nameCantBeEmpty": "Navnet kan ikke være tomt",
      "showStripeProductDetails": "Vis Stripe-produktdetaljer",
      "addEmail": "Legg til e-post",
      "resetMountCounts": "Tilbakestill antall monteringer",
      "connectReconnectGoogleForGbp": "Koble til eller koble til Google på nytt for GBP",
      "downloadFile": "Last ned dokument",
      "showOnlySlowQueries": "Vis kun trege forespørsler",
      "gmbMessagingAvailable": "GMB-meldinger er nå tilgjengelig",
      "reconnectGbpPageToEnable": "Koble til GBP-siden din på nytt for å aktivere meldinger",
      "failedPaymentsCheckBilling": "Mislykkede betalinger oppdaget. Sjekk faktureringen din.",
      "onlyAgencyAdminsCanSeeWarning": "Kun byråadministratorer kan se denne advarselen.",
      "filter": "Filtrer",
      "stopDeleteOperation": "Stopp slettingen",
      "summary": "Sammendrag",
      "enableTracking": "Aktiver sporing",
      "exportAll": "Eksporter alle",
      "newConversationStarted": "Ny samtale startet",
      "startNewConversation": "Start en ny samtale",
      "subAccountScheduledForDeletion": "Underkonto planlagt for sletting",
      "deleteSubAccountOnScheduledTime": "Slett underkonto på planlagt tidspunkt",
      "componentUpdatesDebuggerAlpha": "Feilsøkingsprogram for komponentoppdateringer (Alpha)",
      "componentUpdateTrackingDisabled": "Sporing av komponentoppdatering er deaktivert",
      "deleteSubAccount": "Slett underkonto",
      "subAccountHasNumbersAndCampaigns": "Denne underkontoen har {phoneNumberCount} telefonnummer og {campaignsCount} kampanjer.",
      "subAccountNoNumbersOrCampaigns": "Denne underkontoen har ingen telefonnumre eller kampanjer.",
      "areYouSureDeleteSubAccount": "Er du sikker på at du vil slette denne underkontoen?",
      "confirmDiscussedWithClient": "Jeg bekrefter at jeg har diskutert dette med min klient",
      "understandActionIrreversible": "Jeg forstår at denne handlingen er irreversibel",
      "confirmDisconnectCloseLcPhone": "Jeg bekrefter at jeg ønsker å koble fra og stenge LC Phone-kontoen",
      "choosingNotDeleteLcPhoneWarning": "Advarsel: Hvis du velger å ikke slette LC Phone-kontoen, vil du fortsette å bli belastet for telefonnumrene som er knyttet til denne underkontoen.",
      "deleteAccount": "Slett konto",
      "send": "Send",
      "typeMessage": "Skriv melding",
      "requestPayment": "Be om betaling",
      "reply": "Svar",
      "retry": "Prøv på nytt",
      "analyzeMemory": "Analyser minne",
      "memoryAnalysisApproximate": "🚧 Minneanalyse er omtrentlig og ikke 100 % nøyaktig.",
      "subAccountScheduledForDeletionItWillBeDeleted": "Denne underkontoen er planlagt for sletting. Den vil bli slettet innen",
      "youCanChangeYourMindBeforeThisTime": "Du kan ombestemme deg før dette tidspunktet.",
      "sms": {
        "errors": {
          "skipStayPrompt": "Hopp over",
          "cannotIdentifyContact": "Kan ikke identifisere kontakten og dens underkonto.",
          "contactNotSelected": "Kontakten er ikke valgt.",
          "messageRequired": "Sørg for at du har skrevet inn en melding eller valgt en mal.",
          "noPhoneNumber": "Kontaktpersonen har ikke noe telefonnummer.",
          "genericError": "{message}",
          "stayPrompt": "Fortsett"
        },
        "scheduledSuccess": "E-posten ble planlagt",
        "confirmDelete": "Er du sikker på at du vil slette {name}?"
      },
      "clear": "Fjern",
      "edit": "Rediger",
      "sendNow": "Send nå",
      "schedule": "Planlegg",
      "useTemplate": "Bruk en mal (utdrag)",
      "mergeFields": "Slå sammen felt",
      "customVariablesError": "Det er problemer i de egendefinerte variablene dine, og du må rette dem før du sender.",
      "sendLater": "Send senere",
      "scheduledFor": "Planlagt for {date}",
      "call": "Ring",
      "leftVoicemail": "La igjen en talebeskjed",
      "pleaseSelectCampaign": "Velg en kampanje",
      "whatsapp": {
        "no24HourMessage": "De kan kun sende malmeldinger utenfor 24-timersvinduet. Velg en mal for sending."
      },
      "attachFile": "Legg ved fil",
      "email": {
        "fromEmail": "Fra e-post",
        "fromName": "Avsenders navn",
        "smtpWarning": "SMTP-leverandører har noen begrensninger. Klikk her for å lese mer.",
        "subject": "Emne",
        "errors": {
          "cannotIdentifyContact": "Kan ikke identifisere kontakten og dens underkonto.",
          "contactNotSelected": "Kontakten er ikke valgt.",
          "genericError": "{message}",
          "bodyRequired": "E-posten krever en brødtekst for å kunne sendes.",
          "noEmailAddress": "Kontakten har ikke en e-postadresse."
        },
        "scheduledSuccess": "E-posten ble planlagt med suksess"
      },
      "addCalendarToSchedule": "Du må legge til en kalender for å begynne å planlegge avtaler.",
      "slotRequired": "Tidsluke er påkrevd",
      "teamMemberRequired": "Teammedlem er påkrevd."
    },
    "added": "lagt til",
    "loadMore": "Last inn mer",
    "admin": "Admin",
    "aiEmployee": {
      "popupBlockedAlert": "Du har deaktivert popup-vinduer. Tillat popup-vinduer for dette nettstedet slik at det automatisk kan viderekoble til Zoom-samtalen. Klikk på bli med nå for å gå direkte til Zoom-samtalen."
    },
    "alsoCloseAssociatedSubAccount": "Også nært tilknyttet",
    "analyzeMemory": "Analyser minne",
    "announcements": "Kunngjøringer",
    "apply": "Bruk",
    "appointment": {
      "pickDay": "Velg en dag",
      "pickSlot": "Velg et tidsrom for avtale",
      "selectDate": "Velg dato",
      "selectSlot": "Velg tidsluke",
      "slot": "Tidsrom",
      "day": "Dag"
    },
    "areYouReallySureDeleteSubAccount": "Er du helt sikker på at du vil slette denne underkontoen?",
    "areYouSureDeleteSubAccount": "Er du sikker på at du vil slette denne underkontoen?",
    "assignedContactOwner": "Tildelt ({contact} eier)",
    "assignedToMe": "Tildelt til meg",
    "audio": {
      "browserNotSupported": "Nettleseren din støtter ikke lydelementet.",
      "loadingTranscription": "Laster inn transkripsjon ...",
      "viewTranscript": "Se transkripsjon",
      "stop": "Stopp",
      "playPause": "Spill av/pause",
      "timePlayed": "Spilletid: Totaltid",
      "mute": "Slå av lyden",
      "playbackSpeed": "Avspillingshastighet",
      "download": "Last ned",
      "remove": "Fjern"
    },
    "automated": "Automatisert",
    "avatar": {
      "aiGenerated": "Denne meldingen ble generert av Conversation AI",
      "messengerAutomation": "Messenger-automatisering",
      "workflowGenerated": "Denne meldingen ble generert av arbeidsflythandling for Conversation AI",
      "messageByAI": "Denne meldingen ble generert av samtale-KI",
      "messageByWorkflow": "Denne meldingen ble generert av arbeidsflythandling for samtale-KI",
      "agentPrefix": "E-",
      "unknownFallback": "?"
    },
    "bePartOfFastestGrowingCommunity": "Bli en del av det raskest voksende fellesskapet.",
    "callHighlevelAt": "Ring HighLevel på +1(888)732-4197",
    "callQueueTooltip": "Dette anropet er i brukerens anropskø, og venter på å bli aktivert.",
    "callTranscript": "Samtaletranskripsjon",
    "clearFilters": "Fjern filtre",
    "clientsCompanyBillingPage": "faktureringsside for kundens bedrift",
    "closeChat": "Lukk chatten",
    "closeConversation": "Lukk samtalen",
    "component": {
      "dismissMessage": "AVVIS DENNE MELDINGEN",
      "unblock": "Fjern blokkeringen",
      "inboundDndActive": "Innkommende DND er aktivert for denne kontakten",
      "fetchOlderMessages": "Hent eldre meldinger",
      "conversationBegan": "Samtalen begynte",
      "celebrationTitle": "Flott! Samtalene flyr nå.",
      "celebrationBody": "Vi har bare så vidt begynt, så la oss utforske hvordan GHL kan bidra til å bygge opp virksomheten din.\nI mellomtiden kan du fortsette å sende meldinger så mye du vil"
    },
    "componentUpdateTrackingDisabled": "Sporing av komponentoppdateringer er for tiden deaktivert",
    "componentUpdatesDebuggerAlpha": "🚧 Komponentoppdateringsfeilsøker (Alpha) - Arbeid pågår",
    "confirmDelete": "Slette samtale(r)?",
    "confirmDeleteTextLine11": "Er du sikker på at du vil slette denne samtalen? Denne handlingen er irreversibel.",
    "confirmDeleteTextLine12": "samtaler valgt",
    "confirmDeleteTextLine21": "Denne handlingen er irreversibel. Vil du fortsatt gå videre?",
    "confirmDisconnectedAllIntegrations": "Jeg bekrefter at jeg har koblet fra alle integrasjonene som Twilio, Mailgun, GMB, domener, Facebook, Zoom osv.",
    "confirmStoppedAllAutomations": "Jeg bekrefter at jeg har stoppet alle automatiseringer i denne underkontoen",
    "connectReconnectGoogleForGbp": "Koble til / koble til Google-kontoen din igjen for å få GBP-meldinger!",
    "connectWithCertifiedAdmin": "Koble til en sertifisert administrator",
    "connectWithTeamForHelp": "Ta kontakt med vårt team for å få hjelp via en direktesendt videosamtale!",
    "connectWithUs": "Ta kontakt med oss",
    "connectZoomAccount": "Koble til Zoom-konto",
    "contactEngagementScore": "{contact} engasjementspoengsum",
    "dailyBrainstormingSessions": "Daglige idémyldringsøkter med HighLevel",
    "deleteAccount": "Slett konto",
    "deleteSubAccountOnScheduledTime": "Slett underkonto på planlagt tidspunkt",
    "disableSaasMode": "Deaktiver SaaS-modus",
    "dnd": {
      "configure": "KONFIGURER",
      "status": {
        "on": "PÅ",
        "partial": "Delvis"
      }
    },
    "editAppointment": {
      "updateButton": "Oppdater avtale",
      "scheduleAppointment": "Planlegg avtale",
      "editAppointment": "Rediger avtale",
      "calendar": "Kalender",
      "selectCalendar": "Velg kalender",
      "roundRobin": "Rotasjonsordning",
      "pickTeamMember": "Velg teammedlem",
      "selectTeamMember": "Velg teammedlem",
      "teamMemberRequired": "Teammedlem er påkrevd",
      "slotRequired": "Tidsrom er obligatorisk",
      "appointmentTitle": "Avtaletittel",
      "appointmentTitleTooltip": "Dette kan stå tomt, hvis du velger å bruke den forhåndskonfigurerte avtaletittelen",
      "contactName": "Kontaktnavn",
      "name": "Navn",
      "nameRequired": "Navn er obligatorisk.",
      "emailAddress": "E-postadresse",
      "phoneNumber": "Telefonnummer",
      "phoneNumbers": "Telefonnumre",
      "dateOfBirth": "Fødselsdato",
      "contactTimezone": "Kontakttidssone (brukes til påminnelse)",
      "chooseOne": "Velg en …",
      "meetingLocation": "Møtested",
      "meetingLocationTooltip": "Dette kan stå tomt, hvis du velger å bruke det forhåndskonfigurerte møtestedet",
      "status": "Status",
      "appointmentStatus": "Avtalestatus",
      "additionalNotes": "Tilleggsnotater",
      "notes": "Notater",
      "actionRequired": "Handling er påkrevd",
      "confirmed": "Bekreftet",
      "invalid": "Ugyldig",
      "cancelled": "Avlyst",
      "showed": "Vist",
      "noShow": "Manglende oppmøte",
      "busy": "Opptatt",
      "free": "Gratis",
      "noCalendarMessage": "Du må legge til en kalender for å begynne å planlegge avtaler."
    },
    "email": {
      "errors": {
        "bodyRequired": "E-posten krever en brødtekst for å kunne sendes.",
        "cannotIdentifyContact": "Kan ikke identifisere kontakten og dens underkonto.",
        "contactNotSelected": "Kontakten er ikke valgt.",
        "noEmailAddress": "Kontakten har ingen e-postadresse."
      },
      "thread": {
        "failedToFetch": "Kunne ikke hente innholdet i e-posten",
        "forward": "Videresend"
      },
      "reply": "Svare",
      "share": "Dele",
      "facebook": "Facebook",
      "twitter": "Twitter",
      "addAccount": "+ Legg til konto",
      "respond": "Svar",
      "retry": "Prøv på nytt",
      "moreEmailsInThread": "{count} flere e-poster in tråden",
      "fromName": "Avsenders navn",
      "fromEmail": "Fra e-post",
      "subject": "Emne",
      "attachFile": "Legg ved filer",
      "useTemplate": "Bruk en mal (utdrag)",
      "requestPayment": "Be om betaling",
      "clear": "Fjerne",
      "sendNow": "Send nå",
      "schedule": "Planlegg",
      "send": "Send",
      "smtpWarning": "SMTP-leverandører har noen begrensninger. Klikk her for å lese mer.",
      "chooseOne": "Velg en …",
      "deliveredCount": "{delivered}/{total} er sendt",
      "typeMessage": "Skriv melding",
      "sendLater": "Send senere",
      "scheduledFor": "Planlagt for {date}"
    },
    "emailRebillingCardInfoRequired": "For å aktivere e-postfakturering må du legge inn kundens kortinformasjon på",
    "emailRebillingDescription": "Dette gjør at du kan viderefakturere e-postkostnader til kundene dine, og ta med et påslag.",
    "emailRebillingMarginsDescription": "Dette er marginer som faktureres til kundene dine utover e-postkostnaden du belastes",
    "enableTracking": "Aktiver sporing",
    "exploreHighlevelExperts": "Utforsk HighLevel-eksperter som kan hjelpe deg med å sette opp systemet, automatisere arbeidsflyter eller tilpasse prosjektet ditt.",
    "exportAll": "Eksporter alle",
    "facebook": {
      "errors": {
        "generalError": "Det oppstod en feil. Prøv igjen eller sjekk Facebook-integrasjonen. Feilmelding:",
        "noFacebookId": "Kontakten har ikke en Facebook-ID."
      }
    },
    "failedPaymentsCheckBilling": "Du har én eller flere mislykkede betalinger. Sjekk faktureringshistorikken din.",
    "fbMessengerDM": "FB Messenger DM",
    "filters": {
      "above": "Over",
      "aiActionLogs": "AI-handlingslogger",
      "inRange": "Innenfor rekkevidde",
      "invoice": "Faktura",
      "messageDirectionTooltip": "Filteret vil gjelde for meldinger etter 9. mai 23",
      "appointments": "Avtaler"
    },
    "followed": "Fulgt av",
    "followedByMe": "Fulgt av meg",
    "followedBySpecificUser": "Fulgt av en bestemt bruker",
    "follower": "Følger",
    "followerAssignmentContact": "Følger ({contact} oppgave)",
    "gbp": {
      "errors": {
        "generalError": "Det oppstod en feil. Prøv igjen, eller sjekk Google Business Profile-integrasjonen. Feilmelding:",
        "noGBPId": "Kontakten har ikke en GBP ID."
      }
    },
    "gbpChatNoLongerAvailable": "Google Business Profile Chat er ikke lenger tilgjengelig",
    "getAccessToHighlevelWelcomeCourse": "Få tilgang til HighLevel-velkomstkurset",
    "getPriorityTroubleshooting": "Få prioritert feilsøking, ekspertveiledning og direkte tilgang til vårt tekniske team via Slack.",
    "gmbMessagingAvailable": "Google Business-meldinger er tilgjengelig for kontoen din.",
    "googleMeet": "Google Meet",
    "googleReview": {
      "rating": "Rangering:",
      "replyDate": "Svarsdato:",
      "replyFrom": "Svar fra:",
      "review": "Gjennomgå",
      "reviewDate": "Dato for vurderingen:",
      "reviewFrom": "Vurdering fra:"
    },
    "highlevelEvents": "HighLevel-hendelser",
    "igMessengerDM": "IG Messenger DM",
    "includeSignatureBeforeQuotedText": "Inkluder denne signaturen før sitert tekst i svarene",
    "instagram": {
      "errors": {
        "generalError": "Det oppstod en feil. Prøv igjen eller sjekk Instagram-integrasjonen. Feilmelding:",
        "noInstagramId": "Kontakten har ikke en Instagram-ID."
      }
    },
    "joinOurFacebookGroup": "Bli med i Facebook-gruppen vår",
    "keepUpToDateWithLatestNews": "Hold deg oppdatert med alle de siste nyhetene og utgivelsene!",
    "lastMessageChannel": "Siste meldingskanal",
    "lastMessageDirection": "Siste meldingsretning",
    "lastOutboundMessageType": "Siste utgående meldingstype",
    "learnHow": "Lær hvordan?",
    "leftComment": "la igjen en kommentar",
    "leftPanel": {
      "recents": "Nyeste",
      "unread": "Ulest",
      "createNewMessage": "Opprett ny melding",
      "minCharsRequired": "Min. 3 tegn er påkrevd",
      "twoMoreCharsRequired": "2 tegn til er påkrevd",
      "oneMoreCharRequired": "1 tegn til er påkrevd"
    },
    "liveChat": {
      "endLiveChat": "Avslutt direktechat",
      "errors": {
        "generalError": "Det oppstod en feil. Prøv igjen eller sjekk Google My Business-integrasjonen. Feilmelding:"
      },
      "requestContact": "Be om kontakt"
    },
    "live_chat_message": "Live Chat-melding",
    "made": "laget",
    "memoryAnalysisApproximate": "🚧 Minneanalyse er omtrentlig og ikke 100 % nøyaktig.",
    "mentioned": "Nevnt til",
    "mentions": "Omtaler",
    "mentionsOfMe": "Omtale av meg",
    "mentionsOfSpecificUser": "Omtale av en bestemt bruker",
    "message": {
      "replyAll": "Svar alle",
      "details": "Detaljer",
      "reply": "Svare",
      "unsuccessful": "Mislykket",
      "pending": "Avventer",
      "inboundCall": "Innkommende anrop",
      "outboundCall": "Utgående anrop",
      "ivrCall": "IVR-anrop",
      "leftVoicemail": "La igjen en talebeskjed",
      "storyReply": "Svar på historien",
      "storyMention": "Historiens omtale",
      "replyAsDM": "Svar som DM",
      "newCommentOnPost": "Ny kommentar på {pageName} innlegget.",
      "goToPost": "Gå til innlegget",
      "replyNotAvailable": "Det er ikke mulig å svare som en privat DM for kommentarer som er eldre enn 7 dager.",
      "addToDocuments": "Legg til dokumenter",
      "attachmentsAddedSuccess": "Vedlegg ble lagt til dokumenter",
      "attachmentsAddedFailed": "Kunne ikke legge vedlegg til dokumentene",
      "reportFeedbackForAI": "Rapporter tilbakemelding for KI",
      "sms": "SMS"
    },
    "messageDetails": {
      "bcc": "BCC",
      "cancelScheduleConfirm": "Er du sikker på at du vil kansellere denne tidsplanen?",
      "cancelScheduledMessage": "Kansellere planlagt melding?",
      "cancelSend": "Kanseller sending",
      "cancelScheduledSuccess": "Planlagt melding ble kansellert",
      "cancelScheduledError": "Det oppstod en feil under kansellering av planlagt melding",
      "cc": "CC",
      "channel": "Kanal",
      "createdBy": "Opprettet av",
      "direction": "Retning",
      "emailCampaign": "E-postkampanje",
      "facebookMessage": "Facebook-melding",
      "instagramMessage": "Instagram-melding",
      "messageId": "Melding-ID",
      "messageIdLabel": "Meldings-ID: ",
      "trigger": "Utløser",
      "unanswered": "Ubesvart",
      "yes": "Ja",
      "messageDetails": "Meldingsdetaljer",
      "from": "Fra",
      "fromLabel": "Fra:",
      "to": "Til",
      "toLabel": "Til:",
      "unknown": "Ukjent",
      "unknownFrom": "Ukjent fra",
      "unknownTo": "Ukjent til",
      "unknownDirection": "Ukjent retning",
      "dateUnknown": "Ukjent dato",
      "emailFromUnknown": "E-post fra ukjent",
      "smsFromUnknown": "SMS fra ukjent",
      "callFromUnknown": "Anrop fra ukjent",
      "voicemailFromUnknown": "Telefonsvarer fra ukjent",
      "emailToUnknown": "E-post til ukjent",
      "smsToUnknown": "SMS til ukjent",
      "callToUnknown": "Anrop til ukjent",
      "voicemailToUnknown": "Talepost til ukjent",
      "failed": "Mislyktes",
      "datetime": "Dato og tid",
      "manual": "Manuell",
      "automation": "Automatisering",
      "workflow": "Arbeidsflyt",
      "campaign": "Kampanje",
      "bulkRequest": "Masseforespørsel",
      "delivered": "Levert",
      "bounced": "Avvist",
      "opened": "Åpnet",
      "sent": "Sendt",
      "scheduled": "Planlagt",
      "pageName": "Sidenavn",
      "gbpMessage": "GBP-melding",
      "no": "Nei",
      "eventsTrackedForContactOnly": "Hendelser registreres for øyeblikket kun for kontaktens e-postadresse.",
      "completed": "Fullført",
      "voicemail": "Telefonsvarer",
      "busy": "Opptatt",
      "pending": "Venter",
      "read": "Lest",
      "nativeIntegrations": "Native integrasjoner",
      "smtp": "SMTP",
      "twilio": "Twilio",
      "leadConnector": "LeadConnector",
      "email": "E-post",
      "sms": "SMS",
      "phoneCall": "Telefonsamtale",
      "voiceMail": "Telefonsvarer",
      "facebookMessenger": "Facebook Messenger",
      "instagramMessenger": "Instagram Messenger",
      "gbpMessenger": "GBP Messenger",
      "reviews": "Anmeldelser",
      "others": "Andre",
      "partialDetailsWarning": "Deler av informasjonen vil være tilgjengelig for meldinger før 15. juli 2022.",
      "agencySystem": "Byråsystem",
      "reply": "Svar"
    },
    "multiplePhone": {
      "chooseNumber": "Velg et nummer for å starte samtalen:",
      "continue": "Fortsett",
      "noPhones": "Ingen telefonnumre foreligger"
    },
    "myChat": "Min chat",
    "myInbox": "Innboksen min",
    "newConversationStarted": "Ny samtale startet",
    "newMessage": {
      "title": "Ny melding:",
      "errors": {
        "phoneRequired": "Telefonnummer er obligatorisk"
      }
    },
    "noConversationSelected": "Ingen samtale er valgt",
    "noResultsToShow": "Ingen resultater foreligger",
    "onboardingVideoTutorials": "Videoveiledninger om onboarding",
    "onlyAgencyAdminsCanSeeWarning": "Kun byråadministratorer kan se denne advarselen. For mer informasjon",
    "onlyVisibleToUsers": "Kun synlig for brukere",
    "perMonthPerIp": "/ måned / IP",
    "phone": {
      "call": "Ring {name}",
      "callingOptions": "{count} anropsalternativer",
      "phoneNumbers": "Telefonnumre",
      "callOptions": "{count} ringealternativer",
      "dndActive": "DND er aktiv for samtaler",
      "primary": "Primær"
    },
    "pleaseDisableSaasMode": "Deaktiver SaaS-modus for denne underkontoen",
    "pleaseSelectCampaign": "Velg en kampanje",
    "premiumSupport": "Premium support",
    "quickFilters": "Hurtigfiltre",
    "reconnectGbpPageToEnable": "Koble til GBP-siden din igjen for å aktivere det.",
    "replyAsDMTooltip": "Svar på denne kommentaren som en privat DM.",
    "replyingTo": "Svarer til",
    "resetMountCounts": "Tilbakestill antall monteringer",
    "review": {
      "errors": {
        "generalError": "Det oppstod en feil. Feilmelding:",
        "googleIntegrationError": "Det er ikke mulig å svare på den anmeldelsen. Det ser ut til å være en feil med Google-integreringen din. Koble den til på nytt under Innstillinger -> Integrasjoner.",
        "noReviewId": "Samtalen har ikke noe anmeldelses-ID."
      },
      "reviewPostTo": "Gjennomgå innlegg til {network}",
      "sharedOn": "Anmelding delt på {network}",
      "disputeReview": "Bestrid denne anmeldelsen",
      "learnHow": "(Lær hvordan?)",
      "seeOnGBP": "Se denne anmeldelsen på GBP",
      "alreadyShared": "Denne anmeldelsen er allerede publisert på {network}. Er du sikker på at du vil legge den ut på nytt?"
    },
    "reviewId": "Vurdering-ID",
    "schedule": {
      "sendSchedule": "Send timeplan",
      "timezone": "Tidssone ({heading})",
      "title": "Planlegg din {type}"
    },
    "scheduling": "Planlegger …",
    "seeHow": "Se hvordan",
    "selectFilter": "Velg filter",
    "selected": "utvalgt",
    "sendEmail": {
      "recipientPlaceholder": "mottaker@eksempel.com",
      "subject": "Tema:",
      "subjectPlaceholder": "E-postens emne",
      "to": "Til:",
      "sending": "Sender ...",
      "sendButton": "Send e-post"
    },
    "setupAccountWithFreeTutorials": "Opprett kontoen din med gratis veiledninger",
    "showOnlySlowQueries": "Vis kun langsomme spørringer (>{threshold}ms)",
    "sms": {
      "confirmSending": "Bekreft sending av melding",
      "editModal": {
        "compose": "Skriv SMS"
      },
      "errors": {
        "customVariablesIssue": "Det er problemer i de egendefinerte variablene dine, og du må rette dem før du sender.",
        "messageOrTemplateRequired": "Sørg for at du har skrevet inn en melding eller valgt en mal.",
        "noPhoneNumber": "Kontaktpersonen har ikke noe telefonnummer."
      },
      "scheduledSuccessfully": "SMS ble planlagt med suksess",
      "sendAnyway": "Send uansett",
      "spamWarning": "SMS-innholdet ditt kan inneholde referanser til Cannabis, SHAFT, Vape eller andre forbudte emner. Å sende slikt innhold via SMS er strengt forbudt, og kan føre til kontobegrensninger. Se nøye gjennom innholdet ditt før du fortsetter.",
      "send": "Send"
    },
    "startNewConversation": "Start en ny samtale",
    "subAccountAndDeleteAllPhoneNumbers": "underkonto og slett alle telefonnumrene",
    "subAccountScheduledForDeletion": "Denne underkontoen er planlagt for sletting",
    "subAccountScheduledForDeletionItWillBeDeleted": "Denne underkontoen er planlagt for sletting. Den vil bli slettet innen",
    "teamInbox": "Team-innboks",
    "threshold": "Terskel",
    "understandActionIrreversible": "Jeg forstår at denne handlingen er irreversibel, og at alle data i denne underkontoen vil gå tapt",
    "unstarred": "Fjernet stjerne",
    "use_a_template": "Bruk en mal",
    "userAvailability": "Brukernes tilgjengelighet",
    "userCalendarConfiguration": "Konfigurasjon av brukerkalender",
    "userInfo": "Brukerinformasjon",
    "userRoles": "Brukerroller",
    "viewSupportTickets": "Se dine supportforespørsler, våre støtteartikler og nyttige vanlige spørsmål!",
    "visitOurHelpCenter": "Besøk vårt Helpesenter",
    "welcomeCourse": "Velkommen til kurset",
    "whatsapp_logo": "WhatsApp-logo",
    "youCanChangeYourMindBeforeThisTime": "Du kan ombestemme deg før dette tidspunktet.",
    "zoomAccount": "Zoom-konto",
    "deleteEmails": "Slett {count} e-post(er)",
    "fileAttachment": {
      "urlNotFound": "URL-adressen finnes ikke",
      "unsupportedAttachment": "Disse vedleggene støttes kanskje ikke lenger.",
      "downloadFile": "Last ned fil"
    },
    "composer": {
      "internalComment": "Intern kommentar"
    },
    "dropdown": {
      "openOptions": "Åpne alternativer",
      "messageDetails": "Meldingsdetaljer"
    },
    "respond": "Svar",
    "selectTemplate": "Velg en mal",
    "settings": {
      "aiEmployeePromo": {
        "popupBlockedMessage": "Du har deaktivert popup-vinduer. Tillat popup-vinduer for at dette nettstedet automatisk skal viderekoble til Zoom-samtale. Klikk på Bli med nå for å gå direkte til Zoom-samtalen.",
        "helpAndSupport": "Hjelp og støtte",
        "summerOfAI": "Summer of AI"
      }
    },
    "celebration": {
      "dismiss": "Fjern",
      "body": "Vi har bare så vidt begynt, så la oss utforske hvordan GHL kan bidra til å bygge opp virksomheten din.\nI mellomtiden kan du fortsette å sende meldinger så mye du vil",
      "title": "Flott! Samtalene flyr nå."
    }
  },
  "cookies": {
    "thirdPartyWarning": {
      "helpArticle": "hjelpeartikkel her",
      "message": "Aktiver tredjeparts informasjonskapsler for å se denne siden på riktig måte. Du kan lese vår",
      "ok": "OK",
      "title": "Tredjeparts informasjonskapsler fungerer ikke"
    }
  },
  "crash": {
    "message": "Vi beklager, men noe uventet har skjedd. Prøv å oppdatere siden.",
    "refresh": "Oppdater side",
    "title": "Ups! Noe gikk galt"
  },
  "deleteLocation": {
    "abortModal": {
      "abortingDeletion": "Avbryter sletting for {name}",
      "confirmAbort": "Ja, kanseller",
      "keepDeleting": "Nei, fortsett å slette",
      "message": "Er du sikker på at du ønsker å kansellere?",
      "scheduledForDeletion": "Denne plasseringen er planlagt slettet den {date}",
      "title": "Kanseller sletting",
      "warning": "Merk: Underkontoen slettes på den planlagte datoen med mindre du avbryter slettingen."
    }
  },
  "fileUpload": {
    "dropzone": {
      "defaultMessage": "Slipp filene her for å laste opp",
      "uploadError": "Nettverksfeil: Kunne ikke sende forespørsel til AWS. (Kanskje CORS-feil)"
    }
  },
  "funnel": {
    "acceptShare": {
      "add": "Legg til {entityName}",
      "clonedMessage": "{entityName} er klonet! Bytt til en konto hvor den ble klonet, og finn den under {entityName}s fane.",
      "errorGettingDetails": "Det ser ut til å være en feil ved henting av detaljer for {entityName}. Kontroller URL-en eller prøv igjen.",
      "permissionError": "Tillatelsesfeil: Denne trakten er beskyttet og kan ikke opprettes her."
    }
  },
  "integrations": {
    "googleCalendar": {
      "logo": "GoogleCalendar-logo"
    },
    "printful": {
      "logo": "Printful-logo",
      "title": "Printful: Utskrift på forespørsel"
    },
    "printify": {
      "logo": "Printify-logo",
      "title": "Printify: POD"
    },
    "shipStation": {
      "logo": "ShipStation-logo",
      "title": "Shipstation"
    },
    "shippo": {
      "logo": "Shippo-logo",
      "title": "Shippo: Fraktintegrasjon"
    },
    "tikTok": {
      "accountNotConnected": "Konto er ikke tilkoblet",
      "accountNotConnectedMessage": "Kontoen er ikke koblet til TikTok-annonsekonto. Fullfør integreringen for å se skjemaer og kartfelter.",
      "advertiserId": "Annonsør-ID",
      "companyFields": "{companyName} felter",
      "editFields": "Rediger felter",
      "errorSubscribing": "Feil oppstå under opprettelse av abonnement på siden.",
      "formsNotAvailable": "Skjemaer er ikke tilgjengelige",
      "mandatoryFieldsNote": "Merk: Tilordne noen av følgende obligatoriske felt for å motta potensielle kunder i kontoen din. Felter: Fornavn, Etternavn, E-post, Telefonnummer",
      "noFormsMessage": "Du har for øyeblikket ikke opprettet noe leadgenereringsskjema i TikTok-annonsekontoen din. Besøk din TikTok-annonsekonto og opprett en for å komme i gang.",
      "pageId": "Side-ID",
      "selectAdvertiserAccount": "Velg annonsørkonto"
    }
  },
  "launchpad": {
    "duda": "Duda",
    "joomla": "Joomla",
    "otherOrIDontKnow": "Annet / Jeg vet ikke",
    "shopify": "Shopify",
    "squarespace": "SquareSpace",
    "weebly": "Weebly",
    "wordpress": "WordPress"
  },
  "location": {
    "suspend": {
      "instructionText": "Du må fullføre noen enkle trinn for å sette denne underkontoen på pause"
    },
    "transfer": {
      "chooseDescription": "Velg overføringsmetode",
      "chooseMethod": "Laste opp denne underkontoen",
      "eject": {
        "description": "Tjen 40 % gjentakende provisjon på abonnementet til den nye kontoen.",
        "title": "Opprett som ny konto"
      },
      "modal": {
        "confirmDetails": "Bekreft detaljene før overføring",
        "confirmNomineePrefix": "Utpek eier for",
        "confirmTransfer": "Bekreft overføring",
        "consentText": "Jeg har lest og forstått veiledningen ovenfor, og samtykker til alle begrensningene",
        "ejectErrorTitle": "Kan ikke utløse underkontoen.",
        "ejectGenericError": "Underkontoen du prøver å fjerne, kan ikke kastes ut. Kontakt kundestøtte.",
        "ejectGuidelines": "Retningslinjer for utkasting av underkontoer",
        "ejectSubject": "Kastes underkontoen ut, forutsettes det at brukeren godtar forespørselen om å opprette et nytt byrå.",
        "ejectSuccessTitle": "Forespørsel om å fjerne underkonto er sendt til valgt bruker",
        "enterPassword": "Skriv inn passordet ditt for å lagre",
        "genericError": "Underkontoen du prøver å overføre, kan ikke overføres. Kontakt kundestøtte.",
        "guidelines": "Retningslinjer for overføring av underkontoer",
        "guidelinesConsent": "Les og gi tillatelse",
        "hipaaDisclaimer": "Ansvarsfraskrivelse",
        "hipaaText": "Det kan være lurt å informere denne underkontoen om at de får HIPAA-dekning i dag, men at de kanskje ikke får den samme dekningen i det byrået de blir overført til.",
        "noUsersDescription": "Der er ingen brukere tilknyttet denne underkontoen. Legg til en underkontobruker og fortsett videre.",
        "noUsersSearch": "Fant ingen brukere.",
        "noUsersTitle": "Fant ingen brukere",
        "nomineeInstructions": "Den utpekte vil få en lenke for å melde seg på HighLevel",
        "passwordError": "Ugyldig passord",
        "passwordErrorDescription": "Passordet du skrev inn er feil. Prøv igjen.",
        "relationshipError": "Skriv inn riktig relasjonsnummer",
        "relationshipNumber": "Mottakende byrås relasjonsnummer",
        "relationshipPlaceholder": "0-123-456",
        "requestTransfer": "Forespørsel om å laste opp",
        "seeAllRequests": "Se alle forespørsler",
        "successMessage": "Underkontoen vil bli overført når mottakende byrå aksepterer overføringsforespørselen din.",
        "successTitle": "Forespørsel om å overføre underkontoen er sendt til mottakende byrå.",
        "title": "Overfør underkonto",
        "transferSubject": "Overføring til underkonto forutsetter at det mottakende byrået aksepterer overføringen til sin konto.",
        "confirmNomineeSuffix": " til "
      },
      "transferExisting": {
        "description": "Overfør hele denne underkontoen til en annen konto.",
        "title": "Laste opp til en nåværende konto"
      }
    }
  },
  "marketing": {
    "bulkRequests": {
      "nextExecution": "Neste utførelse",
      "title": "Masseforespørsler"
    },
    "campaign": {
      "account": "Konto",
      "accountBuffer": "Kontobuffer",
      "accountBufferDescription": "Det er ingen begrensning på hvor mange mottakere som kan legges til i kampanjen hver dag (fra en liste).",
      "accounts": "Kontoer",
      "activity": "Aktivitet",
      "acquire": "Anskaffe",
      "acquisitionDescription": "Kundeanskaffelseskampanjer hjelper deg med å produsere flere \"varme\" potensielle salg som er klare til å engasjere seg.",
      "addEvent": "Legg til hendelse",
      "addUser": "Legg til bruker",
      "allMarket": "Hele markedet",
      "allowMultiple": "Tillat flere",
      "assignedToTooltip": "Når denne kampanjen startet, ble denne kontakten tildelt denne brukeren. Endringer i kontaktens Tilordnet til vil reflekteres på hendelsene, men vil ikke endre denne opprinnelige verdien.",
      "atLeastOneEvent": "Minst én hendelse er påkrevd.",
      "automations": "Automatiseringer",
      "automationsPlaceholder": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quas quaerat pariatur consequatur rerum neque a, id, nam nostrum iure accusantium magnam nemo perferendis eveniet quos perspiciatis molestiae explicabo reprehenderit nesciunt recusandae, quod distinctio vero et quia omnis? Corporis omnis, ipsa in, quae iste libero minus, voluptatem perferendis molestiae consectetur nam odio eligendi enim consequuntur! Quis ratione iure modi eos quaerat facere molestiae. Quaerat voluptatibus distinctio sed nisi aliquam, laboriosam laudantium fugiat dolores. Corporis suscipit modi corrupti. Delectus assumenda perspiciatis asperiores porro ipsam quaerat nesciunt provident sit non distinctio veritatis tempora omnis fugit dicta minima nisi aliquam ducimus rem, nobis cum.",
      "bounced": "Avvist",
      "buffering": "Bufring",
      "campaignActivity": "Kampanjeaktivitet",
      "campaignConfiguration": "Kampanjekonfigurasjon",
      "campaignConfigurationWarning": "Kampanjekonfigurasjon påvirker alle markeder. Sørg for at du må endre disse innstillingene.",
      "campaignCreation": "Opprettelse av kampanje",
      "campaignId": "Kampanje-ID",
      "campaignStatusByRecipients": "Kampanjestatus etter mottakere",
      "clickThroughRate": "Klikkfrekvens",
      "clickedThrough": "Klikkfrekvens",
      "conditionIfExplanation": "Kjør denne kampanjen eller hendelsen hvis det aktuelle tidspunktet faller innenfor dette vinduet. Hvis det aktuelle tidspunktet er utenfor dette vinduet, hopper du over kampanjen eller hendelsen og går videre til neste.",
      "conditionWhenExplanation": "Kjør hendelsene i denne kampanjen når det aktuelle tidspunktet faller innenfor dette vinduet, ellers venter du til neste vindu med å kjøre hendelsene.",
      "createCampaign": " Opprett kampanje",
      "ctr": "CTR",
      "customerAcquisition": "Kundeanskaffelse",
      "dateAdded": "Dato lagt til",
      "dateAddedTooltip": "Den eksakte datoen og klokkeslettet da kontakten ble lagt til denne kampanjen. Starttidspunktet for første hendelse kan variere avhengig av konfigurasjonene.",
      "deletedRestorePrompt": "Denne kampanjen er slettet! Ønsker du å gjenopprette den?",
      "delivered": "Levert",
      "deliveryRate": "Leveringsrate",
      "draftMode": "Utkastmodus",
      "draftModeDescription": "Denne kampanjen er et utkast. Den kan ikke brukes før den er publisert.",
      "dropped": "Droppet",
      "emailActivity": "E-postaktivitet",
      "emailActivityFilterExample": "E-postaktivitet: Klikkfrekvens",
      "event": "Hendelse",
      "eventFilterExample": "Hendelse: 10X E-post 4 (distribusjon av lister)",
      "filters": "Filtre",
      "emailPerformanceByAccount": "E-postytelse etter konto",
      "emailsNotSentOnDays": "E-post sendes ikke på lørdag, søndag.",
      "emailsSentOnDays": "E-poster vil bli sendt på mandag, tirsdag, onsdag, torsdag, fredag.",
      "eventStartDate": "Startdato for arrangementet",
      "exampleAddress": "801 7th Avenue North, Saskatoon, SK",
      "exampleCompanyName": "City Perks Coffehouse",
      "exampleDate": "8. mai 2017 kl. 13:27",
      "exampleEmail": "dstumph{'@'}vendasta.com",
      "exampleEmailDescription": "Sørg for at dataene ikke er eldre enn 30 dager",
      "exampleEventName": "10X E-post 4 (distribusjon av lister)",
      "getMoreCustomers": "Få flere kunder",
      "inProgress": "Pågår",
      "includedDays": "Inkluderte dager",
      "internalSource": "Intern kilde",
      "lastUpdate": "Siste oppdatering",
      "leadValuePlaceholder": "$ verdi av potensiell kunde",
      "loopDetected": "Denne kampanjen har blitt låst i utkaststatus fordi den forårsaker en loop. For å aktivere denne kampanjen, kontakt kundestøtte.",
      "market": "Marked",
      "moreDetails": "Flere detaljer",
      "myCampaigns": "Mine kampanjer",
      "na": "Uaktuelt",
      "newFolder": " Ny mappe",
      "nextCampaign": "Neste kampanje",
      "nextExecutionTime": "Neste utførelsestidspunkt",
      "opened": "Åpnet",
      "openRate": "Åpningsrate",
      "option2": "Alternativ 2",
      "option3": "Alternativ 3",
      "pageNavigation": "Eksempel på sidenavigering",
      "processed": "Behandlet",
      "published": "Publisert",
      "recipient": "Mottaker",
      "recipients": "Mottakere",
      "sampleCampaign": "Eksempel på kampanje ",
      "scheduling": "Planlegging",
      "seeHotLeads": "Se varme potensielle kunder",
      "selectDateRange": "Velg datoperiode",
      "selectTimeZone": "Velg tidssone",
      "separator": " / ",
      "showingCount": "Viser {current} av {total}",
      "spamReport": "Søppelpost-rapport",
      "startByAddingEvent": "Start med å legge til en hendelse i denne kampanjen.",
      "stopOnResponse": "Stopp ved svar",
      "stopped": "Satt på pause",
      "time": "Tid",
      "timeConditionNote": "Merk: Hvis det første trinnet i kampanjer er satt til \"Umiddelbart\", gjelder ikke tidsbetingelsen for det første trinnet.",
      "timeZoneDescription": "Denne innstillingen påvirker tidspunktet innholdet ditt blir sendt.",
      "totalLeads": "Totalt antall potensielle kunder",
      "undeliverable": "Ikke leverbar",
      "unsubscribe": "Avslutt abonnement",
      "upNext": "Neste",
      "utc": "UTC",
      "window": "Vindu"
    },
    "embed": {
      "copyLinkInstructions": "Kopier lenken nedenfor og del den enkelt hvor du måtte ønske.",
      "embed": "Sett inn",
      "iframeEmbed": "Iframe innebygd",
      "integrateInstructions": "Bruk følgende alternativer for å integrere ditt egendefinerte skjema på nettstedet ditt",
      "integrateYourForm": "Integrer skjemaet ditt",
      "link": "Lenke",
      "saveAndExit": "Lagre og avslutt"
    },
    "jotbox": {
      "deleteSubmission": "Slett innlevering",
      "downloadPdf": "Last ned PDF",
      "ofSubmissions": " av {total} innsendelser",
      "pages": "sider",
      "records": "oppføringer",
      "searchPlaceholder": "Søk etter navn, e-post, telefon og kontakt-ID",
      "selectYourForm": "Velg skjema",
      "timeSigned": "Tid signert:",
      "totals": "Totalt:"
    },
    "survey": {
      "createNewSurvey": "Opprett ny undersøkelse",
      "integrateYourSurvey": "Integrer spørreundersøkelsen din",
      "noSurveysForAnalyze": "Du har ingen spørreundersøkelse ennå. Opprett spørreundersøkelsen først for å se analysen her.",
      "noSurveysForSubmission": "Du har ingen spørreundersøkelse ennå. Opprett undersøkelsen først for å se innsendingen her.",
      "noSurveysYet": "Du har ingen spørreundersøkelse ennå.",
      "refreshData": "Oppdater data",
      "searchSurveys": "Søk i spørreundersøkelser",
      "surveyBuilder": "Undersøkelsesbygger",
      "toCreateFirstSurvey": "for å lage din første spørreundersøkelse."
    }
  },
  "membership": {
    "acceptShare": {
      "clonedMessage": "Produkt klonet! Bytt til en konto der det ble klonet, og finn det under fanen Medlemskap > Produkter.",
      "errorGettingDetails": "Det ser ut til å være en feil ved henting av produktdetaljer. Kontroller URL eller prøv igjen."
    },
    "resetPassword": {
      "title": "Tilbakestill passord",
      "button": "Tilbakestill passord",
      "newPassword": "Nytt passord",
      "generateStrongPassword": "Generer et sterkt passord",
      "sendEmailNotification": "Send også et e-postvarsel.",
      "errorMessage": "Det oppsto en feil under tilbakestilling av passordet. Prøv igjen.",
      "updating": "Oppdaterer ..."
    }
  },
  "notifications": {
    "psBubble": {
      "byText": "⚡ av",
      "combo": {
        "signedUp": "registrert seg for ProveSource i løpet av de siste 24 timene",
        "verifiedBy": "verifisert av "
      },
      "conversions": {
        "recentlyBought": "kjøpte nylig denne",
        "timeAgo": "i løpet av de siste 16 minuttene ",
        "visitorsCount": "50 besøkende"
      },
      "pageVisits": {
        "description": "ser også ut til å være sultne.",
        "timeAgo": "i løpet av de siste 21 minuttene                        ",
        "title": "50 matelskere"
      },
      "proveSource": "ProveSource",
      "review": {
        "proofMessage": " ProofMessge",
        "rating": "5-stjerners rangering",
        "recently": "Nylig",
        "reviewerName": "Varun Vairavan",
        "starIcon": "⚡"
      },
      "stream": {
        "action": "registrerte seg for ProveSource",
        "location": "(London, Storbritannia)",
        "name": "Mike ",
        "timeAgo": "40 minutter siden                        "
      },
      "visitors": {
        "description": "musikkelskere på nett"
      }
    },
    "step1": {
      "combo": {
        "description": "Vis det totale antallet personer som har utført en bestemt handling i løpet av 24 timer, 7 eller 30 dager.",
        "title": "Kombinasjon"
      },
      "conversions": {
        "description": "Skap sosial validering ved å vise hvor mange kunder som har utført en bestemt handling."
      },
      "liveReviews": {
        "description": "Vis de besøkendes 4+-stjerners anmeldelser i sanntid fra de siste 6 månedene."
      },
      "liveVisitors": {
        "beta": "Beta",
        "description": "Vis hvor mange besøkende som for øyeblikket ser på hele nettstedet ditt i sanntid."
      },
      "pageVisits": {
        "description": "Vis de besøkende at de ikke er de eneste på festen ved å fremheve nylige sidebesøk."
      },
      "stream": {
        "description": "Hva er vel bedre enn å sette et ansikt på det sosiale beviset? Vis dine siste kunder og deres handlinger."
      }
    },
    "step2": {
      "captureDescription2": "Hver side-URL må ha et felt for e-postskjema",
      "captureDescription3": " og ProveSource installert. ",
      "comboType": "Kombinasjonstype",
      "connectAccounts": "Sørg for å koble til kontoene du ønsker å hente anmeldelser fra",
      "connectGoogleAccount": "Koble til underkontoens Google-konto",
      "formSubmissions": "Skjemainnsendinger",
      "googleAccount": "Google-konto",
      "howToTrack": "Slik sporer du",
      "howToTrackDescription": "Hvordan skal vi spore konverteringene dine?",
      "pageUrl": "Side-URL",
      "productPurchase": "Kjøp av produkt",
      "trackAllUrls": "Spor alle URL-adresser som inneholder følgende uttrykk. ",
      "trackVisitors": "Spor besøkende",
      "trackVisits": "Spor besøk",
      "urlTip": " Vi behandler http://, https://, www og ikke-www som separate versjoner av URL-adressen og siden. ",
      "urlValidationError": "Du må inkludere minst én URL. URL-adressen er ugyldig. Sørg for å inkludere http:// eller https://",
      "userSignup": "Brukerregistrering",
      "visits": " Besøk",
      "webhookDescription": "Ring følgende endepunkt for å gi oss beskjed om en hendelse eller konvertering som har skjedd på din side og som er relatert til dette varselet, så tar vi oss av resten.",
      "webhookRequest": "Webhook-forespørsel",
      "whatToTrack": "Hva ønsker du å spore?",
      "whereToCapture": "Sted for innsamling",
      "whereToCaptureDescription": "Hvor fanger du opp konverteringer?",
      "whichPagesToTrack": "Hvilke sider vil du at vi skal spore?",
      "yourWebhookUrl": "Din Webhook-URL"
    },
    "step3": {
      "allPages": " Alle sider",
      "displayOnAllPages": "Vis på alle ULR-adresser som inneholder følgende uttrykk: ",
      "whereToDisplay": "Hvor det skal vises",
      "whereToDisplayActivity": "Hvor ønsker du at vi skal vise denne aktiviteten?"
    },
    "step4": {
      "icons8": "Icons8.com",
      "icons8Instructions": "for å få fine ikoner (høyreklikk på et ikon -> Kopier bildeadresse)",
      "messageSettings": "Meldingsinnstillinger",
      "messageText": "Meldingstekst",
      "referToVisitorsAs": "Henvis til besøkende som",
      "visitIcons8": "Besøk"
    },
    "step5": {
      "allowUsersToClose": " Tillat brukere å lukke varselet ",
      "behavior": "Atferd",
      "bottomLeft": "Nederst til venstre",
      "bottomRight": "Nederst til høyre",
      "clickableNotification": " Klikkbar varsling ",
      "customizeDescription": "Endre de følgende innstillingene for å kontrollere oppførselen og utseendet til varslingen din",
      "design": "Design",
      "displayNotificationFor": "Vis varsel for",
      "displayRules": "Visningsregler",
      "hideOnMobileScreens": " Skjul på mobilskjermer ",
      "linkRelativeNote": " Hvis http:// utelates, åpnes lenken relativt til siden som vises ",
      "minimumEventsToDisplay": "Minimum hendelser som skal vises",
      "notificationLink": "Varslingslenke",
      "notificationPosition": "Varselposisjon",
      "openLinkInNewTab": "Åpne lenke i ny fane",
      "selectPosition": "Velg posisjon",
      "showOnlyOncePerSession": " Vis bare én gang per økt ",
      "titleBackground": "Tittelbakgrunn",
      "titleColor": "Tittelfarge",
      "topLeft": "Øverst til venstre",
      "topRight": "Øverst til høyre",
      "typeUrlHere": "Skriv inn URL her"
    },
    "step6": {
      "identifyNotification": "Identifiser varslingen din",
      "launchMessage": "Vi er i ferd med å starte. Sett deg ned og fest sikkerhetsbeltet.",
      "notificationName": "Varselnavn",
      "notificationNamePrompt": "Hva er navnet på varselet ditt?",
      "wellDone": "Bra jobbet."
    },
    "wordpress": {
      "subscriptionCreatedSuccessfully": "Abonnement opprettet med suksess",
      "youCanNowSetupWordPress": "Nå kan du sette opp WordPress-siden din",
      "subscriptionFailed": "Abonnement mislyktes",
      "resubscriptionSuccessful": "Gjentatt abonnement vellykket",
      "successfullyReactivated": "WordPress-abonnementet ditt har blitt reaktivert",
      "reactiveSub": "Kan ikke reaktivere abonnementet",
      "resubscriptionFailed": "Gjentatt abonnement mislyktes"
    },
    "v2": {
      "viewDetails": "Vis detaljer",
      "chatConversationAssigned": "Chatsamtale tildelt",
      "internalChat": "Intern chat",
      "newTask": "Ny oppgave",
      "appointmentReminder": "Avtalepåminnelse",
      "facebookReview": "Facebook-anmeldelse",
      "googleReview": "Google-anmeldelse",
      "internalChatMessage": "Intern chatmelding",
      "newAppointmentAssigned": "Ny avtale tildelt",
      "newAppointmentBooked": "Ny avtale bestilt",
      "newCall": "Nytt anrop",
      "newEmail": "Ny e-post",
      "newMention": "Ny omtale",
      "newReviewReceived": "Ny anmeldelse mottatt fra {contactName}",
      "taskReminder": "Oppgavepåminnelse",
      "completed": "fullført",
      "failed": "mislyktes",
      "subAccount": "Underkonto",
      "newMessage": "Ny melding",
      "newAppointmentBookedWith": "Ny avtale er bestilt med {contactName}",
      "newAppointmentAssignedTo": "Ny avtale er tildelt til {contactName}",
      "appointmentDueIn": "Avtale forfaller om {minutes} minutter med {contactName}",
      "newTypeReceived": "Ny {type} mottatt fra {contactName}.",
      "newChatAssigned": "Ny chat er tildelt fra {contactName}",
      "taskDueDate": "Oppgave '{title}' forfaller {date} kl. {time} for {contactName}",
      "tasksDueToday": "{count} oppgaver forfaller i dag",
      "tasksOverdue": "{count} forsinkede oppgaver",
      "taskDueIn": "Oppgave '{title}' forfaller om {dueTime} {unitOfTime} for {contactName}",
      "mentionedInConversation": "{userName} nevnte deg i en samtale med {contactName}",
      "now": "nå"
    }
  },
  "onboarding": {
    "landscapeMode": {
      "altTexts": {
        "logo": "Firmalogo"
      },
      "bestExperience": "beste opplevelsen.",
      "optimizedFor": "Denne siden er optimalisert for",
      "portraitMode": "stående modus",
      "toGiveYou": "for å gi deg den"
    }
  },
  "pagination": {
    "goToFirstPage": "Gå til første side",
    "goToLastPage": "Gå til siste side",
    "goToNextPage": "Gå til neste side",
    "goToPreviousPage": "Gå til forrige side",
    "itemsSelected": "{count} valgte elementer",
    "showingEntries": "Viser {from} til {to} av {total} oppføringer"
  },
  "pmd": {
    "0": "0",
    "10": "10",
    "_min": "/ min",
    "_please_add_a_payment_method_for": "Legg til en betalingsmetode for",
    "_segment": "/ segment",
    "ad_manager": "Annonsebehandler",
    "add": "[LEGG TIL:",
    "ai_employee": "AI-ansatt",
    "billing": {
      "incompleteBillingInfo": "Du har ufullstendig faktureringsinformasjon på denne kontoen. Oppdater den umiddelbart.",
      "updateNow": "Oppdater nå"
    },
    "charge": "Kostnad",
    "contactLimit": {
      "message": "Du har nådd grensen for å legge til {contact} i nåværende abonnement. Hvis du vil fortsette, må du oppgradere abonnementet ditt og låse opp ekstra kapasitet.",
      "upgradeNow": "Oppgrader nå",
      "warningMessage": "Du har {current} kontakt(er), mens abonnementet ditt bare tillater opptil {limit}.",
      "warningTitle": "Kontoens bruk er over grensen. Oppgrader for å fortsette å jobbe uavbrutt."
    },
    "cost_borne_by_you": "kostnader som du belastes",
    "dedicated_ip": "Dedikert IP",
    "electeditem": "valgtElement",
    "feedback": "Tilbakemelding:",
    "hello": "Hei",
    "helpDrawer": {
      "aiSupportAssistant": "AI-støtteassistent",
      "clickToCopy": "Klikk for å kopiere relasjonsnummer",
      "clickToCopyToClipboard": "Klikk for å kopiere relasjonsnummeret til utklippstavlen",
      "companyRelationshipNumber": "Bedriftsrelasjonsnummer",
      "hiImHighly": "Hei, jeg er Highly!",
      "implementation": "Implementering",
      "joinImplementationVideo": "Bli med på implementeringsvideosamtale",
      "joinTrialZoom": "Bli med på prøvesamtale i Zoom",
      "kickoff": "start",
      "needHelpChatVideo": "Trenger du hjelp? Start en chat eller videosamtale med oss nå!",
      "openAIAssistant": "Åpne AI-støtteassistent",
      "premium": "Premium",
      "priority": "Prioritet",
      "raiseSupportTicket": "Opprett en støtteforespørsel",
      "raiseTicket": "Send inn forespørsel",
      "relationshipNumber": "Relasjonsnummer",
      "startAISupportChat": "Start AI-støttesamtale",
      "startAgentChatWait": "Start agentchat med 2–5 minutters ventetid",
      "startChatChoose": "Start chat – velg mellom AI-støtte eller agentchat",
      "startImplementationVideo": "Start implementeringsvideosamtale",
      "startZoom": "Start Zoom",
      "startZoomCall": "Start en Zoom-samtale",
      "subtitle": "Enten du vil snakke med oss, fellesskapet eller lære på egenhånd, har vi det du trenger!",
      "title": "Hjelp og støtte",
      "trialExperience": "Prøveopplevelse",
      "useButtonsBelow": "Bruk en av knappene under for å få hjelp!",
      "videoCallReward": "Bli med en videosamtale for å opprette kontoen din - og få {amount} kreditert til lommeboken din når du deltar.",
      "videoCallType": "Bli med en videosamtale med meg for {type}-samtalen din.",
      "yourPremiumSupportSpecialist": "Din {type}-støttespesialist",
      "yourSpecialist": "Din {type}-spesialist",
      "yourSupportSpecialist": "Din støttespesialist",
      "videoCall": "Videosamtale",
      "active": "Aktiv",
      "announcementsAria": "Kunngjøringer – klikk for å åpne i en ny fane",
      "chat": "Chat",
      "accessWelcomeCourseAria": "Klikk for å få tilgang til HighLevels velkomstkurs",
      "clickToUpgrade": "Klikk for å oppgradere",
      "connectCertifiedAdminAria": "Koble til en sertifisert administrator – klikk for å åpne i ny fane",
      "connectWithUsAria": "Koble til med oss – start en direktechat",
      "contactUsAria": "Kontakt oss - ring HighLevel på +1(888)732-4197",
      "copied": "Kopiert",
      "highlevelEventsAria": "Highlevel Events – klikk for å åpne i ny fane",
      "joinFacebookGroupAria": "Bli med i vår Facebook-gruppe – klikk for å åpne i en ny fane",
      "onboardingVideoTutorialsAria": "Videoopplæring om onboarding – klikk for å åpne i ny fane",
      "recommended": "Anbefalt",
      "visitHelpCenterAria": "Besøk vårt hjelpesenter – klikk for å åpne i ny fane",
      "contactUs": "Kontakt oss",
      "agentChatWaitTime": "Agentchat (ca. 2–5 min ventetid)",
      "aiSupportChat": "AI-støttechat",
      "startChat": "Start chat",
      "announcements": "Kunngjøringer",
      "fastestGrowingCommunity": "Bli en del av det raskest voksende fellesskapet.",
      "callHighlevelPhone": "Ring HighLevel på +1(888)732-4197",
      "connectCertifiedAdmin": "Koble til en sertifisert administrator",
      "connectTeamVideoCall": "Ta kontakt med vårt team for å få hjelp via en direktesendt videosamtale!",
      "connectWithUs": "Ta kontakt med oss",
      "dailyBrainstormingSessions": "Daglige idémyldringsøkter med HighLevel",
      "certifiedAdminDescription": "Utforsk HighLevel-eksperter som kan hjelpe deg med å sette opp systemet, automatisere arbeidsflyter eller tilpasse prosjektet ditt.",
      "getAccessWelcomeCourse": "Få tilgang til HighLevel-velkomstkurset",
      "premiumSupportDescription": "Få prioritert feilsøking, ekspertveiledning og direkte tilgang til vårt tekniske team via Slack.",
      "highlevelEvents": "HighLevel-hendelser",
      "joinFacebookGroup": "Bli med i Facebook-gruppen vår",
      "onboardingVideoTutorials": "Videoveiledninger om onboarding",
      "premiumSupport": "Premium support",
      "setupAccountFreeTutorials": "Opprett kontoen din med gratis veiledninger",
      "viewSupportTicketsArticles": "Se dine supportforespørsler, våre støtteartikler og nyttige vanlige spørsmål!",
      "visitHelpCenter": "Besøk vårt hjelpesenter",
      "welcomeCourse": "Velkommen til kurset",
      "beta": "Beta",
      "closeHelpSupportDrawer": "Lukk Hjelp og støtte-skuffen",
      "upgradePlanToEnable": "Du må oppgradere abonnementet ditt for å aktivere denne funksjonen",
      "premiumSupportActive": "Premium-støtten din er aktiv",
      "premiumSupportClickUpgrade": "Premium Support – Klikk for å oppgradere planen din",
      "premiumSupportActiveAria": "Premium Support - Premium-støtten din er aktiv",
      "keepUpToDateNews": "Hold deg oppdatert med alle de siste nyhetene og utgivelsene!"
    },
    "hi": "Hei",
    "is_scheduled_for_deletion_on": "er planlagt for sletting den",
    "k": "K",
    "limit_updated_from": "grense oppdatert fra",
    "minimum_must_be": "Minimum må være",
    "more_emails_in_thread": "flere e-poster i tråden",
    "multipleUsers": {
      "chooseAccount": "Velg en konto for å fortsette"
    },
    "must_be_in_range_of_0": "Må være i området 0-",
    "numbers_and": "nummer/numre og",
    "premiumSupport": {
      "assigningManager": "Tildeler teknisk kontoaansvarlig …",
      "bookCall": "Bestill en samtale",
      "hiIm": "Hei, jeg er {name}",
      "joinZoomNow": "Bli med i Zoom-samtalen nå",
      "quickActions": "Raske støttehandlinger",
      "quickLinks": "Hurtiglenker",
      "raiseFeatureRequest": "Forespørsel om å øke funksjonen",
      "slackChannelCreating": "Vent litt – Premium Slack-kanalen din settes opp! 🚀",
      "technicalAccountManager": "Teknisk kontoansvarlig",
      "viewRoadmap": "Se produktplan"
    },
    "prospecting": "Prospektering",
    "reloadPopup": {
      "message": "Vi har lagt merke til at du ikke har oppdatert siden på en stund. Oppdater for å få den beste opplevelsen fra appen.",
      "refreshNow": "Oppdater nå"
    },
    "resell_settings": "Innstillinger for videresalg",
    "row": "rad",
    "select_upto": "Velg opptil",
    "seo": "SEO",
    "supportCalendar": {
      "description": "Få dedikert support når det passer deg.",
      "title": "Avtal en samtale med Highlevel support"
    },
    "these_are_margins_that_are_billed_to_your_clients_": "Dette er marginer som faktureres kundene dine over",
    "twilioSetup": {
      "autoSetup": {
        "benefit1": "La oss administrere Twilio for deg uten problemer",
        "benefit2": "Vårt støtteteam tar seg av Twilio-problemene dine",
        "button": "Gjør det for meg",
        "drawback": "Betal {price} ekstra på VAS sammenlignet med å gjøre det selv",
        "title": "Vi gjør det for deg"
      },
      "lowCreditsMessage": "Du må koble til en Twilio-konto for å administrere samtaler og tekster som sendes/mottas på HighLevel.",
      "lowCreditsTitle": "Du har lite gratis Twilio-kreditter igjen, men vi tar oss av deg!",
      "selfSetup": {
        "benefit1": "Administrer utgiftene dine",
        "benefit2": "Få mer kontroll over Twilio-tjenesten din",
        "button": "Jeg skal administrere",
        "drawback1": "Ansett noen til å administrere Twilio-tjenesten",
        "drawback2": "Ta kontakt med Twilio-kundestøtte når noe ikke fungerer.",
        "title": "Gjør det selv"
      },
      "wip": {
        "button": "Konfigurer Twilio nå",
        "fallback": "Inntil videre må du administrere din egen Twilio-konto.",
        "message": "Takk for at du valgte oss, men vi jobber fortsatt med å utvikle denne funksjonen. Du vil høre fra oss så snart vi kan lansere dette for kontoen din.",
        "title": "Vi jobber fortsatt med det!!"
      }
    },
    "uiComponents": {
      "loadingMoreOptions": "Laster inn flere alternativer …",
      "noElementsFound": "Ups! Ingen elementer funnet. Vurder å endre søkeordet.",
      "noLocationsFound": "Ingen underkontoer funnet. Prøv et annet søk.",
      "typeToSearch": "Skriv inn for å søke",
      "enterUserEmail": "Skriv inn brukerens e-post."
    },
    "updating": "Oppdaterer",
    "usd": "USD",
    "useTemplate": {
      "useTemplate": "Bruk mal"
    },
    "validEmail": {
      "andYouCan": "Og du kan",
      "as": "som",
      "canReverify": "Du kan verifisere e-posten din på nytt",
      "emailIs": "Denne e-posten er",
      "emailMarkedAs": "Denne e-posten er merket som",
      "markedAsInvalid": "Denne e-posten er merket som",
      "notVerified": "Ikke verifisert",
      "reverifyHere": "Verifiser på nytt her",
      "verifyHere": "Verifiser her"
    },
    "will_give_you_about": "vil gi deg omtrent",
    "checkout": {
      "confirm": "Bekreft",
      "cardInformation": "Kortinformasjon",
      "cardNumberInvalid": "Kortnummeret ditt er ugyldig.",
      "commitment": "bindingstid",
      "paymentConsent": "Ved å bekrefte tillater du LeadConnector å belaste kortet ditt for denne betalingen.",
      "subscriptionConsent": "Ved å bekrefte abonnementet ditt, gir du LeadConnector tillatelse til å belaste kortet ditt for denne betalingen og fremtidige betalinger for dette abonnementet.",
      "endingIn": "som slutter med",
      "month": "måned",
      "pay": "Betal",
      "payWithCard": "betal med kort",
      "paymentBeingProcessed": "Betalingen behandles. Ikke last inn siden på nytt eller klikk på tilbake-knappen",
      "proceedWithExistingCard": "Fortsett med eksisterende kort",
      "proceedWithNewCard": "Fortsett med et nytt kort",
      "purchase": "kjøp",
      "subscribe": "Abonner",
      "subscribeTo": "Abonner på",
      "pleaseUpdateCardDetails": "Oppdater kortdetaljer",
      "zip": "postnummer",
      "retry": "prøv på nytt",
      "initialChargesProrated": "Startgebyrene er forholdsmessig fordelt, og ordinær fakturering vil begynne fra",
      "youWillBeChargedFor": "Du vil bli belastet for",
      "days": "dager",
      "rightNowForPeriodTill": "Akkurat nå for perioden frem til",
      "startGettingChargedFullAmount": "og begynne å bli belastet det fulle beløpet på",
      "perMonthStartingFrom": "/måned fra",
      "nameOnCard": "Navn på kort",
      "somethingWentWrong": "Noe gikk galt",
      "errorImg": "feil bilde",
      "networkError": "Nettverksfeil. Prøv igjen om en stund.",
      "paymentCouldNotBeProcessed": "Betalingen kunne ikke behandles. Prøv å legge til et kort igjen."
    },
    "deleteLocation": {
      "back": "Tilbake",
      "delete": "Slett",
      "completeStepsToDelete": "Du må fullføre noen enkle trinn for å slette dette stedet",
      "alsoCloseAssociated": "Også nært forbundet",
      "scheduling": "Planlegger …",
      "subAccountAndDeletePhoneNumbers": "underkonto og slett alle telefonnumre",
      "somethingWentWrongTryAgain": "Noe gikk galt … Prøv igjen etter en stund",
      "deleteSubAccount": "Slett underkonto",
      "scheduleForDeletion": "Planlegg for sletting"
    },
    "productRebilling": {
      "enableRebilling": "Aktiver omfakturering",
      "ratesMayDifferUK": "Prisene kan variere avhengig av regionen. Beregningene som vises er i henhold til satser for Storbritannia,",
      "examplePricingGpt4oMini": "Priseksempel – GPT-4o Mini",
      "input": "Inndata",
      "output": "Utdata",
      "supportDoc": "rundskriv",
      "unsavedChanges": "Ulagrede endringer",
      "to": "til",
      "chargedToCustomerLower": "Belastet kunden",
      "model": "Modell",
      "profit": "Fortjeneste",
      "saving": "Lagrer …",
      "type": "Type",
      "updating": "Oppdaterer …",
      "clickHere": "Klikk her",
      "chargedToCustomer": "Belastet kunden",
      "enabling": "Aktiverer …",
      "forMoreDetails": "for mer informasjon.",
      "tenDollarsWillGive": "$10 vil gi deg omtrent",
      "yourCost": "Din kostnad",
      "seeHow": "Se hvordan",
      "clientCompanyBillingPage": "faktureringsside for kundens bedrift",
      "connectStripeToEnable": "For å aktivere gjenfakturering, må du koble til Stripe",
      "companyStripeIntegrationPage": "bedriftens side for stripe-integrasjon",
      "enterClientCardInfo": "For å aktivere omfakturering må du legge inn kundens kortinformasjon på",
      "gpt4oMini": "GPT-4o-mini",
      "for750kWords": "(for 750 000 ord)",
      "words": "ord",
      "yourCostLower": "Din kostnad",
      "and": "og",
      "or": "eller",
      "minimumMustBeBetween": "Minimum må være mellom",
      "upgradeToAgencyPro": "oppgrader til Agency Pro",
      "planToSetMargins": "planen for å sette opp marginer"
    },
    "m": "m",
    "label": "Etikett",
    "company_email_": "Bedriftens e-post (",
    "me_": "Meg (",
    "automation_type": "Automatiseringstype",
    "calendar_groups": "Kalendergrupper",
    "length_": ".length }}"
  },
  "products": {
    "noProducts": "Ingen produkter er tilgjengelige",
    "selectProduct": "Velg et produkt"
  },
  "reselling": {
    "common": {
      "additionalMessagesInfo": ". Ytterligere {product} meldinger vil ikke bli belastet til lokasjonene. For å gjenfakturere kunden, aktiver SaaS-modus og gjenfakturering.",
      "agreementPrefix": "Jeg godtar aktivering",
      "agreementSuffix": "for denne kunden uten videresalg, og jeg erkjenner at jeg vil bli belastet",
      "buildResellerOffer": "Bygg ditt videresalgstilbud",
      "deployDirectlyDescription": "Bruk dette alternativet hvis du tilbyr {product} som en del av tilbudet ditt, eller hvis du ønsker å fakturere kunden eksternt",
      "deployPrefix": "Rulle ut",
      "directlySuffix": "Direkte",
      "learnMore": "Les mer.",
      "offerPrefix": "Tilbud",
      "resellPrefix": "Videreselge",
      "resellingPrefix": "Videreselging",
      "subscriptionRestriction": "Kan ikke endre innstillingene ettersom stedet allerede abonnerer",
      "zero": "0",
      "highlevelPrice": "HighLevel-pris",
      "howDoesItWork": "Hvordan fungerer det?",
      "payNowButton": "Betal nå",
      "priceValidationError": "Prisen må være høyere enn eller lik HighLevel-prisen",
      "saving": "Lagrer",
      "yourPrice": "Din pris",
      "yourProfit": "Din fortjeneste"
    },
    "whatsapp": {
      "inboundMessagesInfo": "Det er gratis å motta innkommende meldinger og svare på dem ved hjelp av en fritekst i samtalevinduet. Det vil påløpe ekstra kostnader for utgående malmeldinger hvis de sendes.",
      "whatsappLocation": "WhatsApp-lokasjon"
    },
    "agencyResellingPage": {
      "seo": {
        "subscriptionRestriction": "Kan ikke endre innstillingene ettersom stedet allerede abonnerer",
        "offerPrefix": "Tilbud ",
        "poweredByPrefix": " (Drevet av Search Atlas)",
        "toggleTooltipDisable": "Denne handlingen vil deaktivere SEO-verktøyet for alle underkontoer.",
        "toggleTooltipEnable": "Denne handlingen vil aktivere SEO-verktøyet for alle underkontoene.",
        "resellPrefix": "Videreselg ",
        "howDoesItWork": "Hvordan fungerer det?",
        "buildResellerOffer": "Bygg ditt videresalgstilbud",
        "yourPrice": "Din pris",
        "highlevelPrice": "HighLevel-pris",
        "yourProfit": "Din fortjeneste",
        "priceValidationError": "Prisen må være høyere enn eller lik HighLevel-prisen",
        "saving": "Lagrer",
        "save": "Lagre",
        "deployPrefix": "Distribuer ",
        "directlySuffix": "Direkte",
        "deployDirectlyDescription": "Bruk dette alternativet hvis du tilbyr SEO som en del av tilbudet ditt, eller hvis du ønsker å fakturere kunden eksternt",
        "agreementPrefix": "Jeg godtar aktivering ",
        "agreementSuffix": " for denne kunden uten videresalg, og jeg bekrefter at jeg vil bli belastet",
        "payNowButton": "Betal nå",
        "subscriptionCreating": "Abonnementet er under opprettelse.<br/>Ikke last inn siden på nytt eller klikk på tilbake-knappen",
        "subscriptionCreated": "Abonnement opprettet. Vent litt …",
        "subscriptionError": "Kan ikke opprette abonnement, ta kontakt med kundestøtte"
      },
      "adManager": {
        "subscriptionRestriction": "Kan ikke endre innstillingene ettersom stedet allerede abonnerer",
        "offerPrefix": "Tilbud ",
        "resellingPrefix": "Videreselging",
        "resellPrefix": "Videreselg ",
        "howDoesItWork": "Hvordan fungerer det?",
        "bookACall": "Bestill en samtale",
        "bookCallTooltip": "Bestill en samtale med teamet vårt for å lære mer om Ad Manager",
        "buildResellerOffer": "Bygg ditt videresalgstilbud",
        "yourPrice": "Din pris",
        "highlevelPrice": "HighLevel-pris",
        "yourProfit": "Din fortjeneste",
        "priceValidationError": "Prisen må være høyere enn eller lik HighLevel-prisen",
        "loading": "Laster …",
        "save": "Lagre",
        "deployPrefix": "Distribuer ",
        "directlySuffix": "Direkte",
        "deployDirectlyDescription": "Bruk dette alternativet hvis du tilbyr Ad Manager som en del av tilbudet ditt, eller hvis du ønsker å fakturere kunden eksternt.",
        "agreementPrefix": "Jeg godtar aktivering ",
        "agreementMiddle": " for denne kunden uten videresalg, og jeg bekrefter at jeg vil bli belastet",
        "agreementSuffix": " per måned",
        "stripeNotConnectedLocationWarning": "Stripe er ikke koblet til denne lokasjonen. Koble til Stripe for å aktivere denne funksjonen.",
        "stripeNotConnectedAgencyWarning": "Stripe er ikke koblet til dette byrået. Koble til Stripe for å aktivere denne funksjonen.",
        "underSubAccountReselling": "per måned under videresalg av underkonto"
      },
      "dedicatedIp": {
        "description": "Dette lar deg omfakturere dedikert IP (som brukes til utgående e-post) til kundene dine og inkludere et påslag",
        "numberOfIps": "Antall IP-er:",
        "yourCost": "Din kostnad:",
        "chargedToCustomer": "Belastet kunden:",
        "profit": "Fortjeneste:",
        "monthlyProfit": "Månedlig fortjeneste:",
        "loading": "Laster …",
        "save": "Lagre",
        "revokeDedication": "Tilbakekall dedikasjon",
        "revokeDescription": "Bruk dette alternativet for å avslutte tilbudet om nye dedikerte IP-adresser til kunden din uten å belaste dem",
        "existingSubscriptionsNote": "Nåværende IP-abonnementer vil ikke bli påvirket",
        "revoke": "Tilbakekall",
        "provideDirectlyTitle": "Oppgi dedikert IP-adresse for e-post direkte",
        "provideDirectlyDescription": "Bruk dette alternativet for å gi kunden din en dedikert IP-adresse uten å belaste dem",
        "agreeToProvideText": "Jeg godtar å tilby IP for denne kunden uten mersalg",
        "acknowledgeChargeText": "Jeg erkjenner at jeg vil bli belastet $59 per måned per IP.",
        "agree": "Godta",
        "yourMonthlyCost": "Din månedlige IP-kostnad:",
        "monthlyChargeToCustomer": "Månedlig avgift til kunden:",
        "resellingSettingsSuffix": " Innstillinger for videresalg",
        "ipRebillingAmount": "IP-omfaktureringsbeløp"
      }
    }
  },
  "saas": {
    "disable": {
      "complianceModal": {
        "clientApproval": "Jeg bekrefter at jeg har diskutert dette med kunden, og jeg har deres godkjenning",
        "confirmQuestion": "Er du sikker på at du vil deaktivere SaaS-modus for denne kontoen?",
        "dataLossAck": "Jeg erkjenner at alle viderefaktureringsdata, SaaS-abonnementsdata og transaksjonsregister vil gå tapt",
        "disableSaas": "Deaktiver SaaS",
        "irreversibleAck": "Jeg forstår at denne handlingen er irreversibel"
      },
      "confirmationModal": {
        "cancelSubscription": "Avbryt også tilknyttet SaaS-abonnement",
        "confirmDisable": "Lagre Deaktiver",
        "confirmQuestion": "Er du sikker på at du vil deaktivere SaaS-modus?",
        "somethingWentWrong": "Noe gikk galt … Prøv igjen etter en stund"
      },
      "processingModal": {
        "closeNow": "Lukke nå",
        "closeWindowInstructions": "Du kan lukke dette vinduet. Vi vil informere deg via e-post når prosessen er fullført",
        "title": "SaaS vil snart bli deaktivert for denne plasseringen.",
        "typicalTime": "Dette tar vanligvis 10 minutter eller mindre."
      }
    }
  },
  "settings": {
    "customFields": {
      "addCustomField": "Legg til egendefinert felt",
      "fieldKey": "Feltnøkkel",
      "fieldName": "Feltnavn",
      "idWillBeAdded": "ID vil bli lagt til etter at tapsårsaken er opprettet",
      "lostReasonID": "Frafallsårsak-ID",
      "placeholder": "Plassholder"
    },
    "locationMailGun": {
      "bccAddress": "BCC-adresse",
      "clearError": "Fjern feil",
      "deleteConfirmationMessage": "Denne handlingen vil fjerne Mailgun-tilkoblingen.",
      "deleteConnection": "Slett tilkobling",
      "domain": "Domene",
      "domainsAvailable": "{count} tilgjengelig",
      "invalidApiKey": "Ugyldig API Key",
      "selectDomain": "Velg domene"
    },
    "locationWallet": {
      "fetchTransactionDetailsError": "Feil under henting av transaksjonsdetaljer",
      "transactions": "Transaksjoner"
    },
    "noShowSMS": {
      "smsWithImage": "SMS for ikke oppmøte med bilde",
      "title": "Tilpass SMS med anmeldelse"
    },
    "optOut": {
      "addKeywords": "Legg til ett av følgende nøkkelord for avmelding: STOP, STOPPALL, UNSUBSCRIBE, CANCEL, END eller QUIT.",
      "customizeTitle": "Tilpasse avmeldingsbeskjed",
      "disableConfirm": "Er du sikker på at du vil deaktivere avmeldingsbeskjeden?",
      "disableOptOut": "Deaktiver avmelding",
      "disableTitle": "Deaktiver avmeldingsbeskjed?",
      "optInConfirmClient": "Jeg bekrefter at jeg vil sørge for at SMS bare sendes til kontaktene som har gitt sitt samtykke.",
      "quickTipMessage": "Den første meldingen du sender til en person må inneholde ett av følgende standardnøkkelord for avmelding: STOP, STOPALL, UNSUBSCRIBE, CANCEL, END eller QUIT.",
      "reallyDisableConfirm": "Er du virkelig sikker på at du vil deaktivere avmeldingsbeskjeden?"
    },
    "payments": {
      "logViewer": {
        "requestPostBody": "Forespørsel POST-tekst",
        "requestQueryParameters": "Forespørsel spørringsparametere",
        "responseBody": "Svartekst"
      },
      "logs": "Logger",
      "logsPage": {
        "clearAll": "Fjern alle",
        "loadMore": "Last inn mer",
        "price": "Pris",
        "product": "Produkt",
        "tabsAriaLabel": "Faner for betalingslogger"
      }
    },
    "senderInfo": {
      "addGeneralTextAt": "Legg til generell tekst på",
      "beginning": "Start",
      "complianceConfirm": "Jeg bekrefter at jeg vil sørge for at alle SMS-meldinger sendt fra denne kontoen er i samsvar med gjeldende retningslinjer",
      "customizeTitle": "Tilpasse generell tekst",
      "disableConfirm": "Er du sikker på at du vil deaktivere SenderID?",
      "disableSenderID": "Deaktiver SenderID",
      "disableTitle": "Deaktiver SenderID?",
      "end": "Slutt",
      "pleaseAdd": "Legg til {text} som nevnt i hurtigtipset.",
      "quickTipMessage": "Den første meldingen du sender til en enkeltperson, må inneholde avsenderidentifikasjonsinformasjon. Legg til {text} i den generelle tekstboksen.",
      "reallyDisableConfirm": "Er du virkelig sikker på at du vil deaktivere SenderID?",
      "senderID": "Avsender-ID"
    },
    "shopify": {
      "adminApiAccessToken": "Admin API-tilgangstoken",
      "apiTokenRequired": "API-tilgangstoken kreves",
      "checkDocumentation": "Sjekk denne dokumentasjonen for mer informasjon",
      "checkmark": "✓",
      "cross": "✗",
      "customAppApiAccessToken": "Egendefinert tilgangstoken for App API",
      "deleteWarning": "Hvis du sletter dette, fjernes den eksisterende tilkoblingen.",
      "existStoreAlertTitle": "Shopify-butikkintegrering finnes allerede",
      "integration": "Shopify-integrering",
      "integrationHealth": "Integrering helse",
      "orders": "Bestillinger",
      "scopePermissionsWarning": "Sørg for at appen din er gitt tillatelser som er merket med rødt kryss",
      "scopes": "Omfang",
      "scopesDescription": "Autorisasjonsomfang kreves for å få tilgang til Shopify-informasjonen. På grunn av nylige endringer i Shopify er read_customers nå nødvendig for å få full informasjon fra kundene, på grunn av Shopify-beskyttede kundedata.",
      "storeConnectedMessage": "Shopify-butikken er allerede koblet til en underkonto {locationName}",
      "storeNameHelp": "Butikknavnet ditt ligger i URL-adressen for Shopify-kontoen din – etter https://og for.myshopify.",
      "storeNameLabel": "Navnet på shopify-butikken din",
      "storeNamePlaceholder": "butikknavn",
      "storeNameRequired": "Butikknavn er påkrevd",
      "typeRemoveConfirm": "Skriv 'REMOVE' for å bekrefte",
      "webhooks": "Webhooks",
      "webhooksDescription": "For å motta alle hendelser fra Shopify må vi registrere disse Shopify-webhookene under integreringsprosessen. Disse webhookene er viktige for å sikre at Shopify-egenskaper fungerer som de skal."
    },
    "slack": {
      "accountConnected": "Konto tilkoblet",
      "accountsConnected": "kontoer koblet til",
      "accountsList": "Liste over alle Slack-kontoer",
      "added": "Lagt til {date}",
      "connectChannel": "Koble til din Slack-kanal",
      "description": "Få øyeblikkelige varsler på Slack-kanalen din. Klikk på \"Koble til\" for å legge til en Slack-kanal.",
      "manage": "Administrer",
      "manageAccounts": "Administrer Slack-kontoer",
      "noIntegrations": "Ingen Slack-integrasjoner ble funnet."
    },
    "smtpService": {
      "addFirstService": "Legge til din første SMTP-tjeneste.",
      "addService": "Legg til tjeneste",
      "bccEmails": "BCC-e-poster",
      "cannotDeleteDefaultProvider": "Du kan ikke slette standard leverandør.",
      "contactDeveloper": "Kontakt utvikleren av denne appen.",
      "customProvider": "Egendefinert leverandør",
      "defaultProvider": "Standard leverandør",
      "defaultProviderUpdated": "Standardleverandøren har blitt oppdatert!",
      "emailDomain": "E-post / domene",
      "emailService": "E-POST-tjeneste",
      "enableReplyTracking": "Aktiver svarsporing",
      "forwardToAssignedUser": "Videresend til tilordnet bruker",
      "providerType": "Leverandørtype",
      "smtpConnectionIssue": "Der er et problem med denne smtp-tilkoblingen. Koble til denne Integreringen på nytt.",
      "useLcEmailMessage": "Bruk LC Email til å sende e-post til byrået ditt og kundene dine."
    },
    "socialPosting": {
      "automaticPostingEnabled": "Automatisk publisering aktivert",
      "dailyPostLimit": "Daglig innleggsgrense",
      "directoriesDescription": "Når du får en ny anmeldelse, legger vi den automatisk ut i over 80 kataloger på nettet for å automatisk hjelpe merkevaren din og SEO med å vokse.",
      "directoriesTitle": "80+ kataloger og nettsteder",
      "fivePosts": "5 innlegg",
      "fiveStars": "5 stjerner",
      "fourPosts": "4 innlegg",
      "fourStars": "4 stjerner",
      "googlePlus": "Google +",
      "manageSettingsDescription": "Tilpass hvordan og når anmeldelsene dine blir automatisk lagt ut på hvert av de sosiale nettverkene dine.",
      "manageSettingsTitle": "Administrer innstillingene for sosiale innlegg",
      "postReviewsForRating": "Legg inn anmeldelser for denne stjernerangeringen eller høyere.",
      "searchEngines": "Søkemotorer",
      "threePosts": "3 innlegg",
      "threeStars": "3 stjerner",
      "title": "Innlegg på sosiale medier"
    },
    "tags": {
      "addNewTag": "Legg til ny tagg",
      "allTags": "Alle tagger",
      "deletedTags": "Slettede tagger",
      "here": "her.",
      "newTag": "Ny tagg",
      "noTagsYet": "Ingen tagger å vise ennå",
      "searchTags": "Søk i tagger",
      "viewDeletedTags": "Du kan se og gjenopprette slettede tagger på siden for revisjonslogger"
    },
    "templateMessage": {
      "addEmailTemplate": "Legg til e-postmal (utdrag)",
      "addTemplate": "Legg til mal (utdrag)",
      "addTextTemplate": "Legg til tekstmal (utdrag)",
      "body": "Hoveddel",
      "deleteTemplateConfirmation": "Er du sikker på at du vil slette denne malen?",
      "templatesCount": "{count} maler",
      "title": "Meldingsmaler (utdrag)"
    },
    "unsubscribe": {
      "content": "Innhold",
      "contentTooltip": "Innholdet i denne meldingen vil automatisk bli lagt til i alle e-postene.",
      "customizeTitle": "Tilpasse innhold for avmelding",
      "disableConfirm": "Er du sikker på at du vil deaktivere avmeldingslenken fra e-post?",
      "disableTitle": "Deaktiver avmeldingslenke?",
      "disableUnsubscribe": "Deaktiver avmelding",
      "pleaseAddTag": "Legg til /*unsubscribe*/-taggen",
      "reallyDisableConfirm": "Er du virkelig sikker på at du vil deaktivere avmeldingslenken fra e-post?",
      "subscribedConfirm": "Jeg bekrefter at e-post kun vil bli sendt til kontakter som har abonnert på å motta e-post.",
      "subscribedConfirmClient": "Jeg bekrefter at jeg vil sørge for at e-post kun sendes til kontakter som har abonnert på å motta e-post.",
      "suspensionWarning": "Aktiviteter som ikke overholder retningslinjene, kan føre til suspensjon av e-postfunksjonene i kontoen din.",
      "tagRequirement": "Den første e-posten du sender til en person må inneholde /*unsubscribe*/-taggen"
    },
    "callAndVoicemailSettings": {
      "defaultVoicemailMessage": "Dette er standard talemelding for alle Twilio-numre på lokasjonen, med mindre den er tilpasset under",
      "forwardCallsToWebApp": "Videresend samtaler til nettapp",
      "forwardCallsToMobileApp": "Videresend samtaler til mobilappen",
      "dedicatedNumberRequiredInfo": "Dette er kun obligatorisk hvis brukerne trenger et dedikert nummer. Ikke nødvendig for telefonsvarer eller for å rute anropet til den tilordnede brukeren.",
      "voicemailMessageInfo": "Denne talepostmeldingen vil bli spilt av i stedet for den fra telefonoperatøren. Vi anbefaler et tidsavbrudd på 20 sekunder eller mindre.",
      "noTimeout": "Ingen tidsavbrudd",
      "10Secs": "10 sekunder",
      "20Secs": "20 sekunder",
      "voicemailMessageDuration": " Vi vil ta opp en telefonsvarer hvis samtalen ikke blir besvart innen denne tiden.",
      "saveCallSettings": "Lagre anropsinnstillinger"
    },
    "elizaFAQSetting": {
      "bypassElizaNote": "Når denne taggen er til stede på kontakten, vil de meldingene IKKE bli levert til Eliza",
      "sendToElizaNote": "Som standard vil alle samtalene bli levert til Eliza. Hvis denne taggen er konfigurert, <br />vil de nye samtalene bli sendt til Eliza, bare når denne taggen er til stede på en kontakt.<br /> Hvis både Eliza bypass-taggen og Send til Eliza-taggen er konfigurert, vil bare Send til Eliza bli prioritert",
      "permissionNote": "Brukertillatelsene dine er ikke aktivert for denne siden. <br />Snakk med administratoren din.",
      "addFAQ": "Legg til vanlige spørsmål"
    },
    "locationSettings": {
      "ownCardWarning": "Ikke legg til ditt eget kort på underkontoer!",
      "addClientCardWarning": "Legg til kundens (underkontoens) kort og ikke ditt eget, da dette kortet vil bli brukt til å fakturere kunden på dine vegne.",
      "stripeConnectMissing": "Stripe connect mangler",
      "pleaseContactAgencyToAddPaymentMethods": "Kontakt byrået ({email}) for å legge til betalingsmetoder"
    },
    "integrations": {
      "connectWaveAccount": "Koble til Wave-kontoen til lokasjonen din",
      "connectXeroAccount": "Koble til Xero-kontoen til lokasjonen din"
    },
    "gmbSettings": {
      "gbpCallTrackingEnabledOnAnotherSubAccount": "GBP-samtalesporing er aktivert på en annen underkonto. Samtalesporing kan aktiveres på én enkelt underkonto av gangen.",
      "gbpCallTrackingEnabledOnAnotherPage": "GBP-samtalesporing er aktivert på en annen side ({pageName}). Samtalesporing kan aktiveres på én underkonto og én side per lokasjon om gangen.",
      "gbpCallsProperlySetup": "GBP-samtaler er riktig konfigurert, og samtaler kommer inn fra",
      "tooManyEditsToPrimaryPhone": "De har gjort for mange endringer på primærtelefonen for denne virksomheten. Prøv igjen senere",
      "setupTwilioToStartCallTracking": "Konfigurer Twilio for å starte samtalesporing",
      "twoSecondaryNumbersSetupAlready": "De har allerede to sekundærnumre satt opp. Kan ikke bytte nummer",
      "yourAgentIDIs": "Din agentID er"
    },
    "numberPool": {
      "title": "Hva bør spores",
      "tracking": {
        "percentComplete": "34 % fullført",
        "searchLower": "søk"
      },
      "create": {
        "title": "Opprett sporingsnummer"
      }
    },
    "phoneNumbers": {
      "title": "Hva bør spores",
      "tracking": {
        "percentComplete": "34 % fullført",
        "heading": "Opprett sporingsnummer"
      }
    }
  },
  "smartList": {
    "filterMultiInput": {
      "enterValue": "* Skriv inn en verdi",
      "selectOption": "* Velg et alternativ"
    },
    "filterMultiSelections": {
      "atLeastOneRequired": "* Minst én {filterName} er obligatorisk",
      "select": "Velg {filterName}"
    },
    "newEmailStats": {
      "timeStamp": "Tidsstempel"
    },
    "recordsNav": {
      "clickToReloadList": "Klikk for å laste inn listen på nytt"
    },
    "reviewRequestActions": {
      "emailReviewReq": "E-postvurderingsforespørsel",
      "smsReviewReq": "SMS-vurderingsforespørsel",
      "whatsappReviewReq": "WhatsApp-vurderingsforespørsel"
    },
    "smartListFilters": {
      "clearAllFilters": "Tøm alle filtre",
      "noneFound": "ingen funnet",
      "saveChangesToList": "Lagre filterendringer i denne smartlisten",
      "saveCombinationAsNew": "Lagre kombinasjon av filtre, kolonner og sortering som en ny smartliste",
      "saveCurrentAsNew": "Lagre gjeldende filtre som en ny smartliste",
      "searchAndAddFilter": "Søk etter og legg til et filter",
      "searching": "søker …",
      "undoUnsavedChanges": "Angre ulagrede endringer"
    },
    "smsStatsPanel": {
      "smsStats": "SMS-statistikk"
    },
    "manageDuplicates": "Administrer duplikater",
    "emailAction": {
      "attachFiles": "Legg ved filer",
      "customValues": "Egendefinerte verdier",
      "triggerLinks": "Trigger-lenker"
    },
    "atLeastOneRequired": "* Minst én {filterName} kreves",
    "arrayInput": {
      "searchPlaceholder": "Søk etter {filterName}",
      "searching": "Søker …"
    }
  },
  "snapshots": {
    "common": {
      "errorWhileFetchingSnapshotContents": "Feil under henting av øyeblikksbildeinnhold",
      "overwriteAll": "Overskriv alle",
      "skipAll": "Hopp over alle",
      "somethingWentWrongWhileFindingConflicts": "Noe gikk galt under søket etter konflikter",
      "step": "Trinn"
    },
    "confirmOverwrite": {
      "confirmButton": "Lagre overskriving",
      "description": "Denne handlingen er irreversibel, og kan endre konfigurasjoner av kampanjer, muligheter, trakter osv. Bekreft handlingen ved å skrive følgende i inndatafeltet.",
      "title": "Er du sikker på at du vil overskrive valgte data?"
    },
    "conflicts": {
      "noConflictsDetected": "Fant ingen konflikter",
      "overwrite": "Overskrive"
    },
    "pushCloneAccount": {
      "assetsFoundLinked": "Fant ressurser som er tilknyttet",
      "checkingConflicts": "Sjekker etter konflikter",
      "chooseSnapshot": "Velg et øyeblikksbilde",
      "copyingDataNotification": "Kopierer data til utvalgte plasseringer. Vent litt …",
      "linkedLocations": "Sammenkoblede plasseringer",
      "noConflictsFound": "Ingen konflikter ble funnet",
      "notAuthorizedMessage": "Kun byråadministratorer kan utføre denne handlingen",
      "overwriteConflicts": "Overskrive konflikter",
      "pickSnapshot": "Velge et øyeblikksbilde",
      "response": "Svar",
      "selectAssetsToPush": "Velg ressurser som skal skyves",
      "selectLocationsToUpdate": "Velg plasseringer for oppdatering",
      "snapshotNotAuthorized": "Dette øyeblikksbildet er ikke godkjent for denne plasseringen",
      "snapshotNotSelected": "Øyeblikksbilde er ikke valgt"
    },
    "share": {
      "agencyRestrictedLink": "Byråebegrenset lenke",
      "deleteShareLink": "Slett delingslenke",
      "editShareLink": "Rediger delingslenke",
      "permanentLink": "Permanent lenke",
      "subaccountRestrictedLink": "Underkontobegrenset lenke"
    },
    "shareSnapshot": {
      "addCommaAfterEach": "(Legg til komma (<span class='text-base font-bold'> , </span>) etter hvert relasjonsnummer)",
      "addCommaAfterEachSubAccount": "(Legg til komma (<span class='text-base font-bold'> , </span>) etter hver underkonto-ID)",
      "atLeast1EmailRequired": "Minst én e-post er påkrevd.",
      "emailShareLink": "E-postlenke for deling",
      "enterOnePerLine": "(Skriv inn én per linje)",
      "errorGettingLink": "Henting av lenken mislyktes. Prøv igjen senere.",
      "getAgencyRestrictedLink": "Få byråbegrenset lenke",
      "getLink": "Få lenke",
      "getOneTimeLink": "Få engangslenke for deling",
      "getPermanentLink": "Få permanent lenke",
      "getSubAccountRestrictedLink": "Få underkontobegrenset lenke",
      "shareType": "Del type",
      "title": "Del øyeblikksbilde"
    },
    "snapshot": {
      "copySnapshotID": "Kopier øyeblikksbilde-ID",
      "deleteSnapshot": "Slett øyeblikksbilde",
      "editSnapshot": "Rediger øyeblikksbilde",
      "pushUpdate": "Send oppdatering til tilknyttede kontoer",
      "refreshSnapshot": "Oppdatere øyeblikksbilde"
    },
    "updateShareLink": {
      "addCommaAfterEach": "(Legg til komma etter hvert relasjonsnummer)",
      "addCommaAfterEachSubAccount": "(Legg til komma etter hver underkonto-ID)",
      "title": "Oppdater delingslenke"
    }
  },
  "socialMedia": {
    "engagement": "Engasjement",
    "potentialReach": "Potensiell rekkevidde",
    "storiesCreated": "Opprettede historier",
    "recentPosts": "Nylige innlegg",
    "notConnected": "Ikke tilkoblet (Koble til nå!)",
    "totalAudience": "Totalt publikum",
    "activeAudience": "Aktivt publikum",
    "socialMediaOverview": "Oversikt over sosiale medier"
  },
  "suspendModal": {
    "currentStatus": "Nåværende abonnementsstatus: Pauset",
    "instructions": "Du må fullføre noen enkle trinn for å {action} denne underkontoen",
    "nextBillingDate": "Neste faktureringsdato:",
    "noKeepCharging": "Nei, fortsett å belaste kunden.",
    "pauseSubscriptionQuestion": "Ønsker du å sette abonnementet på pause også med underkontoen?",
    "resumeSubAccount": "Gjenoppta underkonto",
    "resuming": "Gjenopptar …",
    "saasSubscriptionActive": "Denne underkontoen har et aktivt SaaS-abonnement.",
    "saasSubscriptionResumed": "SaaS-abonnementet for denne kontoen gjenopptas.",
    "yesPause": "Ja, sett abonnementet på pause"
  },
  "table": {
    "perPageOptions": {
      "5": "5 per side",
      "10": "10 per side",
      "15": "15 per side",
      "20": "20 per side",
      "25": "25 per side",
      "50": "50 per side",
      "100": "100 per side"
    },
    "filterPlaceholder": "Søke ...",
    "emptyText": "Fant ingen oppføringer",
    "loading": "Laster ...",
    "showingEntries": "Viser {from} til {to} av {total} oppføringer",
    "noEntriesToShow": "Ingen oppføringer kan vises"
  },
  "templateLibrary": {
    "public": {
      "loadingAccountData": "Laster inn kontodata …",
      "toContinueWith": "for å fortsette med"
    },
    "switcherModal": {
      "comingSoon": "Kommer snart!",
      "multiLocationMessage": "Denne funksjonen er for øyeblikket kun tilgjengelig for enkeltkontoer. Vi jobber hardt for å gjøre dette tilgjengelig for kontoer med flere underkontoer."
    },
    "importedMessage": "{productName} er importert! Naviger til Malbiblioteket og finn det under {productName}-fanen.",
    "permissionErrorMsg": "Dette alternativet er kun tilgjengelig på høyere abonnementer. Oppgrader nå for å låse det opp.",
    "errors": {
      "sourceDeleted": "Feil: Kildemalen har blitt slettet. Den er ikke lenger tilgjengelig. Sjekk statusen til malen eller kontakt kilden for å få hjelp.",
      "sourceDraft": "Feil: Kildemalen har blitt flyttet til utkast. Sjekk statusen til malen eller kontakt kilden for å få hjelp.",
      "linkedDeleted": "Feil: Kildemalen, som er koblet til den delte malen, har blitt slettet. Sjekk statusen til malen eller kontakt kilden for å få hjelp.",
      "fetchError": "Det ser ut til å være en feil ved henting av detaljer for {productName}. Kontroller URL-en eller prøv igjen!",
      "sameAgency": "Kan ikke dele mal innenfor samme byrå"
    }
  },
  "triggers": {
    "addContactTagRequiresTag": "Handlingen Legg til kontaktmerke krever en tagg.",
    "addNotesRequiresData": "Handlingen Legg til notater krever notatdata.",
    "addTaskRequiresFields": "Handlingen Legg til oppgave krever tittel og forfallsdato.",
    "addToCampaignRequiresCampaign": "Handlingen Legg til kampanje krever en kampanje.",
    "addToCustomAudienceRequires": "Handlingen Legg til i tilpasset målgruppe krever en annonsekonto og en tilpasset målgruppe.",
    "addTrigger": "Legg til trigger",
    "anyAction": "Enhver handling",
    "anyCondition": "Enhver betingelse",
    "brokenCustomVariables": "Noen av feltene inneholder egendefinerte variabler med feil. Fiks dem før du lagrer.",
    "conditionCannotBeEmpty": "Betingelsen \"{condition}\" kan ikke være tom",
    "confirmDeleteTrigger": "Er du sikker på at du vil slette denne triggeren?",
    "customDateFieldRequired": "Egendefinert datofeltfilter er påkrevd for triggeren tilpasset datopåminnelse",
    "detailPage": {
      "chooseTriggerPlaceholder": "Velge en trigger",
      "lastUpdate": "Sist oppdatert:",
      "loopIdentifiedWarning": "Denne triggeren har blitt låst i utkaststatus fordi den forårsaker en loop. For å aktivere denne triggeren, kontakt kundestøtte.",
      "ruleNotActiveWarning": "Denne regelen kjører ikke før du aktiverer den.",
      "triggerCreation": "Opprettelse av trigger:",
      "triggerDeletedPrompt": "Denne triggeren er slettet! Vil du gjenopprette den?",
      "triggerRunDailyTooltip": "Trigger kjører klokken 08:00 AM daglig",
      "whatTriggersRule": "Hva skal utløse denne regelen?",
      "whichEventTriggersAutomation": "Hvilken hendelse skal utløse denne automatiseringen?"
    },
    "dndContactRequiresState": "Handlingen DND-kontakt krever at DND-status er innstilt.",
    "emptyConditionNotAllowed": "Tom betingelse er ikke tillatt.",
    "emptyFieldNotAllowed": "Tomt felt er ikke tillatt.",
    "executeWebhookRequiresUrl": "Handlingen Utfør webhook krever en webhook URL.",
    "fieldCannotBeEmpty": "{field} kan ikke være tomt",
    "fillRequiredFields": "Fyll ut alle obligatoriske felter i handlingene.",
    "googleAdwordsRequiresConversion": "Handlingen Legg til Google Adwords krever omdannelse.",
    "googleAnalyticsRequiresFields": "Handlingen Legg til Google Analytics krever sporings-ID, handlingstype og handlingskategori",
    "membershipGrantOfferRequiresOffer": "Handlingen Innfri tilbud for medlemskap krever tilbud.",
    "membershipRemoveOfferRequiresOffer": "Handlingen Fjern tilbud for abonnement krever tilbud.",
    "newBasicRule": "Ny grunnleggende regel",
    "opportunitiesRequirePipeline": "Handlinger for muligheter krever at du velger en prosess.",
    "opportunityLoopWarning": "Denne triggeren vil føre til en gjentakende opprettelse av mulighet. Velg bort Tillat dupliserte muligheter eller endre trinnet du refererer til.",
    "removeContactTagRequiresTag": "Handlingen Slett kontaktmerke krever en tagg.",
    "removeFromCampaignRequiresCampaign": "Handlingen Fjern fra kampanje krever en kampanje.",
    "removeFromCustomAudienceRequires": "Handlingen Slett fra tilpasset målgruppe krever en annonsekonto og en tilpasset målgruppe.",
    "rulesBasedOn": "regler basert på",
    "selectUserForNotification": "Velg bruker for å sende varsel.",
    "sendEmailRequiresFields": "Handlingen Send e-post krever fra, til, emne og melding.",
    "sendNotificationRequiresFields": "Handlingen Send varsel krever tittel, brødtekst og brukertype for å sende varsel.",
    "sendSmsRequiresFields": "Handlingen Send SMS krever mottaksnummer og melding.",
    "stripeMinAmountUSD": "Beløp må være større enn eller lik 50 cents USD.",
    "stripeRequiresFields": "Handlingen Stripe engangsbelastning krever kunde-ID, beløp og valuta",
    "thatWillFire": "som vil utløse",
    "triggerCannotBeEmpty": "Trigger kan ikke være tom",
    "updateContactFieldRequires": "Oppdater kontaktfelt bør ha minst ett angitt felt."
  },
  "workflow": {
    "resellPaywall": {
      "buttonText": "Betal ${amount} og abonner",
      "commitment": "Ingen forpliktelser, avbestill når som helst",
      "features": {
        "billedOnUsage": "Faktureres basert på bruk etter at grensen er overskredet",
        "externalAI": "Omfatter ikke eksterne KI-modellhandlinger, som faktureres separat",
        "leadingPricing": "Bransjeledende priser!",
        "monthlyPurchase": "Gjelder for ett kjøp per måned",
        "premiumActions": "Gjelder for premiumhandlinger og utløsere"
      },
      "planDetails": "Informasjon om abonnementet",
      "subscribeAndSave": "Abonner og spar i dag!",
      "title": "${amount} for {executions} utførelser per måned"
    }
  },
  "appointmentWidget": {
    "movedMessage": "Denne innstillingen har blitt flyttet til kalendersiden.",
    "toNavigate": "her for å navigere. Denne siden vil snart bli fjernet."
  },
  "attribution": {
    "description": "Den første interaksjonen er rett og slett det første berøringspunktet en bruker har. Så hvis noen først oppdaget deg via en betalt søkeannonse (PPC), vil den kanalen få æren når det gjelder en konvertering. Siste interaksjon vil være den siste kanalen.",
    "firstInteraction": "Første interaksjon",
    "lastInteraction": "Siste interaksjon",
    "title": "Attribusjon"
  },
  "campaign": {
    "addEvent": "Legg til hendelse",
    "a2p": {
      "address": {
        "chooseState": "Velg stat …",
        "city": "By*",
        "postalCode": "Postnummer*",
        "streetAddress": "Gateadresse*",
        "streetAddressHelper": "Må være en gyldig adresse knyttet til din bedrift.",
        "title": "Bedriftsadresse"
      },
      "addressError": {
        "title": "Innsending av adresse mislyktes"
      },
      "authorizedRep": {
        "jobPosition": "Stilling*",
        "jobTitle": "Stillingstittel*",
        "title": "Info om autorisert representant"
      },
      "brandDetails": {
        "solePropBrand": {
          "heading": "Enkeltpersonforetak-merkevare",
          "point1": "Kun ett telefonnummer er tillatt",
          "point2": "EIN/SSN/DUNS er ikke påkrevd"
        },
        "solePropCampaign": {
          "heading": "Enkeltpersonforetak-kampanje",
          "point1": "Bare ett nummer kan knyttes til en enkeltpersonforetakskampanje.",
          "point2": "Når det er godkjent, vil standardnummeret ditt bli tilknyttet automatisk.",
          "infoText": "Du kan også oppdatere nummeret etter godkjenning",
          "warningText": "Bare ett nummer kan knyttes til en enkeltpersonforetakskampanje. Når det er godkjent, vil standardnummeret ditt bli tilknyttet automatisk. Du kan også oppdatere nummeret etter godkjenning."
        },
        "solePropSubtitle": "Enkeltpersonforetak-merkevare- og kampanjedetaljer",
        "standardBrand": {
          "heading": "$4.41 - én gang",
          "point1": "EIN/SSN/DUNS er påkrevd",
          "point2": "Mer enn ett telefonnummer er tillatt"
        },
        "standardCampaign": {
          "heading": "$16,54 – én gang",
          "point1": "Mer enn ett nummer er tillatt å koble til en standardkampanje.",
          "point2": "EIN/SSN/DUNS er påkrevd",
          "infoText": "En ekstra kampanjeavgift på opptil $12 per måned vil påløpe i henhold til TCR-reglene."
        },
        "standardSubtitle": "Standard merkevare- og kampanjedetaljer",
        "title": "Merkevare- og kampanjedetaljer"
      },
      "businessInfo": {
        "soleProp": {
          "contactInfo": "Kontaktinformasjon",
          "contactInfoSubtitle": "Dette kan være en hvilken som helst person som kan svare på spørsmål om denne merkevaren, hvis nødvendig. Legg merke til at du ikke kan bruke samme kontaktinformasjon for flere merkevarer. Hvert merke du oppretter, må ha unik kontaktinformasjon.",
          "emailHelper": "Ikke bruk den samme e-posten for mer enn fem merkevarer.",
          "phoneNumberHelper": "Ikke bruk det samme telefonnummeret for mer enn fem merkevarer.",
          "profileName": "Firmanavn eller ditt for- og etternavn*",
          "profileNameHelper": "Bruk enten det juridiske navnet til organisasjonen som sender meldingene, eller ditt eget navn hvis denne merkevaren ikke er for en organisasjon.",
          "nextLoading": "Neste …",
          "invalidPhoneNumber": "Ugyldig telefonnummer",
          "phoneNumberWithCountryCode": "Telefonnummer (med landskode)*",
          "phoneNumberRequired": "Telefonnummer er påkrevd.",
          "emailRequired": "E-post er obligatorisk.",
          "profileNameRequired": "Profilnavn er påkrevd."
        },
        "standard": {
          "businessType": "Type bedrift*",
          "legalBusinessName": "Bedriftens juridiske navn*",
          "legalBusinessNameHelper": "Oppgi firmanavnet nøyaktig slik det er registrert hos myndighetene og oppgitt i skattepapirene (CP 575). F.eks. Leadconnector LLC i stedet for Leadconnector.",
          "regionsOfOperations": "Bedriftens forretningsregioner*",
          "registrationNumber": "Bedriftens registreringsnummer*",
          "registrationNumberHelper": "Nummeret som brukes til å identifisere bedriften din. For amerikansk EIN må det være et 9-sifret nummer, f.eks. 12-3456789.",
          "registrationType": "Bedriftens type registrerings-ID*",
          "website": "Bedriftens nettsted*"
        }
      },
      "businessProfileRegistration": {
        "stepProgress": "Trinn {currentStep} av {businessInfoSteps}"
      },
      "businessProfileSuccess": {
        "message": "Bedriftsprofilen Deres er sendt inn med suksess.",
        "startA2P": "Start A2P-registrering",
        "title": "Forretningsprofil sendt inn med hell",
        "tooltips": {
          "agency": "Byråbrukere kan starte A2P-registrering.",
          "location": "Lokasjonsbrukere kan starte A2P-registrering"
        }
      },
      "campaign": {
        "endUserConsent": {
          "closeExample": "Lukk eksempel",
          "optInKeywords": "Påmeldingsnøkkelord*",
          "optInKeywordsHelper": "Maks. lengde: 255 tegn.",
          "optInKeywordsPlaceholder": "Nøkkelord separert med komma, eksempel: SUBSCRIBE, START.",
          "optInMessage": "Påmeldingtekst*",
          "optInMessageInfo": "Må inneholde bedriftsnavn og avmeldingsnøkkelord",
          "optInMessagePlaceholder": "Eksempel: Du har meldt deg på for å motta varsler og kampanje-SMS fra company_name. Svar STOP hvis du trenger å melde deg ut i fremtiden.",
          "placeholder": "Eksempel: Sluttbrukere samtykker ved å besøke - https://www.mycompany.com/book og fylle ut detaljene sine. Brukere krysser av i en boks for å motta varsler og reklamemeldinger fra oss for å gi sitt samtykke. I tillegg kan sluttbrukere også sende START til +1 (213) 725-2867.",
          "question": "Hvordan samtykker sluttbrukerne til å motta meldinger?*",
          "seeExample": "Se eksempel"
        },
        "messageDetails": {
          "embeddedLink": "Meldingen vil inneholde en innebygd lenke",
          "phoneNumbers": "Meldingene vil inneholde telefonnumre",
          "sampleMessage1Placeholder": "Eksempel: Hei, John! Dette er Jane fra company_name. Vår avtale den 20. juli kl. 11.00 er bekreftet. Ta kontakt med +1(213) 725-2867 hvis du må endre avtalen. Svar STOP for å melde deg av.",
          "sampleMessage2Placeholder": "Eksempel: Hei, Brian! Dette er Jane fra company_name. Jeg ser at du ikke kunne komme til avtalen vår. Vil du å endre timeplanen? – https://www.mycompany.com/book. Svar STOP for å melde deg av.",
          "sampleMessageInfo": "Må inneholde leadnavn, ditt navn, firmanavn og avmeldingsspråk",
          "subtitle": "Legg til eksempelmeldinger"
        },
        "useCaseDetails": {
          "explainInDetail": "Gi detaljert forklaring",
          "pickUseCase": "Velg brukstilfelle for kampanje",
          "solePropLabel": "Enkeltpersonforetak",
          "subtitle": "Angi kampanjedetaljer og beskrivelse",
          "useCase": "Brukstilfelle for kampanje*",
          "useCaseDescription": "Beskrivelse av brukstilfelle*",
          "useCaseDescriptionPlaceholder": "Eksempel: Denne kampanjen sender informasjon om avtaler – bekreftelses- og påminnelsesmeldinger til kundene våre når de har bestilt en time hos oss på nettstedet vårt og har valgt å motta reklame- og varslings-SMS fra oss."
        }
      },
      "einModal": {
        "disableNoEINText": "Bare bedrifter med gyldig adresse i USA og Canada har lov til å registrere A2P-merkevare uten et skattenummer.",
        "hasEIN": "Ja, bedriften jeg registrerer har et skattenummer (f.eks. EIN, CCN osv.).",
        "infoText": "Du finner den amerikanske EIN-en din på CP 575-skjemaet.",
        "noEIN": "Nei, bedriften jeg registrerer har ikke et skattenummer (f.eks. EIN, CCN osv.).",
        "question": "Har bedriften du registrerer et skatteregistreringsnummer (f.eks. EIN, CCN osv.)?*",
        "title": "Bestem A2P-merkevarens behov"
      },
      "exampleModal": {
        "examples": "Eksempler"
      },
      "otpError": {
        "message": "Det oppsto et problem med sending av OTP.",
        "title": "Kunne ikke sende OTP på nytt"
      },
      "otpSuccess": {
        "title": "OTP-en din er sendt."
      },
      "validation": {
        "cityRequired": "By er påkrevd.",
        "countryRequired": "Land er påkrevd.",
        "invalidMobileNumber": "Ugyldig mobilnummer",
        "postalCodeRequired": "Postnummer er påkrevd.",
        "stateRequired": "Stat er påkrevd.",
        "streetAddressRequired": "Gateadresse er påkrevd."
      }
    },
    "affiliates": {
      "affiliateAboutIframe": "affiliate-about-iframe",
      "agencyOwner": "Byråeier",
      "agencyOwnerAndAdmins": "Byråeier og administratorer",
      "contactAgencyOwner": "Hvis du trenger hjelp, kontakt din",
      "firstPromoterAccessMessage": "Denne FirstPromoter-rapporten er kun tilgjengelig for",
      "firstPromoterIframe": "firstpromoter-iframe",
      "noPartnerFound": "Fant ikke en partner som samsvarer med filtrene dine. Klikk",
      "paymentDetailsAccessMessage": "Denne delen for betalingsdetaljer er kun tilgjengelig for og kan kun redigeres av",
      "toApplyPartner": "for å søke om å bli partner."
    },
    "common": {
      "actions": {
        "googleDrive": "Google Drive"
      },
      "labels": {
        "doc": "Doc"
      },
      "loading": "Laster",
      "legalBusinessNameHelper": "Oppgi firmanavnet nøyaktig slik det er registrert hos myndighetene og oppgitt i skattepapirene (CP 575). F.eks. Leadconnector LLC i stedet for Leadconnector."
    },
    "desktop": {
      "highlevel": {
        "logoAltText": "HighLevel Logo",
        "launchingDescription": "Klikk <span class='font-semibold'>Åpne HighLevel</span> for å starte skrivebordsappen.<br>Fungerer det ikke? Du kan også <a href=\"/\" class='!text-blue-700 hover:underline'>bruke HighLevel i nettleseren</a>",
        "launchingTitle": "Starter HighLevel Desktop",
        "launchButtonText": "Åpne HighLevel"
      },
      "leadconnector": {
        "logoAltText": "LeadConnector Logo",
        "launchingDescription": "Klikk <span class='font-semibold'>Åpne LeadConnector</span> for å starte skrivebordsappen.<br>Fungerer det ikke? Du kan også <a href=\"/\" class='!text-blue-700 hover:underline'>bruke LeadConnector i nettleseren</a>",
        "launchingTitle": "Starter LeadConnector Desktop",
        "launchButtonText": "Åpne LeadConnector"
      }
    },
    "email": {
      "actionCard": {
        "chooseAction": "Velg en handling",
        "destination": "Destinasjon",
        "removeFromAllCampaigns": "Denne handlingen vil fjerne potensielle kunder fra alle kampanjer unntatt den aktuelle kampanjen",
        "triggerLinks": "Trigger-lenker"
      },
      "importTemplate": {
        "errorImporting": "Feil under import av mal!",
        "importTemplate": "Importer mal",
        "importing": "Importerer",
        "title": "Importer {entityName} malen",
        "unnamedEntity": "Ikke navngitt kopi av {entityName}"
      },
      "lcEmail": {
        "migrationModal": {
          "below": "nedenfor",
          "confirmByTyping": "Vennligst bekreft ved å skrive",
          "confirmWord": "BEKREFT",
          "existingNotMoved": "Hvis kunden din allerede har Mailgun eller SMTP-oppsett, vil de ikke bli flyttet over",
          "notNow": "Ikke nå",
          "pricingInfo": "LC Email er billigere enn Mailgun og vil koste omtrent $0,68 for 1000 e-poster",
          "setAsDefault": "Angi LC Email som standardleverandør for byrået ditt og kunder som ikke allerede har Mailgun eller SMTP",
          "thisWill": "Dette vil:",
          "title": "Du migrerer til Lead Connector e-post",
          "useLcEmail": "Bruk LC Email"
        }
      },
      "newPostModal": {
        "dragDropMedia": "Dra eller slipp media her",
        "editPost": "Rediger innlegg",
        "enterText": "Skriv inn tekst her",
        "exampleComment": "Veldig kult!! Ser frem til dette!",
        "exampleName": "Test Tech",
        "hashtag1": "#hashtag",
        "hashtag2": "#flott",
        "hashtag3": "#kult",
        "imagePlaceholder": "img(02).png",
        "needReview": "Trenger du en anmeldelse?",
        "network": "Nettverk",
        "photo": "bilde",
        "previewPost": "Forhåndsvisning av innlegg",
        "selectNetwork": "Velg sosialt nettverk",
        "sizeExample": "245kb",
        "textExample": "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        "urlExample": "https://searchengineland.com/google-announces-new-features-for-retail-advertisers-at-smx-advanced-300001"
      },
      "numberPool": {
        "confirmation": {
          "createdMultiple": "Du har opprettet en nummerpulje på {count} numre for å spore besøkende på nettstedet ditt. <br />Samtalene dine vil bli viderekoblet til",
          "createdSingle": "Du har opprettet {count} nummer for å spore besøkende på nettstedet ditt. <br />Samtalene dine vil bli viderekoblet til",
          "percentComplete": "100 % fullført"
        },
        "create": {
          "correctErrors": "Rett opp feilene!",
          "forwardHelp": "Fortell oss hvilken telefon som skal ringe når kunden ringer sporingstelefonnummeret ditt. Dette er vanligvis det primære telefonnummeret til bedriften din. Eksempel: 404-555-1212",
          "heading": "Nummerpulje og viderekobling av anrop",
          "nameHelp": "{name} er hva vi kaller dette sporingsnummeret i kontoen din. Velg et kort navn som er lett å huske.",
          "newTrackingNumbers": "nye sporingsnumre.",
          "nextTracking": "Neste: Alternativer for sporing",
          "percentComplete": "50 % fullført",
          "pleaseConfirm": "Bekreft:",
          "poolSize": "Puljestørrelse",
          "poolSizeError": "Angi en utvalgsstørrelse mellom 4 og 30 sporingsnumre.",
          "poolSizeHelp": "Størrelsen på tallpuljen din avgjør hvor mange samtidige besøkende vi kan spore på nettstedet ditt til enhver tid. Størrelsen på puljen bør være en fjerdedel av den høyeste timesvise trafikken som rapporteres i Google Analytics, med minst fire numre.",
          "swappingHelp": "Fortell oss hvilket telefonnummer vi skal bytte ut på nettstedet. Eksempel: 404-555-1212",
          "swappingNumber": "Bytte av nummer",
          "validationError": "Det oppstod en feil ved validering av skjemaet"
        },
        "features": {
          "activateNumber": "Aktiver nummer",
          "address": "{type}-adresse",
          "addressHelp": "Kjøpsnummer for enkelte land krever adresse. Ta kontakt med brukerstøtte om hvordan du legger til adresse hvis du trenger hjelp.",
          "heading": "Nummerfunksjoner",
          "leaveBlank": "La det stå tomt for å utelate melding",
          "recordingDescription": "Aktiver anropsopptak og spill av en kort melding til den som ringer.",
          "recordingHelp": "Noen jurisdiksjoner krever at begge parter samtykker til at samtalen tas opp. For å bidra til overholdelse av disse lovene kan du aktivere en hilsen for å informere den som ringer, om at samtalen kan bli tatt opp.",
          "whisperDescription": "En kort melding som spilles av før telefonsamtalen. Den som ringer hører ikke denne meldingen."
        },
        "tracking": {
          "heading": "Sporingsalternativer",
          "nextCreatePool": "Neste: Opprett pulje",
          "percentComplete": "34 % fullført",
          "searchLower": "søk"
        },
        "whatToTrack": {
          "heading": "Hva ønsker du å spore på nettstedet ditt?",
          "trackCampaign": "Spor en markedsføringskampanje",
          "trackCampaignDescription": "Opprett ett telefonnummer som sporer alle innringere til én enkelt markedsføringskampanje.",
          "trackVisitor": "Spor besøkendes aktivitet",
          "trackVisitorDescription": "Opprett flere numre som korrelerer samtaler med besøkende på nettstedet, PPC-søkeord og mer."
        }
      }
    },
    "loader": {
      "clickHereToRefresh": "klikk her for å oppdatere.",
      "issuesLoadingApp": "Hvis du har problemer med å laste inn appen",
      "loadingFreshData": "Laster inn nye data …",
      "loadingNewSubAccountData": "Laster inn nye underkontodata …"
    },
    "login": {
      "bySigningInYouAgree": "Ved å logge inn godtar du våre <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>vilkår og betingelser</a>",
      "newPasswordSent": "Et nytt passord sendes til e-posten din."
    },
    "regulatoryBundle": {
      "a2p": {
        "activityHistory": {
          "by": "Av:"
        },
        "affiliates": {
          "partnerBadgeAlt": "Partnermerke"
        },
        "checkout": {
          "cardInformation": "Kortinformasjon",
          "cardNumberInvalid": "Kortnummeret ditt er ugyldig.",
          "commitment": "bindingstid",
          "consentOneTime": "Ved å bekrefte tillater du LeadConnector å belaste kortet ditt for denne betalingen.",
          "consentSubscription": "Ved å bekrefte abonnementet ditt, gir du LeadConnector tillatelse til å belaste kortet ditt for denne betalingen og fremtidige betalinger for dette abonnementet.",
          "defaultIntervalCount": "1",
          "endingIn": "som slutter med",
          "errorImageAlt": "Illustrasjon av feil",
          "intervalSuffix": "(s)",
          "month": "Måned",
          "pay": "Betal",
          "payWithCard": "betal med kort",
          "paymentProcessing": "Betalingen behandles. Ikke last inn siden på nytt eller klikk på tilbake-knappen",
          "proceedWithExistingCard": "Fortsett med eksisterende kort",
          "proceedWithNewCard": "Fortsett med et nytt kort",
          "prorationDetails": "Du vil bli belastet for {days} dager akkurat nå for perioden frem til {billingEnd}, og vil bli belastet hele beløpet på ${amount}/måned fra og med {billingDate}.",
          "prorationMessage": "Innledende kostnader er pro rata, og regelmessig fakturering vil starte fra {billingDate}",
          "purchase": "kjøp",
          "subscribe": "Abonner",
          "subscribeTo": "Abonner på",
          "updateCardDetails": "Oppdater kortinformasjonen",
          "zip": "postnummer"
        },
        "options": {
          "jobPosition": {
            "gm": "GM",
            "vp": "VP"
          }
        },
        "registration": {
          "stepProgress": "Trinn {currentStep} av 8",
          "successDescription": "A2P-merkevaren og kampanjen din er sendt inn.",
          "successMessage": "Merk: Du vil motta en OTP-melding fra TCR på ditt oppgitte mobilnummer for verifisering. Vennligst svar Ja innen 24 timer etter at du har mottatt SMS-en.",
          "successWaitDays": "7 dager",
          "successWaitPrefix": "Det kan ta opptil ",
          "successWaitSuffix": " for godkjenning av merkevaren din og ytterligere 4–5 uker for godkjenning av kampanjen."
        },
        "reminder": {
          "noReplyYet": "Ingen svar ennå",
          "patientConfirmed": "Pasient bekreftet"
        },
        "sendGrid": {
          "apiKeyRequired": "API Key påkrevd"
        },
        "update": {
          "brandNameHelper": "Bruk det juridiske navnet til organisasjonen som sender meldingene.",
          "businessVerticals": "Forretningsvertikaler*",
          "resendOTP": "Send OTP på nytt",
          "retryOTPTitle": "Prøv OTP-verifisering på nytt"
        }
      },
      "addCustomEmailModal": {
        "title": "Legg til egendefinert e-post"
      },
      "addEditSMTPServiceModal": {
        "addProvider": "Legg til leverandør",
        "clickHereForInfo": "Klikk her for å få mer informasjon.",
        "clickHereToFindOut": "Klikk her for å finne ut mer om dem.",
        "createProviderError": "Noe gikk galt under opprettelsen av leverandøren!",
        "gmailLimitations": "Gmail har visse begrensninger.",
        "needHelp": "Trenger du hjelp til å finne SMTP-server og portnummer?",
        "port25NotSupported": "Port 25 støttes ikke! Bruk port 2525 i stedet",
        "providerExists": "Det finnes allerede en leverandør med denne e-postadressen/brukernavnet.",
        "providerName": "Leverandørnavn",
        "selectProvider": "Velg leverandør",
        "smtpPortNumber": "SMTP-portnummer",
        "smtpProvider": "SMTP-leverandør",
        "smtpServer": "SMTP-server",
        "username": "Brukernavn",
        "usernameOrEmailRequired": "Enten brukernavn eller e-post kreves.",
        "verifySmtpAccount": "Verifiser SMTP-konto"
      },
      "addTagModal": {
        "addTag": "Legg til tagg",
        "editTag": "Rediger tagg",
        "tagAlreadyExists": "Taggen {tag} finnes allerede"
      },
      "affiliates": {
        "firstPromoterAccessMessage": "Denne FirstPromoter-rapporten er kun tilgjengelig for <strong>byråets eier og administratorer</strong>. Hvis du trenger hjelp, kan du kontakte <strong>byråeieren din ({agencyOwnerEmail})</strong>.",
        "firstPromoterIframeTitle": "FirstPromoter-kontrollpanel",
        "noPartnersFound": "Fant ikke en partner som samsvarer med filtrene dine. Klikk <a href='javascript:void(0);'>her</a> for å søke om å bli partner.",
        "paymentDetailsAccessMessage": "Kun <strong>byråets eier</strong> kan åpne eller redigere denne delen med betalingsopplysninger. Hvis du trenger hjelp, kan du kontakte <strong>byråeieren din ({agencyOwnerEmail})</strong>."
      },
      "appointmentDetails": {
        "title": "Avtaledetaljer"
      },
      "attachSnapshotToggle": {
        "loadSnapshot": "Last inn øyeblikksbilde:",
        "loadSnapshotWarning": "Ønsker du å laste inn øyeblikksbildet som er knyttet til denne planen? <br /> <strong class='text-danger'>Eksisterende data kan gå tapt</strong>"
      },
      "auth": {
        "changePassword": {
          "changeButton": "Endre passord",
          "confirmPassword": "Bekreft det nye passordet",
          "expired": "Lenken for tilbakestilling av passord har utløpt.",
          "regenerateLink": "Regenerer lenke",
          "success": "Passordet er endret",
          "title": "Angi nytt passord",
          "passwordMismatch": "Passordene stemmer ikke overens"
        },
        "forgotPassword": {
          "contactAgency": "Kontakt byrået ditt.",
          "contactSupport": "kontakt HighLevel Support døgnet rundt ved å ringe",
          "supportMessage": "Hvis du ikke har tilgang til den e-postboksen, vennligst",
          "successMessage": "En lenke for tilbakestilling av passord sendes til e-posten din.",
          "rateLimitError": "For mange forespørsler om tilbakestilling av passord. Prøv igjen senere."
        },
        "login": {
          "inactivityMsg": "Vi har lagt merke til at du har vært inaktiv en stund, så vi har logget deg ut for å ivareta sikkerheten.",
          "loginButton": "Logg inn",
          "resetPasswordMsg": "Lenken for å tilbakestille passordet er sendt til e-posten din.",
          "signInWithGoogle": "Logg inn med Google",
          "contactHighLevelSupport": " kontakt HighLevel Support døgnet rundt ved å ringe"
        },
        "logout": {
          "loggingOut": "Logger ut ..."
        },
        "otp": {
          "enterBackupCode": "Skriv inn sikkerhetskoden",
          "resend": "Send på nytt",
          "resendIn": "Send på nytt om",
          "sendToPhone": "Send kode til telefonen",
          "sending": "Sender",
          "useAuthenticator": "Bruk Authenticator-appen",
          "useBackupCode": "Bruk sikkerhetskode",
          "verifyButton": "Verifiser med sikkerhetskode"
        },
        "sso": {
          "agreeTerms": "Ved å logge inn godtar du våre <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>vilkår og betingelser</a>",
          "and": ", og",
          "loginDifferentMethod": "Logg inn med en annen metode",
          "loginSuccessRedirecting": "Pålogging er utført, omdirigerer …",
          "processing": "Behandler forespørselen din …",
          "redirecting": "Omdirigerer …",
          "redirectingToDashboard": "Omdirigerer til kontrollpanelet …",
          "signedIn": "Logget inn",
          "signingIn": "Logger på …",
          "testFailedRedirecting": "Testen mislyktes, omdirigerer …",
          "testSuccessRedirecting": "Testen er utført, omdirigerer …"
        }
      },
      "businessDetailModal": {
        "businessAddress": "Bedriftsadresse: {address}",
        "businessDetailsText": "Følgende bedriftsopplysninger vil bli sendt til Google Local Services Ads for Reserve with Google Integration. Sjekk og bekreft eller {link} for å oppdatere bedriftsprofilen din.",
        "businessInfoRequired": "Ovennevnte bedriftsinformasjon er nødvendig for integrering, {link} for å oppdatere manglende/feilaktig bedriftsinformasjon.",
        "businessName": "Bedriftsnavn: {name}",
        "businessNiche": "Forretningsnisje: {niche}",
        "city": "By: {city}",
        "confirmDetails": "Jeg bekrefter herved at ovennevnte opplysninger er korrekte",
        "country": "Land: {country}",
        "mustConfirmDetails": "Du må bekrefte de ovennevnte opplysningene.",
        "phoneNumber": "Telefonnummer: {phone}",
        "state": "Stat: {state}",
        "zipCode": "Postnummer: {zipCode}"
      },
      "calendarHourRow": {
        "addHours": "Legg til timer",
        "applyAll": "Bruk alle"
      },
      "campaign": {
        "callerIdVerificationModal": {
          "answerCall": "Svar på anropet og tast inn denne bekreftelseskoden:",
          "leadConnectorCalling": "Lead Connector ringer …",
          "title": "Legg til en anroper-ID etter stemme",
          "waitingForVerification": "Venter på bekreftelsen …"
        },
        "callerIdVerificationStatus": {
          "failed": "Kunne ikke verifisere anroper-ID. Prøv igjen.",
          "success": "Du har verifisert <strong>{contact}</strong>"
        },
        "choosePhoneNumberModal": {
          "addExistingNumbers": "Legg til eksisterende nummer/numre",
          "areaCode": "Retningsnummer:",
          "checkAvailability": "Sjekk tilgjengelighet",
          "checkingAvailability": "Sjekker nummertilgjengelighet.",
          "chooseAreaCode": "Velg et retningsnummer",
          "choosePhoneNumbers": "Velg telefonnumre",
          "goBack": "Gå tilbake",
          "localNumbers": "Lokalt {type}",
          "nextNumberFeatures": "Neste: Nummerfunksjoner",
          "noExistingNumbers": "Ingen eksisterende nummer(e) kan legges til",
          "noNumbersAvailable": "Ingen numre er tilgjengelig",
          "notEnoughNumbers": "Ikke nok tilgjengelige numre",
          "numbersAvailable": "Tilgjengelige numre",
          "numbersDifferentArea": "Nummer i et annet retningsnummer",
          "numbersLocalTo": "Numre som hører til i <strong>{number}</strong>",
          "problemChecking": "Hvis du har problemer med å sjekke nummerets tilgjengelighet, sjekk nettverkstilkoblingen eller kontakt kundestøtte.",
          "somethingWentWrong": "Noe gikk galt. Sjekk Twilio-kontoopplysningene dine, og send en melding til kundestøtte hvis problemet vedvarer.",
          "tollFreeNumbers": "Gratisnumre (tillegg på 2,00 USD per nummer per måned)",
          "percentageComplete": "67 % fullført"
        },
        "deleteNumberPoolModal": {
          "confirmDelete": "Jeg forstår konsekvensene, slett puljen",
          "confirmText": "Skriv <b>{name}</b> for å bekrefte",
          "title": "Slett nummerpulje – <strong>{name}</strong>",
          "warning": "Denne handlingen kan ikke angres. Dette vil permanent slette nummeret/numrene fra Twilio-kontoen din sammen med nummerpuljen fra databasen vår. Hvis du sletter nummerpuljen fordi du står overfor et problem, kan du også ta kontakt med vårt supportteam."
        },
        "editNumberFormatModal": {
          "description": "Du kan oppdatere formateringen av byttenummer(ene) og bassengnummer(ene) slik det passer deg. Sørg for at byttenummeret/byttenumrene vises på samme måte på nettstedet som de er formatert.",
          "title": "Oppdater nummerformatering – <strong>{name}</strong>"
        },
        "editNumberPoolModal": {
          "addEditGroupId": "Legg til/rediger gruppe-ID",
          "callConnectTooltip": "Denne funksjonen krever at mottakeren trykker på en tast for å koble til samtalen, noe som gir høyere nøyaktighet i samtalerapporteringen.",
          "createGroupIdDescription": "Opprett/legg til en unik gruppe-ID for å bruke flere nummerpuljer med en enkelt JavaScript-kodebit.",
          "enableCallConnect": "Aktiver samtaletilkoblingsfunksjonen",
          "groupId": "Gruppe-ID",
          "outboundCallTimeout": "Tidsavbrudd for utgående anrop",
          "passCallerID": "Send oppringt nummer som anroper-ID",
          "passCallerIDTooltip": "Som standard sender systemet nummeret til innringeren videre, men hvis du vil at oppringer-ID-en skal være nummeret som innringeren har ringt, kan du aktivere denne funksjonen.",
          "selectCallerID": "Velg anrops-ID",
          "timeDuration": "Tidsvarighet i sekund(er)",
          "titleNumber": "Nummer – <strong>{number}</strong>",
          "updateWhisperWarning": "Oppdater diskret melding, da denne funksjonen krever at mottakeren trykker på en tast for å koble samtalen.",
          "useVerifiedNumber": "Bruk det bekreftede nummeret ditt som anroper-ID for utgående anrop",
          "useVerifiedNumberTooltip": "Gjelder kun for verifiserte telefonnumre. Du kan verifisere et telefonnummer i Innstillinger > Telefonnumre > Legg til verifisert anroper-ID"
        },
        "emailOTPModal": {
          "confirmCode": "Bekreft kode",
          "resendCode": "Hvis du ikke mottok koden, klikk her for å sende den på nytt",
          "unexpectedIssue": "Uventet problem oppstod"
        },
        "facebookFieldMapModal": {
          "customFieldInfo": "Informasjon om egendefinerte felt",
          "customFieldTooltip": "Tilpasset feltverktøytips: {options}",
          "field": "{companyName} felt",
          "trackingParameters": "Parametere for sporing",
          "zipCode": "Postnummer"
        },
        "howToUseNumberPoolModal": {
          "addSwappingNumbers": "Legg til nummerbytte",
          "addingSnippets": "Legge til JavaScript-kodebiter",
          "groupSnippet": "Gruppe '{id}' kodebit",
          "normalSnippet": "Normalt kodebit",
          "noswapDescription": "Hvis du ikke vil at vi skal bytte nummer på et bestemt sted, legg til klassen 'noswap'.",
          "notReplacing": "Ikke erstatte på et bestemt sted",
          "requiredSteps": "Obligatoriske trinn",
          "snippetsDescription": "Kopier kodebiten nedenfor og legg den til like over den avsluttende body-taggen på hver side der du vil erstatte tallene.",
          "swappingDescription": "Bruk tallene under for å aktivere bytte av telefonnummer. Velg et lokalt eller internasjonalt format, eller begge deler."
        },
        "newPhoneNumberModal": {
          "areaCode": "Retningsnummer",
          "availableNumbers": "Tilgjengelige numre",
          "bundle": "Pakke",
          "chooseAddress": "Velg adresse …",
          "chooseBundle": "Velg pakke …",
          "createRegulatory": "Opprett en regulatorisk pakke/adresse her.",
          "monthlyFee": "Månedlig pris",
          "noNumbersFound": "Ingen numre funnet, prøv et annet retningsnummer.",
          "selectAddress": "Velg \"Adresse\" for å kjøpe nummer.",
          "selectBundle": "Velg \"Pakke\" for å kjøpe nummer.",
          "title": "Legg til telefonnummer",
          "upgradeAccount": "Oppgrader Twilio-kontoen din, bare oppgraderte kontoer kan kjøpe telefonnumre og foreta telefonsamtaler.",
          "cardAuthenticationFailed": "Kortautentisering mislyktes!"
        },
        "reserveWithGoogleIntegration": {
          "agreeTerms": "Du må godta vilkårene og personvernstatusen.",
          "clickingProceed": "Ved å klikke på Fortsett, åpnes LSA-koblingssiden i en ny fane",
          "configureCalendar": "Konfigurer minst én kalender for å fortsette med å reservere med Google-integrasjon",
          "configureCalendarBtn": "Konfigurere kalenderen",
          "linkOneAccount": "Sørg for at du bare kobler til én konto. Kontakt kundestøtte hvis du ikke kan se siden i skjermbildet ovenfor.",
          "readInstructions": "Jeg har lest de nevnte instruksjonene."
        },
        "updateTrackingModal": {
          "title": "Oppdater sporingsalternativ"
        },
        "usageSummary": {
          "agencyOnlyVisible": "(Dette er kun synlig for byråadministratorer)",
          "updatedEvery24Hours": "(oppdateres hver 24. time)"
        },
        "userCalendarConfiguration": {
          "calendarNotSelected": "Kalender er ikke valgt for synkronisering",
          "check": "Sjekk {email}",
          "checkForConflicts": "Kontroller konflikter",
          "checkForConflictsTooltip": "Still inn kalenderen(e) til å se etter konflikter for å unngå dobbeltbookinger.",
          "contactCreationAllowed": "Opprettelse av kontakt er tillatt",
          "googleCalendar": "Google Kalender-logo",
          "noGoogleAccounts": "Ingen google/outlook-kontoer lagt til i integrasjonsinnstillingene ennå",
          "noGoogleAccountsTeamMember": "Ingen google/outlook-kontoer er lagt til for dette teammedlemmet på den aktuelle plasseringen. Be teammedlemmet ditt om å logge inn via kontoen sin og legge til Google-tilkobling fra integrasjonsinnstillingene.",
          "outlookCalendar": "Outlook-brukerkalender",
          "primaryCalendarTooltip": "Angi kalenderen du vil legge til nye hendelser i etter hvert som de er planlagt.",
          "runTriggerAllowed": "Kjør utløser er tillatt"
        },
        "warningModal": {
          "contactAgency": "Ta kontakt med byrået ditt for å endre e-postinnstillingene.",
          "title": "Advarsel"
        }
      },
      "checkout": {
        "prioritySupport": {
          "features": {
            "faster247Chat": "Raskere døgnåpen chatstøtte",
            "faster247Ticket": "Raskere billettstøtte og svartider døgnet rundt"
          },
          "highlight": {
            "description": "Vi forstår det, du må gå raskere. Når du har et spørsmål eller en problemstilling, vil du ha svar så snart som mulig! Med Priority Support Upgrade kan du hoppe over køen og automatisk få forespørslene dine til å komme først i køen.",
            "heading": "Er du klar for VIP-behandling?"
          },
          "name": "Prioritert støtte",
          "success": {
            "description": "Prioritert støtte er aktivert på din konto. Ingen flere køer som venter på deg.",
            "heading": "Du er nå en prioritert kunde!"
          }
        }
      },
      "cloneFunnel": {
        "cloneButton": "Klone {entityName}",
        "cloning": "Kloner …",
        "cloningLimit": "Kloning er begrenset til tre underkontoer om gangen",
        "error": "Feil under kloning av trakt!",
        "locationsLabel": "Velg steder",
        "nameLabel": "Navn for den klonede {entityName}",
        "namePlaceholder": "Angi navn for klonet {entityName}",
        "selectUpTo": "Velg opptil {maxSelectableLocations} steder",
        "title": "Klone {entityName}"
      },
      "cnam": {
        "learnMore": {
          "description": "Med CNAM vises bedriftsnavnet ditt på anrops-ID-en, noe som gjør anropene dine umiddelbart gjenkjennelige og øker tilliten. La kundene dine vite at det er du som ringer hver gang.",
          "title": "Få anropene dine til å skille seg ut!"
        },
        "registration": {
          "characterLimit": "{count}/15",
          "confirm": "Bekreft og registrer",
          "description": "Vis bedriftsnavnet ditt til mottakerne for å øke tilliten og svarprosenten.",
          "title": "Øk tilliten til samtaler med CNAM",
          "warning": "Visning av bedriftsnavn er ikke garantert, spesielt ikke på mobil."
        },
        "submitted": {
          "checkStatus": "Sjekk CNAM-status",
          "description": "Bedriftsnavnet ditt bør vises til aktuelle kontakter i løpet av 3–5 dager.",
          "subtitle": "CNAM-forespørselen din er nå sendt inn.",
          "title": "Gratulerer!"
        }
      },
      "confirmMerchantDeleteModal": {
        "confirmDelete": "Bekreft sletting",
        "confirmation": "Bekreftelse"
      },
      "createAddress": {
        "successTitle": "Adressen er sendt inn",
        "underReview": "Innsendt adresse er under vurdering"
      },
      "createEndUser": {
        "dateFormat": "Datoformatet skal være ÅÅÅÅ-MM-DD.",
        "phoneExample": " Eksempel: +14155552671",
        "title": "Bedriftsdetaljer:"
      },
      "customValueModal": {
        "changingNameWarning": "Endring av navnet vil ikke påvirke feltnøkkelen.",
        "editCustomValue": "Rediger egendefinert verdi",
        "fieldKeyCreatedWarning": "Feltnøkkelen opprettes i henhold til navnet og kan ikke endres senere.",
        "nameRequired": "Navnefeltet er obligatorisk",
        "nameValidation": "Navnet skal være alfanumerisk og inneholde minst ett tegn",
        "valueRequired": "Verdifeltet er obligatorisk"
      },
      "details": {
        "addressName": "Adressenavn",
        "addressTitle": "Adressedetaljer",
        "bundleName": "Pakkenavn",
        "bundleTitle": "Detaljer om regelverkspakken",
        "countryFlag": "{country} flagg",
        "id": "ID",
        "organisation": "Organisasjon",
        "rejectionReason": "Avvisningsårsak",
        "status": {
          "approved": "Godkjent",
          "notValidated": "Ikke validert",
          "rejected": "Avvist",
          "validated": "Validert"
        },
        "typeOfNumber": "Type nummer"
      },
      "drChronoOfficeSelect": {
        "selectOffice": "Velg kontor",
        "whichOffice": "Hvilket kontor vil du koble til denne kontoen?"
      },
      "editAddToCalendarModal": {
        "allowContactCreation": "Tillat opprettelse av kontakt:",
        "allowTrigger": "Tillat utløser:",
        "doNotSync": "Ikke synkroniser nye hendelser til den primære kalenderen",
        "primaryCalendarTooltip": "Du kan bare velge en kalender med skrivetillatelse som du ikke har valgt for å sjekke konflikter.",
        "selectDefaultCalendar": "Velg standardkalender",
        "whichCalendar": "Hvilken kalender skal vi bruke til å synkronisere (lese og skrive) hendelser til?"
      },
      "editCheckForConflictsCalendarsModal": {
        "checkThesePlaces": "Sjekk disse stedene for eventuelle konflikter",
        "howToCheckConflicts": "Hvordan bør vi sjekke for konflikter?"
      },
      "ejectModal": {
        "agencyClosing": "Elite Marketing-byråkontoen med Highlevel avsluttes. Hvis du vil beholde kontoen din, kan du kontakte {userName} for å migrere kontoen din direkte til Highlevel.",
        "cancelWarning": "Vær oppmerksom på at kontoen din offisielt kanselleres 30. juni 2025, og vi vil ikke kunne hente dataene dine etter denne datoen hvis overføringen ikke er fullført.",
        "contactEmail": "transfers{'@'}gohighlevel.com",
        "contactUs": "Hvis du har spørsmål, kan du ta kontakt på",
        "faqsUrl": "gohighlevel.com/getstartedtoday-em",
        "freeTransition": "For å støtte deg under denne kostnadsfrie overgangen, gir vi deg {months} med gratis tilgang til det nye abonnementet ditt.",
        "intro": "På grunn av gjentatte brudd på HighLevels tjenestevilkår, er Elite Marketing Authority (EMA) permanent fjernet fra HighLevel-plattformen.",
        "platformCommitment": "Som plattformen som driver EMAs tjenester, er HighLevel forpliktet til å opprettholde et trygt, kompatibelt og pålitelig miljø for alle brukere. For å unngå avbrudd i kontoen din, er vi her for å hjelpe deg med en sømløs overgang - enten til en annen white label-leverandør eller direkte til HighLevel.",
        "questions": "Hvis du har spørsmål,",
        "retainAccess": "Hvis du vil beholde tilgangen til eksisterende data og verktøy, klikker du på knappen nedenfor og følger instruksjonene for å starte overføringen.",
        "speakWithTeam": "å snakke med teamet vårt.",
        "startTransfer": "Start din gratis overføring",
        "title": "Til kunder av Elite Marketing",
        "viewFaqs": "Se vanlige spørsmål her:",
        "whiteLabel": "Hvis du foretrekker å få tilgang til HighLevel gjennom en annen white label-leverandør, vil vi gjerne imøtekomme denne endringen via vårt kundestøttesystem etter at du har overført kontoen din direkte til HighLevel."
      },
      "emailTemplate": {
        "createdOn": "Opprettet den",
        "updatedOn": "Oppdatert den"
      },
      "error": {
        "title": "Innsending av regelverkspakke mislyktes"
      },
      "errors": {
        "funnel": {
          "multiplePages": "Mer enn én side har denne URL-en. Endre banen til denne siden for å få den til å fungere.",
          "urlNotFound": "Beklager, vi finner ikke URL-adressen du leter etter"
        },
        "productRebilling": {
          "requestFailed": "Forespørselen mislyktes"
        },
        "template": {
          "categoryNotFound": "Beklager, vi finner ikke kategorien du leter etter.",
          "internalError": "En intern feil har oppstått!"
        },
        "transfer": {
          "hipaaEnabled": {
            "message": "Underkontoen du prøver å overføre er HIPAA-aktivert, og kan ikke overføres til et byrå som ikke er HIPAA-aktivert."
          },
          "limitExceeded": {
            "message": "Byrået som du prøver å overføre underkontoen til har brukt opp deres bruksgrense og kan ikke få flere underkontoer.  Be dem enten slette en underkonto som ikke er i bruk eller oppgradere til en høyere byråplan for å få denne underkontoen."
          },
          "pendingRequest": {
            "heading": "En overføringsforespørsel for denne underkontoen venter allerede.",
            "message": "Kanseller den eksisterende overføringsforespørselen for denne underkontoen før du fortsetter med å opprette en ny."
          }
        }
      },
      "facebookPageSelect": {
        "cannotFind": "Finner du ikke siden du leter etter? Gå til Facebook-innstillingene dine og sørg for at alle sidene er valgt.",
        "instagramAvailable": "Instagram er tilgjengelig for denne kontoen!",
        "noPages": "Du har ingen sider under denne kontoen.",
        "title": "Velg hvilken Facebook-side du vil koble til denne plasseringen"
      },
      "googleLocationSelect": {
        "closeButton": "Lukk!",
        "enableCallTracking": "Aktiver sporing av GBP-samtaler",
        "noBusinesses": "Du har ingen tilknyttede virksomheter under denne kontoen."
      },
      "importCustomers": {
        "newExperience": {
          "efficient": "Mer effektivt",
          "faster": "Raskere",
          "itsText": "Det er",
          "smoother": "Jevnere",
          "title": "En ny importopplevelse er her!",
          "warningMessage": "Når du aktiverer den nye importopplevelsen, aktiveres Labs for denne underkontoen og Beta-funksjonen slås på."
        },
        "validateEmails": "Validere e-poster?"
      },
      "initBundle": {
        "numberType": "Type numre du har planlagt å bruke",
        "numberTypes": {
          "local": "Lokale numre",
          "mobile": "Mobil",
          "tollfree": "Gratisnummer"
        },
        "selectCountry": "Velg landet ditt",
        "selectUserType": "Velg brukertypen",
        "userTypes": {
          "business": "Bedrift",
          "individual": "Individ"
        }
      },
      "manageLocationCredits": {
        "creditLastAddedOn": "Kreditt sist lagt til den:",
        "currentBalance": "Nåværende saldo",
        "debitBalance": "- Debetsaldo",
        "depositComplimentaryCreditsOf": "Legg til gratis kreditter verdt",
        "manageBalance": "Administrer saldo",
        "mustBeValidInteger": "Må være et gyldig heltall",
        "nextDate": "Neste dato:",
        "perMonth": "per måned",
        "remainingWalletBalance": "Gjenværende saldo i lommeboken for denne underkontoen",
        "rolloverCredits": "Overfør kreditt til neste måned",
        "toManageMonthlyCredits": "For å administrere månedlige kreditter,"
      },
      "manageLocationSubscriptionModal": {
        "addNewSubscription": "Legg til nytt abonnement"
      },
      "manualActions": {
        "confirmDelete": "Er du sikker på at du vil slette denne handlingen?",
        "confirmDeleteAll": "Er du sikker på at du vil slette alle de manuelle handlingene på denne siden?"
      },
      "membership": {
        "resetPassword": {
          "generateStrongPassword": "Generer et sterkt passord",
          "sendEmailNotification": "Send også et e-postvarsel."
        }
      },
      "modal": {
        "description": "Du må fullføre noen få enkle overholdelsestrinn for å bruke telefonsystemer",
        "submit": "Send inn",
        "title": "Lead connector-telefontjeneste"
      },
      "notifications": {
        "list": {
          "homePageVisitors": "Besøkende på startsiden",
          "launched": "Lansert",
          "newNotification": "Nytt Push-varsel",
          "startMessage": "Begynn å øke konverteringen ved å opprette ditt første varsel",
          "types": {
            "combination": "Kombinasjon"
          }
        },
        "page": {
          "createTitle": "Opprett ny varsling",
          "steps": {
            "display": "Visning",
            "track": "Spor"
          }
        }
      },
      "opportunities": {
        "columns": {
          "additionalInfo": "Tilleggsinformasjon",
          "calendarEvent": "Kalenderhendelse",
          "hideAssignedTo": "Skjul tilordnet til",
          "hideTags": "Skjul tagger"
        },
        "filters": {
          "dateAddedAsc": "↑ Dato lagt til (STIG)",
          "dateAddedDesc": "↓ Dato lagt til (SYNK)",
          "orderBy": "SorterEtter"
        },
        "getStarted": "kom i gang!",
        "noPipelines": "Oops! Det ser ut til at det ikke er noen pipeline. Oprett pipeline for å"
      },
      "pages": {
        "pageMoved": {
          "title": "Oppføringer på nett har flyttet"
        }
      },
      "recentlyVisited": {
        "prices": "{count} priser"
      },
      "reminders": {
        "appointmentReminders": "Avtalepåminnelser",
        "apptTime": "Avtaletid",
        "defaultDateRange": "Søn 1. april 2018 - man 31. april 2018"
      },
      "saasAccountDetailsActiveSubscription": {
        "onHold": "På hold",
        "rebillingOnHoldWarning": "Denne kontoen har allerede konfigurasjoner for omfakturering på vent. SaaS-planen kan bare legges til etter at kunden har lagt til en betalingsmetode.",
        "subscriptionId": "Abonnement-ID:"
      },
      "saasPricingTable": {
        "confirmAndProceed": "Bekreft og fortsett",
        "documents": {
          "acceptedDocuments": "Godkjente dokumenter",
          "acceptedDocumentsLabel": "Godkjente dokumenter:",
          "additionalInfo": "Tilleggsinformasjon:",
          "createAddressLink": "Opprett adresse.",
          "createAddressPrompt": "Opprett en adresse først, og fortsett deretter med å opprette pakken.",
          "documentInfo": "PNG, JPG, PDF opptil 5 MB",
          "documentType": "Dokumenttype",
          "option": "Alternativ {number}",
          "selectAddress": "Velg adresse:",
          "selectDocumentType": "Velg dokumenttype:",
          "selectFile": "Velg fil",
          "title": "Påkrevde dokumenter:",
          "updateDocuments": "Oppdater dokumenter"
        },
        "everythingIn": "Alt i <b>{plan}+</b>",
        "noPaymentMethod": {
          "linkText": "legge til kredittkort her",
          "message": "Be kunden din om å",
          "title": "Underkontoen må legge til betalingsmåte først."
        },
        "noSaasPlan": {
          "linkText": "opprett dine SaaS-planer her.",
          "message": "Vennligst",
          "title": "Du har ingen konfigurert SaaS-plan."
        },
        "saasModeSetupPendingWarning": "SaaS-planen vil bli aktivert etter at kunden legger til en betalingsmetode. Inntil da vil kontotilgangen deres være begrenset.",
        "skipForNow": "Hopp over inntil nå",
        "skipPlan": "Hopp over planen",
        "success": {
          "title": "Innsending av regelverkspakke er gjort",
          "underReview": "Innsendt pakke under vurdering"
        }
      },
      "selectBundle": {
        "addressBundle": {
          "description": "Dette alternativet vil legge til en ny adresse på kontoen din",
          "label": "Adressepakke"
        },
        "regulatoryBundle": {
          "description": "Dette alternativet hjelper deg med å opprette nye regelverkspakker",
          "label": "Regelverkspakke"
        },
        "title": "Velg hvilken pakke du vil legge til"
      },
      "settings": {
        "billing": "Fakturering",
        "calendars": "Kalendere",
        "customEmails": "Egendefinerte e-poster",
        "domains": "Domener",
        "domainsAndUrlRedirects": "Domener og URL-omdirigeringer",
        "facebookFormFieldsMapping": "Kartlegging av Facebook-skjemafelter",
        "groups": "Grupper",
        "integrations": "Integrasjoner",
        "labs": "Laboratorier",
        "media": "Media",
        "noShowSMS": "SMS med manglende oppmøte",
        "pipelines": "Pipelines",
        "profile": "Profil",
        "smtpAndMailGunService": "SMTP- og MailGun-tjeneste",
        "templates": "Maler",
        "urlRedirects": "URL-omdirigeringer"
      },
      "shakenStir": {
        "confirmation": {
          "title": "Anropene dine er nå verifisert!"
        },
        "modal": {
          "andThe": " og den ",
          "certification": "Jeg bekrefter at den tilknyttede bedriftsprofilen er opprinnelsen til telefonsamtalene og bekrefter at jeg vil delta i sporingsarbeid, inkludert de som blir initiert av",
          "failedTitle": "Innsending mislyktes",
          "friendlyNamePlaceholder": "Eks: SHST 2022-11-24 kl 19:47:14",
          "linkInfo": {
            "description": "Alle nåværende tilgjengelige numre og fremtidige kjøpte numre vil automatisk bli registrert med SHAKEN/STIR.",
            "title": "Alle numre vil bli koblet automatisk"
          },
          "stiPa": "Administrator av policyer for sikker telefoniidentitet (STI-PA)",
          "subtitle": "Angi detaljene og beskrivelsen",
          "successMessage": "Din forespørsel om SHAKEN/STIR-registrering er sendt inn. Godkjenning kan ta opptil <b>3–4 dager</b>. Statusen vil snart bli oppdatert.",
          "successTitle": "SHAKEN/STIR klarert oppringing aktivert.",
          "title": "Aktiver SHAKEN/STIR klarert oppringing",
          "tracebackGroup": "US Telecom Traceback Group"
        },
        "withCnam": {
          "cnamPromo": "Vil du gå et skritt videre? Vis firmanavnet ditt på anrop med CNAM.",
          "registerCnam": "Registrer deg for CNAM",
          "title": "Bygg tillit hos kundene dine og øk svarprosenten"
        },
        "successMessage": "Din forespørsel om SHAKEN/STIR-registrering er sendt inn. Godkjenning kan ta opptil <b>3–4 dager</b>. Statusen vil snart bli oppdatert."
      },
      "shopify": {
        "selectLocation": "Velg hvilket sted du vil koble til denne Shopify-butikken"
      },
      "signup": {
        "accountType": "Kontotype",
        "agencyProAccount": "Pro-byråkonto (497 USD/måned)",
        "agencyTestAccount": "Test-byråkonto",
        "freeTrialMessage": "Få en 14 dagers <strong>gratis</strong> prøveperiode ved å registrere deg nå.",
        "freelancerAccount": "Frilanserkonto (297 USD/måned)",
        "getStartedForFree": "Kom i gang gratis!",
        "pickPassword": "Velg et passord",
        "signUp": "Registrer deg",
        "starterAccount": "Startkonto (97 USD/måned)",
        "termsAndConditions": "Ved å registrere deg, godtar du våre <a href='https://www.gohighlevel.com/privacy' target='_blank'>vilkår og betingelser</a>",
        "yourCompanyName": "Firmanavnet ditt",
        "yourFullName": "Ditt fulle navn"
      },
      "standardPlan": {
        "description": "Vi har følgende planer for standard merkevareregistreringer.",
        "plans": {
          "common": {
            "einRequiredForRegistration": "EIN er påkrevd for registrering",
            "moreThan1Phone": "Mer enn ett telefonnummer er tillatt"
          },
          "highVolume": {
            "heading": "Standard for høyt volum",
            "point3": "Opptil 600 000 segmenter per dag",
            "infoText": "Merkevare- og kampanjeregistreringsavgift på $20,95 belastes én gang. En ekstra kampanjeavgift på opptil $2,25 per måned vil påløpe i henhold til TCR-reglene.",
            "point2": "Send opptil 3000 segmenter per dag",
            "point1": "EIN er påkrevd for registrering"
          },
          "lowVolume": {
            "heading": "Standard for lavt volum",
            "recommended": "Anbefalt",
            "point3": "Opptil 6000 segmenter per dag",
            "infoText": "Merkevare- og kampanjeregistreringsavgift på $20,95 belastes én gang. En ekstra kampanjeavgift på opptil $2,25 per måned vil påløpe i henhold til TCR-reglene.",
            "point2": "Send opptil 3000 segmenter per dag",
            "point1": "EIN er påkrevd for registrering"
          }
        },
        "title": "Velg din standard merkevareplan"
      },
      "submissionDetail": {
        "titles": {
          "bookingDetails": "Bestillingsdetaljer",
          "form": "Skjema",
          "quiz": "Quiz",
          "submissionDetail": "Detaljer om innsending",
          "survey": "Spørreundersøkelse"
        }
      },
      "suspension": {
        "suspended": {
          "description": "Bare byråadministratorer/-brukere har tilgang til denne underkontoen. For øyeblikket har ikke du og andre kontoadministratorer/-brukere tilgang til denne underkontoen.",
          "heading": "Denne underkontoen har blitt satt på pause."
        },
        "temporarily": {
          "description": "Alle dataene dine er trygge, og alle utløsere/kampanjer osv. vil fortsette å virke etter aktivering.",
          "heading": " Kontoen din er midlertidig suspendert."
        }
      },
      "triggers": {
        "assignUser": {
          "onlyUnassignedContacts": "Gjelder bare for kontakter som ikke er tilordnet",
          "splitTraffic": "Del opp trafikken",
          "trafficWeightage": "Trafikkvekting",
          "userRequired": "Bruker må velges",
          "weightage": "Vekting"
        },
        "birthdayFilters": {
          "afterDays": "Etter antall dager",
          "beforeDays": "Før antall dager",
          "dayIs": "Dagen er",
          "daysInNumber": "Antall dager",
          "hasTag": "Har tagg",
          "monthIs": "Måneden er",
          "selectDay": "Velg dag",
          "selectMonth": "Velg måned"
        },
        "botConversation": {
          "enterTimeout": "Angi tidsavbrudd (i timer)",
          "selectEliza": "Velg Eliza",
          "selectThankyouTemplate": "Velg takkemal",
          "selectWelcomeTemplate": "Velg velkomstmal"
        },
        "contactField": {
          "addField": "Legg til felt",
          "defineFilters": "Definer filtre"
        },
        "copyModal": {
          "title": "Kopier utløser"
        },
        "detailModal": {
          "actionsPerform": "Hvilke handlinger bør vi utføre?",
          "campaignNameRequired": "Kampanjenavnfeltet er påkrevd",
          "campaignsDeprecation": "Kampanjer vedlikeholdes ikke lenger. For å sikre en smidig overgang, ber vi deg konvertere dine eksisterende kampanjer til arbeidsflyter.",
          "folderName": "Mappenavn",
          "mustSelectFolder": "Må velge en mappe.",
          "newFolderName": "Nytt mappenavn",
          "selectFolder": "Velg mappe",
          "triggerNameRequired": "Feltet utløsernavn er påkrevd",
          "triggersDeprecation": "Utløsere vedlikeholdes ikke lenger. For å sikre en smidig overgang, ber vi deg konvertere eksisterende utløsere til arbeidsflyter.",
          "triggerName": "Navn på utløser"
        },
        "dnd": {
          "disableAll": "Deaktiver DND for alle kanaler",
          "disableSpecific": "Deaktiver DND for spesifikke kanaler",
          "enableAll": "Aktiver DND for alle kanaler",
          "enableSpecific": "Aktiver DND for spesifikke kanaler",
          "selectAction": "Velg handling"
        },
        "email": {
          "sendTestEmail": "Send test-e-post",
          "smtpWarning": "SMTP-leverandører har noen begrensninger. Klikk her for å lese mer."
        },
        "facebook": {
          "avatarAlt": "Facebook-avatar",
          "selectCustomAudience": "Velg tilpasset målgruppe"
        },
        "googleAds": {
          "conversionName": "Konverteringsnavn",
          "conversionTooltip": "Konverteringskilden skal være Importer fra klikk, og kategorien skal være Importert kundeemne eller Kundeemne",
          "noConversions": "Ingen konverteringsfrekvens funnet",
          "selectConversion": "Velg konvertering"
        },
        "googleAnalytics": {
          "eventAction": "Hendelseshandling",
          "eventActionRequired": "Hendelseshandling er påkrevd.",
          "eventCategory": "Hendelseskategori",
          "eventCategoryRequired": "Hendelseskategori er påkrevd.",
          "eventLabel": "Hendelsesmerkelapp",
          "eventValue": "Hendelsesverdi",
          "hitType": "Type",
          "hitTypeRequired": "Trefftype er påkrevd.",
          "trackingId": "Sporings-ID",
          "trackingIdRequired": "Sporings-ID er påkrevd."
        },
        "membershipOffer": {
          "selectOffer": "Velg tilbud"
        },
        "notification": {
          "selectRedirectPage": "Velg omdirigeringsside",
          "selectUser": "Velg bruker",
          "selectUserType": "Velg brukertype"
        },
        "sms": {
          "sendTestSMS": "Send test-SMS"
        },
        "stripeCharge": {
          "customerId": "Kunde-ID fra Stripe",
          "enterAmount": "Skriv inn beløp",
          "selectCurrency": "Velg valuta"
        },
        "webhook": {
          "webhookUrl": "Webhook-URL"
        }
      },
      "twilioReselling": {
        "transactions": {
          "fields": {
            "activityDate": "Aktivitetsdato",
            "balance": "Saldo",
            "id": "id"
          }
        },
        "upgradeBanner": {
          "subtitle": "Byråer med pro-abonnement tjener ca. $363 per måned ved å omfakturere telefonkostnader til kundene sine",
          "title": "Ønsker du å omfakturere dette til kundene dine?"
        }
      },
      "updateModals": {
        "error": {
          "title": "Kunne ikke sende inn profilen din."
        },
        "success": {
          "message": "A2P-merkevaren og kampanjen din er sendt inn.<br/><br/><b>Merk:</b> Du vil <b>motta en OTP-melding på ditt oppgitte mobilnummer for verifisering</b> fra TCR. <b>Svar Ja innen 24 timer</b> etter mottak av SMS-en."
        }
      },
      "usageLimit": {
        "contactLimit": "Kontaktgrense",
        "maxContactsAllowed": "Maksimalt antall kontakter tillatt i underkontoen",
        "maxUsersAllowed": "Maksimalt antall brukere tillatt i underkontoen",
        "unlimited": "Ubegrenset",
        "usageLimits": "Bruksgrenser",
        "userLimit": "Brukergrense",
        "userLimitHelpMessage": "Bare brukere på underkontonivå teller med i denne grensen. Du kan fortsatt legge til så mange byråbrukere til underkontoene som du trenger"
      },
      "yext": {
        "reselling": {
          "agreeToEnable": "Jeg samtykker i å aktivere oppføringer for denne kunden uten mersalg, og jeg erkjenner at jeg vil bli belastet",
          "deployDirectly": "Distribuer lister direkte",
          "deployDirectlyDesc": "Bruk dette alternativet hvis du tilbyr oppføringer som en del av tilbudet ditt, eller hvis du ønsker å fakturere kunden eksternt",
          "minimumCommitment": "med en minimum 1 måneders bindingstid.",
          "offerListings": "Tilbudslister",
          "resellListings": "Videresalgsoppføringer",
          "subscribedInfo": "{withoutUpsell} uten mersalg, {withUpsell} med mersalg og {withSaas} med SaaS-pakke",
          "subscriptionCreated": "Abonnement er opprettet. Vent litt …",
          "subscriptionCreating": "Abonnementet er under opprettelse.<br/>Ikke last inn siden på nytt eller klikk på tilbake-knappen",
          "unableToCreate": "Kan ikke opprette abonnement, ta kontakt med kundestøtte",
          "unavailabilityForAgencyAdmin": "Yext er ikke tilgjengelig i dette landet. Hvis du mener at dette er en feil, kan du be om at vi legger det inn i veikartet vårt på",
          "yourResellOffer": "Ditt tilbud om videresalg"
        }
      },
      "selectCountry": "Velg landet ditt",
      "documents": {
        "additionalInfo": "Tilleggsinformasjon",
        "createAddressLink": "Opprett adresse.",
        "createAddressPrompt": "Opprett en adresse først, og fortsett deretter med å opprette pakken.",
        "selectAddress": "Velg adresse:"
      }
    },
    "triggers": {
      "emptyTrigger": "Tom trigger"
    },
    "util": {
      "addFiles": "+ Legg til filer",
      "fillValues": "Fyll verdier",
      "image": "bilde",
      "ok": "Ok",
      "pleaseTypeOrCancel": "Skriv inn {consentString} ovenfor eller avbryt denne handlingen.",
      "pressEnterToAddCustomOption": "Trykk enter for å legge til et tilpasset alternativ",
      "required": "* påkrevd",
      "unsaved": "Ikke lagret"
    },
    "workflow": {
      "announcement": {
        "enableMessage": "For å aktivere arbeidsflyten for en lokasjon, gå til fanen Kontoer, klikk på ikonet med tre prikker til høyre for en underkonto, og velg <strong>Aktiver arbeidsflytbygger</strong>. Denne prosessen er midlertidig, ettersom arbeidsflyter vil bli tatt i bruk på alle underkontoer i neste uke."
      },
      "faq": "Vanlige spørsmål",
      "gotIt": "Jeg forstår",
      "workflowIsLive": "Arbeidsflyten er live i kontoen din!"
    },
    "action": {
      "stats": {
        "bounced": "Avvist",
        "clicked": "Klikket på",
        "delivered": "Levert",
        "opened": "Åpnet",
        "replied": "Besvart",
        "unsubscribed": "Avmeldt",
        "total": "Totalt",
        "failed": "Mislyktes"
      },
      "actions": {
        "edit": "Rediger",
        "send": "Send",
        "remove": "Fjern"
      },
      "timing": {
        "days": "Dager",
        "immediately": "Umiddelbart",
        "before": "Før",
        "after": "Etter",
        "minutes": "Minutter",
        "hours": "Timer"
      },
      "labels": {
        "template": "Mal",
        "manual": "Manuell"
      },
      "details": {
        "hideDetail": "Skjul detalj",
        "showDetail": "Vis detaljer"
      },
      "queue": {
        "people": "personer",
        "person": "person",
        "queued": "i kø"
      },
      "tooltips": {
        "clickedHelp": "Nøyaktigheten av klikksporing kan variere avhengig av e-postklient og brukerinnstillinger.",
        "statsAccuracy": "Nøyaktigheten av statistikken kan variere avhengig av e-postklient og brukerinnstillinger."
      }
    },
    "bulkRequest": {
      "list": {
        "confirmDelete": "Er du sikker på at du vil slette denne masseforespørselen?",
        "startImmediately": "Start umiddelbart"
      },
      "modal": {
        "contactTypes": {
          "all": "Alle",
          "leads": "Potensielle kunder",
          "customers": "Kunder"
        },
        "buttons": {
          "cancel": "Avbryt",
          "update": "Oppdater",
          "add": "Legg til"
        },
        "labels": {
          "name": "Navn",
          "contactType": "Kontakttype",
          "campaign": "Kampanje",
          "scheduledDate": "Planlagt dato",
          "tag": "Tagg"
        },
        "placeholders": {
          "tags": "Tagger",
          "selectCampaign": "Velg kampanje",
          "pickType": "Velg type"
        },
        "sections": {
          "bulkRequest": "Masseforespørsel",
          "whoShouldRun": "Hvem skal den kjøre for?"
        },
        "titleAdd": "Legg til masseforespørsel",
        "titleEdit": "Rediger masseforespørsel",
        "validation": {
          "scheduledDateRequired": "Planlagt dato er påkrevd"
        }
      }
    },
    "listFolder": {
      "expandIcon": "Utvid"
    },
    "list": {
      "confirmDeleteFolder": "Bekreft sletting av mappe",
      "delete": "Slett",
      "confirmDelete": "Er du sikker på at du vil slette denne kampanjen?",
      "moveToFolder": "Flytt til mappe",
      "pleaseRename": "gi nytt navn",
      "removeFromFolder": "Fjern fra mappe"
    },
    "copy": {
      "title": "Kopier kampanje",
      "newCampaignName": "Nytt kampanjenavn",
      "locations": "Steder"
    }
  },
  "compliance": {
    "findOutMore": "Finn ut mer",
    "gdprDescription": "Vi tar beskyttelsen av dine og dine kunders personopplysninger på største alvor og behandler personopplysninger konfidensielt og i samsvar med lovbestemte personvernregler og denne personvernerklæringen.",
    "gdprTitle": "GDPR-samsvar",
    "hipaaDescription": "Aktiver sikkerhetsoppgraderinger for å sikre at dataene i HighLevel-kontoen din er sikre og oppfyller kravene i HIPAA",
    "hipaaTitle": "HIPAA-overholdelse"
  },
  "customValues": {
    "key": "Nøkkel",
    "selectedItemsCountSingular": "{count} rad er valgt",
    "selectedItemsCountPlural": "{count} rader valgt"
  },
  "facebookAdFields": {
    "checkIcon": "Skjemaet ble tilordnet",
    "errorMessage": "Sidetilgangstokenet er enten utløpt eller har ikke nok tillatelser. Sørg for at du har administratortilgang til sidene."
  },
  "fbLeadSync": {
    "confirmTitle": "Bekrefte synkronisering av Facebook potensielle kunder?",
    "impactMessage": "Forstå effekten av synkronisering av Facebook potensielle kunder før du går videre:",
    "observations": "1. Dette vil synkronisere Facebook potensielle kunder og opprette nye kontakter for alle potensielle kunder som er generert de siste {days} dagene, og som ikke finnes i kontaktlisten din. <br>2. Hvis du har importert manglende potensielle kunder manuelt ved hjelp av CSV eksportert fra Facebook Ads Manager, må du deaktivere «Tillat dupliserte kontakter» for å forhindre at synkroniseringen oppretter dupliserte kontakter. <br>3. Hvis du har arbeidsflyter som utløses ved <b>opprettelse av kontakt</b> eller <b>innsending av Facebook Lead-skjema</b>, vil de bli utløst for hver nye kontakt som opprettes. <br>4. Eksisterende kontakter som er opprettet via Facebook Leads, vil ikke bli påvirket. <br>5. Kontaktopprettelsestidspunktet som er registrert, vil være gjeldende klokkeslett. <br>6. Synkroniseringen kan ta opptil én time å fullføre, avhengig av hvor mange potensielle kunder som ennå ikke er synkronisert. <br>",
    "proceedQuestion": "Vil du fortsette med synkronisering av Facebook potensielle kunder?"
  },
  "integrationAI": {
    "accountDisconnected": "Kontoen er frakoblet!",
    "appNotFound": "App-konfigurasjon ble ikke funnet. Bruk av reservedata.",
    "checkingConnection": "Sjekker tilkoblingsstatus …",
    "connecting": "Kobler til …",
    "disconnectApp": "Koble fra app",
    "disconnecting": "Kobler fra …",
    "loadingAppInfo": "Laster inn appinformasjon …",
    "refreshConnection": "Oppdater tilkobling",
    "refreshing": "Oppdaterer …",
    "svgNotAvailable": "SVG er ikke tilgjengelig"
  },
  "phoneSystem": {
    "additionalSettings": "Flere innstillinger",
    "messaging": "Meldinger",
    "messagingAnalytics": "Meldingsstatistikk",
    "regulatoryBundles": "Regelverkspakker",
    "title": "Telefonsystem",
    "trustCenter": "Tillitssenter",
    "voice": "Stemme"
  },
  "demo": {
    "draggable": {
      "title": "Test av dragbare komponenter",
      "usingVue3": "Bruk av dragbare, Vue 3-kompatible komponenter",
      "description": "Denne komponenten bruker nå den reviderte, dragbare, Vue 3-kompatible komponenten.",
      "buttons": {
        "resetAllLists": "Tilbakestill alle lister",
        "clearLog": "Tøm logg",
        "stopLoading": "Stopp lasting",
        "simulateLoading": "Simulere lasting",
        "refreshData": "Oppdatere data"
      },
      "examples": {
        "basicDraggable": "Grunnleggende dragbar",
        "draggableWithElement": "Dragbar med element",
        "draggableWithTransitionGroup": "Draggable med overføringsgruppe",
        "draggableWithMoveFunction": "Dragbar med flyttefunksjon"
      },
      "eventLog": "Hendelseslogg",
      "handle": "Brukernavn",
      "name": "Navn",
      "cannotMove": "(kan ikke flyttes)"
    },
    "tableDemo": {
      "title": "Vue 3 UIBTable-demo",
      "basicControls": "Grunnleggende kontroller",
      "labels": {
        "filter": "Filter:",
        "sortBy": "Filtrere etter:",
        "sortDirection": "Sorteringsretning:",
        "perPage": "Per side:",
        "tableStyling": "Tabellutseende:"
      },
      "placeholders": {
        "typeToSearch": "Skriv for å søke ......"
      },
      "checkboxLabels": {
        "striped": "Stripete",
        "bordered": "Omkranset",
        "hover": "Hold over",
        "small": "Liten",
        "responsive": "Responsiv"
      },
      "fields": {
        "id": "ID",
        "name": "Navn",
        "email": "E-post",
        "status": "Status",
        "created": "Opprettet",
        "actions": "Handlinger"
      },
      "statuses": {
        "active": "Aktiv",
        "inactive": "Inaktiv",
        "pending": "Avventer",
        "banned": "Utestengt"
      },
      "modal": {
        "title": "Gjenstandsdetaljer",
        "close": "Lukke"
      },
      "messages": {
        "confirmDelete": "Er du sikker på at du vil slette {name}?",
        "editItem": "Rediger gjenstand {id}",
        "showingItems": "Viser {count} av {total} gjenstander"
      }
    },
    "saasPricingTable": {
      "confirmAndProceed": "Bekreft og fortsett",
      "everythingIn": "Alt i <b>{plan}+</b>",
      "noPaymentMethod": {
        "linkText": "legge til kredittkort her",
        "message": "Be kunden din om å",
        "title": "Underkontoen må legge til betalingsmåte først."
      },
      "noSaasPlan": {
        "linkText": "opprett dine SaaS-planer her.",
        "message": "Vennligst",
        "title": "Du har ingen konfigurert SaaS-plan."
      },
      "saasModeSetupPendingWarning": "SaaS-planen vil bli aktivert etter at kunden legger til en betalingsmetode. Inntil da, vil kontotilgangen være privat.",
      "skipForNow": "Hopp over foreløpig",
      "skipPlan": "Hopp over planen"
    }
  },
  "isv": {
    "business_registration_id_type": "Bedriftens type registrerings-ID",
    "business_registration_number": "Bedriftens registreringsnummer",
    "business_website": "Bedriftens nettsted",
    "enter_your_business_registration_id_type": "Angi bedriftens type registrerings-ID",
    "name_of_other_registration_id_type": "Navn på annen type registrerings-ID",
    "pick_business_industry": "Velg bedriftens bransje",
    "pick_business_registration_id_type": "Velg bedriftens type registrerings-ID",
    "emailWithStar": "E-post*",
    "businessIndustry": "Bedriftens bransje*",
    "businessType": "Type bedrift*",
    "regionsOfOperations": "Bedriftens driftsregioner*",
    "registrationNumber": "Bedriftens registreringsnummer*",
    "registrationNumberHelper": "Nummeret som brukes til å identifisere bedriften din. For amerikansk EIN, må det være et 9-sifret nummer, f.eks. 12-3456789.",
    "businessWebsiteWithStar": "Bedriftens nettsted*",
    "businessTypeWithStar": "Virksomhetstype",
    "businessWebsite": "Bedriftens nettsted"
  },
  "aiProductRebilling": {
    "enableRebilling": "Aktiver omfakturering",
    "ratesMayDiffer": "Prisene kan variere, avhengig av regionen. Beregningene som vises er i henhold til satser for Storbritannia,",
    "supportDoc": "støttedokument",
    "cancel": "Avbryt",
    "profit": "Fortjeneste",
    "chargedToCustomer": "Belastet kunden",
    "enabling": "Aktiverer …",
    "forMore": "for mer informasjon.",
    "rebillAmount": "Omfaktureringsbeløp",
    "tenDollarsWillGive": "$10 vil gi deg omtrent",
    "yourCost": "Din kostnad",
    "clientBillingPage": "faktureringssiden for kundens selskap",
    "needStripeConnection": "For å aktivere omfakturering må du koble til Stripe-kontoen din",
    "per1000Words": "per 1000 ord",
    "perImage": "per bilde",
    "perReviewResponse": "per svar på anmeldelse",
    "perFunnel": "per trakt",
    "minimumBetween": "Minimum må være mellom {min} og {max}",
    "images": "bilder",
    "reviewResponse": "svar på anmeldelse",
    "funnel": "trakt",
    "pleaseCheckSupport": "Sjekk"
  },
  "a2p": {
    "otpSuccess": {
      "title": "OTP vellykket",
      "message": "OTP-suksessmelding"
    },
    "otpError": {
      "title": "OTP-feil",
      "message": "OTP-feilmelding"
    },
    "businessProfileError": {
      "title": "Feil i bedriftsprofil",
      "message": "Feilmelding for bedriftsprofil"
    },
    "addressError": {
      "title": "Adressefeil",
      "status": "Status for adressefeil"
    },
    "profileError": {
      "title": "A2P-profilfeil",
      "message": "A2P-profilfeilmelding"
    },
    "address": {
      "country": "Land",
      "state": "Stat",
      "chooseCountry": "Velg land …",
      "statePlaceholder": "Skriv inn delstat",
      "chooseState": "Velg stat …",
      "city": "By*",
      "postalCode": "Postnummer*",
      "streetAddress": "Gateadresse*",
      "streetAddressHelper": "Må være en gyldig adresse knyttet til din bedrift.",
      "title": "Forretningsadresse"
    },
    "validation": {
      "brandNameRequired": "Merkenavn er påkrevd.",
      "businessVerticalRequired": "Bedriftens område er påkrevd.",
      "cityRequired": "By er påkrevd.",
      "countryRequired": "Land er påkrevd.",
      "invalidMobileNumber": "Ugyldig mobilnummer.",
      "mobileNumberRequired": "Mobilnummer er påkrevd.",
      "postalCodeRequired": "Postnummer er påkrevd.",
      "stateRequired": "Stat er påkrevd.",
      "streetAddressRequired": "Gateadresse er påkrevd."
    },
    "authorizedRep": {
      "email": "E-post*",
      "firstName": "Fornavn*",
      "jobPosition": "Stilling*",
      "jobTitle": "Stillingstittel*",
      "jobTitlePlaceholder": "Skriv inn stillingstittel",
      "lastName": "Etternavn*",
      "phoneNumber": "Telefonnummer*",
      "phoneNumberPlaceholder": "Skriv inn telefonnummer",
      "pickJobPosition": "Velg stilling",
      "title": "Info om autorisert representant"
    },
    "registration": {
      "stepProgress": "Trinn {currentStep} av 8",
      "successTitle": "A2P-merkevaren og kampanjen din er sendt inn.",
      "successWaitDays": "7 dager",
      "successWaitPrefix": "Det kan ta opptil ",
      "successWaitSuffix": " for godkjenning av merkevaren din og ytterligere 4–5 uker for godkjenning av kampanjen.",
      "otpNote": "Merk: Du vil motta en OTP-melding fra TCR på ditt utstedte mobilnummer som må verifiseres. Svar Ja innen 24 timer etter mottak av SMS-en."
    },
    "update": {
      "brandDetailsTitle": "Oppdater merkevaredetaljer",
      "brandName": "Navn på merkevare*",
      "brandNameHelper": "Bruk enten det juridiske navnet til organisasjonen som sender meldingene, eller ditt eget navn hvis denne merkevaren ikke er for en organisasjon.",
      "businessVerticals": "Bedriftens bransje*",
      "chooseVertical": "Velg bransje ...",
      "mobileNumber": "Mobilnummer for OTP-verifisering (med landskode)*",
      "mobileNumberHelper": "Angi et mobilnummer som du har tilgang til så du kan bekrefte OTP-verifisering. Kun amerikanske/kanadiske numre vil bli godkjent. Du kan ikke bruke et CPaaS-telefonnummer, for eksempel et som du har fått fra LeadConnector. Du kan ikke bruke det samme mobilnummeret til å registrere mer enn tre enkeltpersonforetak. Denne grensen administreres av TCR.",
      "updateButton": "Oppdater",
      "retryOTPTitle": "Prøv OTP på nytt",
      "retryOTPMessage": "Klikk på knappen nedenfor for å sende bekreftelsesmeldingen for OTP på nytt.",
      "sending": "Sender ...",
      "resendOTP": "Send OTP på nytt"
    },
    "einModal": {
      "title": "Har du et EIN-nummer?",
      "question": "Har du et arbeidsgiveridentifikasjonsnummer (EIN)?",
      "hasEIN": "Ja, jeg har EIN",
      "noEIN": "Nei, jeg har ikke et EIN-nummer",
      "disableNoEINText": "EIN er påkrevd for steder utenfor USA og Canada.",
      "infoText": "Et EIN-nummer er påkrevd for bedrifter i USA og Canada."
    },
    "brandDetails": {
      "brandHeading": "Merkevaredetaljer",
      "brandName": "Navn på merkevare*",
      "brandNameHelper": "Bruk enten det juridiske navnet til organisasjonen som sender meldingene, eller ditt eget navn hvis denne merkevaren ikke er for en organisasjon.",
      "businessIndustry": "Bedriftens bransje*",
      "chooseVertical": "Velg bransje ...",
      "mobileNumber": "Mobilnummer for OTP-verifisering (med landskode)*",
      "mobileNumberHelper": "Angi et mobilnummer som du har tilgang til så du kan bekrefte OTP-verifisering. Kun amerikanske/kanadiske numre vil bli godkjent. Du kan ikke bruke et CPaaS-telefonnummer, for eksempel et som du har fått fra LeadConnector. Du kan ikke bruke det samme mobilnummeret til å registrere flere enn tre enkeltpersonforetak. Denne grensen administreres av TCR.",
      "solePropBrand": {
        "heading": "Enkeltpersonforetak-merkevare",
        "point1": "Kun ett telefonnummer er tillatt",
        "point2": "EIN/SSN/DUNS er ikke påkrevd",
        "subheading": "Registrering av enkeltpersonforetak-merke"
      },
      "solePropCampaign": {
        "heading": "Enkeltpersonforetak-kampanje",
        "point1": "Bare ett nummer kan knyttes til en enkeltpersonforetakskampanje",
        "point2": "Når det er godkjent, vil standardnummeret ditt bli tilknyttet automatisk",
        "infoText": "Du kan også oppdatere nummeret etter godkjenning",
        "warningText": "Bare ett nummer kan knyttes til en enkeltpersonforetakskampanje. Når det er godkjent, vil standardnummeret ditt bli tilknyttet automatisk. Du kan også oppdatere nummeret etter godkjenning.",
        "subheading": "Registrering av kampanje for enkeltpersonforetak"
      },
      "solePropSubtitle": "Enkeltpersonforetak merkevare- og kampanjedetaljer",
      "standardBrand": {
        "heading": "$4.41 - én gang",
        "point1": "EIN/SSN/DUNS er påkrevd",
        "point2": "Mer enn ett telefonnummer er tillatt",
        "subheading": "Standard merkevareregistrering"
      },
      "standardCampaign": {
        "heading": "$16,54 - én gang",
        "point1": "Mer enn ett nummer er tillatt å koble til en standardkampanje",
        "point2": "EIN/SSN/DUNS er påkrevd",
        "infoText": "En ekstra kampanjeavgift på opptil $12 per måned vil påløpe i henhold til TCR-reglene.",
        "subheading": "Standard kampanjeregistrering"
      },
      "standardSubtitle": "Standard merkevare- og kampanjedetaljer",
      "title": "Merkevare- og kampanjedetaljer"
    },
    "campaign": {
      "useCaseDetails": {
        "title": "Detaljer om kampanjens brukstilfelle",
        "subtitle": "Angi kampanjedetaljer og beskrivelse",
        "useCase": "Brukstilfelle for kampanje*",
        "pickUseCase": "Velg brukstilfelle for kampanje",
        "useCaseDescription": "Beskrivelse av brukstilfelle*",
        "explainInDetail": "Gi detaljert forklaring",
        "useCaseDescriptionPlaceholder": "Eksempel: Denne kampanjen sender informasjon om avtaler - bekreftelse og påminnelsesmeldinger til kundene våre når de har bestilt en time hos oss på nettstedet vårt og har valgt å motta reklame- og varslings-SMS fra oss.",
        "useCaseDescriptionHelper": "Gi en detaljert beskrivelse av hvordan du vil bruke denne kampanjen.",
        "solePropLabel": "Enkeltpersonforetak",
        "seeExamples": "Se eksempler",
        "closeExamples": "Lukk eksempler"
      }
    }
  },
  "opportunities": {
    "email": "E-post",
    "phone": "Telefon",
    "status": "Status",
    "contactType": "Kontakttype",
    "bulkOperation": "Bulk-prosess",
    "contactName": "Kontaktnavn",
    "unassigned": "Ikke tilordnet",
    "abandoned": "Forlatt",
    "addOpportunityName": "Legg til navn på mulighet",
    "companyName": "Firmanavn",
    "contactInfo": "Kontaktinformasjon",
    "enterValue": "Angi verdi",
    "lost": "Tapt",
    "open": "Åpen",
    "opportunityInfo": "Mulighetsinfo",
    "opportunityName": "Navn på mulighet",
    "opportunitySource": "Mulighetskilde",
    "owner": "Eier",
    "pipeline": "Pipeline",
    "selectPipeline": "Velg prosess",
    "selectStage": "Velg fase",
    "stage": "Etappe",
    "won": "Vunnet",
    "createdOn": "Opprettet",
    "goToContactDetail": "Gå til kontaktinformasjonssiden",
    "leadValue": "Lead-verdi",
    "removeOwner": "Fjern eier",
    "createdBy": "Opprettet av",
    "notAllowedToChange": "Du har ikke tillatelse til å endre denne kontakten",
    "opportunityAlreadyExists": "En mulighet eksisterer allerede for denne kontakten i den valgte pipelinen.",
    "filters": {
      "all": "Alle",
      "statuses": {
        "all": "Alle",
        "open": "Åpne",
        "won": "Vunnet",
        "lost": "Tapt",
        "abandoned": "Forlatt"
      },
      "search": "Søke",
      "status": "Status",
      "campaign": "Kampanje",
      "owner": "Eier",
      "pipeline": "Pipeline",
      "dateAddedAsc": "↑ Dato lagt til (STIG)",
      "dateAddedDesc": "↓ Dato lagt til (SYNK)",
      "orderBy": "SorterEtter"
    },
    "columns": {
      "note": "Merknad",
      "task": "Oppgave",
      "companyName": "Firmanavn",
      "additionalInfo": "Tilleggsinformasjon",
      "calendarEvent": "Kalenderhendelse",
      "hideAssignedTo": "Skjul tilordnet til",
      "hideTags": "Skjul tagger"
    },
    "buttons": {
      "new": "Ny"
    },
    "dragActions": {
      "abandoned": "Forlatt",
      "lost": "Tapt",
      "won": "Vunnet"
    },
    "getStarted": "komme i gang.",
    "noPipelines": "Oops! Det ser ut til at det ikke er noen pipeline. Oprett pipeline for å",
    "addTask": "Legg til oppgave",
    "tasksCount": "{count} aktiviteter"
  },
  "appointmentDetails": "Avtaledetaljer",
  "cloneFunnel": {
    "cloneButton": "Klone {entityName}",
    "cloning": "Kloner …",
    "cloningLimit": "Kloning er begrenset til tre underkontoer om gangen",
    "error": "Feil under kloning av trakt!",
    "locationsLabel": "Velg steder",
    "nameLabel": "Navn for den klonede {entityName}",
    "namePlaceholder": "Angi navn for klonet {entityName}",
    "selectUpTo": "Velg opptil {maxSelectableLocations} steder",
    "title": "Klone {entityName}"
  },
  "errors": "Feil",
  "renderEmailAddress": "Gjengi e-postadresse",
  "noPaymentMethodWarning": "Advarsel om ingen betalingsmetode",
  "pageDetail": "Sidedetalj",
  "activityHistory": "Aktivitetshistorikk",
  "uiAlert": "UI-varsel",
  "eventModals": {
    "wait": {
      "save": "Lagre",
      "days": "Dager",
      "fri": "Fre",
      "mon": "Man",
      "sat": "Lør",
      "sun": "Sun",
      "thu": "Tor",
      "tue": "Tir",
      "wed": "Ons",
      "wait": "Vent",
      "minutes": "Minutter",
      "hours": "Timer",
      "title": "Rediger ventetidshendelse",
      "whichDaysResume": "Hvilke dager bør vi gjenoppta?",
      "pickDayError": "Velg minst én dag",
      "whatTimeResume": "Når skal vi gjenoppta?"
    },
    "sms": {
      "send": "Send",
      "name": "Navn",
      "attachFile": "Legg ved fil",
      "learnMore": "Les mer",
      "sendTest": "Send test",
      "title": "Rediger {eventType}-hendelse",
      "titleTemplate": "Rediger {eventType}-mal",
      "nameRequired": "Navn er påkrevd",
      "pickTemplate": "Velg mal",
      "appCharacters": "App-tegn",
      "numSegments": "Antall segmenter",
      "approximateCost": "Omtrentlig kostnad",
      "costEstimateNote": "Notat for kostnadsestimat",
      "urlAttachmentAutocompleteToken": "URL-vedlegg",
      "addFileUrl": "Legg til en fil-URL",
      "urlImageAlt": "Bilde-URL",
      "fileImageAlt": "Bildefil",
      "enterMessage": "Skriv inn en melding",
      "mobilePhonePlaceholder": "Mobiltelefon",
      "unsupportedContentType": "Ustøttet innholdstype: {fileType}",
      "urlAttachmentWarning": "{count} URL-vedlegg{plural} kunne ikke lastes inn. Vil du fortsette?",
      "provideMobileNumber": "Oppgi mobilnummer"
    },
    "email": {
      "text": "Tekst",
      "checkLinks": "Sjekk lenkene der du har en tilpasset verdi. Det er en ekstra '%20' mellom {{ og custom_values.",
      "errorOccurred": "Det oppstod en feil, prøv igjen.",
      "insertToAddress": "Skriv inn en mottaksadresse."
    },
    "voicemail": {
      "save": "Lagre",
      "dropFile": "Slipp fil her eller klikk for å laste opp",
      "faq": "Vanlige spørsmål",
      "title": "Rediger telefonsvarerhendelse",
      "voicemailFile": "Talepostfil",
      "warning": "Advarsel: Talepostfiler må være i MP3-, WAV- eller GSM-format.",
      "unsupportedFormat": "Filformatet støttes ikke. Bruk MP3, WAV eller GSM."
    },
    "call": {
      "title": "Rediger samtalehendelse",
      "save": "Lagre",
      "name": "Navn",
      "nameRequired": "Navn er påkrevd",
      "callWhisper": "Diskret melding ved svar",
      "whisperMessage": "Diskret melding",
      "thisIsTheMessage": "Dette er meldingen som vil bli spilt av for agenten før samtalen kobles til.",
      "callTimeoutS": "Tidsavbrudd for anrop (s)",
      "timeoutSeconds": "Tidsavbrudd (sekunder)",
      "disableVoicemailDetect": "Deaktiver talepostgjenkjenning",
      "callWillPatchInstantly": "Samtalen vil bli koblet umiddelbart uten å aktivere telefonsvareren."
    }
  },
  "emailTemplate": {
    "createdOn": "Opprettet den",
    "updatedOn": "Oppdatert"
  },
  "cnam": {
    "learnMore": {
      "title": "CNAM Lær mer",
      "description": "CNAM-beskrivelse"
    },
    "submitted": {
      "checkStatus": "Sjekk CNAM-status",
      "description": "Bedriftsnavnet ditt bør vises til aktuelle kontakter i løpet av 3–5 dager.",
      "subtitle": "CNAM-forespørselen din er nå sendt inn.",
      "title": "Gratulerer!"
    },
    "registration": {
      "confirm": "Bekreft",
      "learnMore": "Les mer",
      "characterLimit": "{count}/15",
      "title": "CNAM-registrering",
      "description": "Skriv inn firmanavnet ditt (maks 15 tegn)",
      "warning": "Advarsel: Bedriftsnavnet ditt vil bli vist på anrops-ID-en. "
    }
  },
  "updateModals": {
    "error": {
      "title": "Oppdateringsfeil",
      "message": "Oppdater feilmelding"
    },
    "success": {
      "message": "A2P-merkevaren og kampanjen din er sendt inn.<br/><br/><b>Merk:</b> Du vil <b>motta en OTP-melding fra TCR på ditt utstedte mobilnummer som må verifiseres</b>. Svar <b>Ja innen 24 timer</b> etter mottak av SMS-en.",
      "title": "A2P-merkevaren og kampanjen din er sendt inn. Det kan ta opptil <b>7 dager</b> for godkjenning av merkevaren din, og ytterligere 4-5 uker for godkjenning av kampanjen."
    }
  },
  "regulatoryBundle": {
    "error": {
      "title": "Feil i regelverkspakke",
      "status": "Status for feil i regelverkspakken"
    },
    "createAddress": {
      "successMessage": "A2P-merkevaren og kampanjen din er sendt inn.",
      "successTitle": "Adressen er sendt inn",
      "underReview": "Innsendt adresse er under vurdering"
    },
    "createEndUser": {
      "dateFormat": "Datoformatet skal være ÅÅÅÅ-MM-DD.",
      "phoneExample": " Eksempel: +14155552671",
      "title": "Bedriftsdetaljer:"
    },
    "success": {
      "title": "Innsending av regelverkspakke er gjort",
      "underReview": "Innsendt pakke er under vurdering",
      "message": "Din forespørsel om SHAKEN/STIR-registrering er sendt inn. Godkjenning kan ta opptil <b>3–4 dager</b>. Statusen vil snart bli oppdatert."
    },
    "documents": {
      "additionalInfo": "Tilleggsinformasjon",
      "createAddressLink": "Opprett adresse.",
      "createAddressPrompt": "Opprett en adresse først, og fortsett deretter med å opprette pakken.",
      "selectAddress": "Velg adresse:"
    },
    "selectBundle": {
      "addressBundle": {
        "description": "Dette alternativet vil legge til en ny adresse på kontoen din",
        "label": "Adressepakke"
      },
      "regulatoryBundle": {
        "description": "Dette alternativet hjelper deg med å opprette nye regelverkspakker",
        "label": "Regelverkspakke"
      },
      "title": "Velg hvilken pakke du vil legge til"
    },
    "modal": {
      "back": "Tilbake",
      "next": "Neste",
      "submit": "Send inn",
      "title": "Ny regelverkspakke",
      "description": "Opprett en ny regelverkspakke for din lokasjon"
    }
  },
  "reminder": {
    "phone": "Telefon",
    "noReplyYet": "Ingen svar ennå"
  },
  "sendGrid": {
    "apiKey": "SendGrid API-nøkkel",
    "save": "SendGrid lagre",
    "apiKeyRequired": "SendGrid API-nøkkel er påkrevd"
  },
  "twilioReselling": {
    "upgradeBanner": {
      "upgradeButton": "Oppgrader",
      "subtitle": "Byråer med pro-abonnement tjener ca. $363 per måned ved å omfakturere telefonkostnader til kundene sine",
      "title": "Ønsker du å omfakturere dette til kundene dine?"
    }
  },
  "emailField": {
    "label": "E-post",
    "placeholder": "E-post",
    "tooltip": {
      "primary": "Primær",
      "emails": "E-poster"
    }
  },
  "attachSnapshotToggle": {
    "loadSnapshot": "Last inn øyeblikksbilde:",
    "loadSnapshotWarning": "Ønsker du å laste inn øyeblikksbildet som er knyttet til denne planen? <br /> <strong class='text-danger'>Eksisterende data kan gå tapt</strong>"
  },
  "suspension": {
    "suspended": {
      "description": "Bare byråadministratorer/-brukere har tilgang til denne underkontoen. For øyeblikket har ikke du og andre kontoadministratorer/-brukere tilgang til denne underkontoen.",
      "heading": "Denne underkontoen har blitt satt på pause."
    },
    "temporarily": {
      "description": "Alle dataene dine er trygge, og alle utløsere/kampanjer osv. vil fortsette å virke etter aktivering.",
      "heading": " Kontoen din er midlertidig suspendert."
    }
  },
  "callerIdUpdateModal": {
    "friendlyName": "Bedriftens kallenavn",
    "title": "Oppdater anroper-ID"
  },
  "drChronoOfficeSelect": {
    "selectOffice": "Velg kontor",
    "whichOffice": "Hvilket kontor vil du koble til denne kontoen?",
    "connect": "Koble til."
  },
  "phoneField": {
    "label": "Telefon",
    "placeholder": "Telefonnummer",
    "tooltip": {
      "invalidNumber": "Ugyldig telefonnummer",
      "notSmsCapable": "Dette {type}-nummeret er ikke SMS-kompatibelt."
    }
  },
  "submissionDetail": {
    "titles": {
      "bookingDetails": "Bestillingsdetaljer",
      "form": "Skjema",
      "quiz": "Quiz",
      "submissionDetail": "Detaljer om innsending",
      "survey": "Spørreundersøkelse"
    }
  },
  "shakenStir": {
    "confirmation": {
      "description": "Din forespørsel om SHAKEN/STIR-registrering er sendt inn. Godkjenning kan ta opptil <b>3–4 dager</b>. Statusen vil snart bli oppdatert.",
      "title": "SHAKEN/STIR klarert oppringing aktivert."
    },
    "modal": {
      "andThe": " og ",
      "businessProfile": "Bedriftsprofil",
      "certification": "Jeg bekrefter at den tilknyttede bedriftsprofilen er opprinnelsen til telefonsamtalene, og bekrefter at jeg vil delta i sporingsarbeid, inkludert de som blir initiert av",
      "failedTitle": "Innsending mislyktes",
      "friendlyName": "Kallenavn",
      "friendlyNamePlaceholder": "Eks: SHST 2022-11-24 kl 19:47:14",
      "linkInfo": {
        "description": "Alle nåværende tilgjengelige numre og fremtidige kjøpte numre vil automatisk bli registrert med SHAKEN/STIR.",
        "title": "Alle numre blir automatisk koblet sammen"
      },
      "stiPa": "Administrator av policyer for sikker telefoniidentitet (STI-PA)",
      "subtitle": "Angi detaljene og beskrivelsen",
      "successMessage": "Din forespørsel om SHAKEN/STIR-registrering er sendt inn. Godkjenning kan ta opptil <b>3–4 dager</b>. Statusen vil snart bli oppdatert.",
      "successTitle": "SHAKEN/STIR klarert oppringing er aktivert.",
      "title": "Aktiver SHAKEN/STIR klarert oppringing",
      "tracebackGroup": "US Telecom Traceback Group"
    },
    "withCnam": {
      "cnamPromo": "Registrer deg for CNAM for å vise bedriftsnavnet ditt på anrops-ID",
      "registerCnam": "Registrer CNAM"
    }
  },
  "task": {
    "2day": "2 dager",
    "3day": "3 dager",
    "4day": "4 dager",
    "5day": "5 dager",
    "addTask": "Legg til oppgave",
    "countTasks": "{count} oppgaver"
  },
  "updatedProductsModal": {
    "title": "Oppdaterte produkter",
    "copyDirectSaleLink": "Kopier lenke for direkte salg",
    "setupFeeInstruction": "Oppsettgebyret kan konfigureres i Stripe Dashboard. ",
    "doNotDeleteWarning": "Ikke slett produkter eller priser fra Stripe Dashboard. Dette vil bryte integrasjonen."
  },
  "termsOfService": {
    "privacyLink": "Personvernerklæring",
    "accept": "Godta",
    "termsLink": "Tjenestevilkår",
    "updateMessage": "Vi har oppdatert våre bruksvilkår og personvernerklæring. Gjennomgå og godta for å fortsette.",
    "agreementPrefix": "Ved å fortsette, godtar du våre ",
    "agreementConjunction": " og "
  },
  "callerIdVerificationModal": {
    "answerCall": "Svar på anropet og tast inn denne bekreftelseskoden:",
    "leadConnectorCalling": "Lead Connector ringer …",
    "title": "Legg til en anrops-ID etter stemme",
    "waitingForVerification": "Venter på bekreftelsen …"
  },
  "emailOTPModal": {
    "confirmCode": "Bekreft kode",
    "resendCode": "Hvis du ikke mottok koden, klikk her for å sende den på nytt"
  },
  "survey": {
    "copy": {
      "cancel": "Avbryt",
      "location": "Sted",
      "copy": "Kopier",
      "newSurveyName": "Nytt navn på spørreundersøkelse",
      "title": "Kopier spørreundersøkelse",
      "locationRequired": "Sted er obligatorisk"
    }
  },
  "stripeProductDetailsModal": {
    "productName": "Produktnavn",
    "planDetails": "Informasjon om abonnement",
    "title": "Produktbeskrivelse",
    "planId": "Plan-ID",
    "copiedToClipboard": "Kopiert til utklippstavlen"
  },
  "importCustomers": {
    "newExperience": {
      "efficient": "Mer effektivt",
      "faster": "Raskere",
      "itsText": "Det er",
      "smoother": "Jevnere",
      "title": "En ny importopplevelse er her!",
      "warningMessage": "Når du aktiverer den nye importopplevelsen, aktiveres Labs for denne underkontoen og Beta-funksjonen slås på.",
      "tryNow": "Prøv nå"
    },
    "validateEmails": "Validere e-poster?"
  },
  "yext": {
    "reselling": {
      "zero": "0",
      "highlevelPrice": "HighLevel-pris",
      "howDoesItWork": "Hvordan fungerer det?",
      "payNow": "Betal nå",
      "priceError": "Prisen må være høyere enn eller lik HighLevel-prisen",
      "saving": "Lagrer",
      "yourPrice": "Din pris",
      "yourProfit": "Din fortjeneste",
      "subscriptionCreating": "Abonnementet er under opprettelse.<br/>Ikke last inn siden på nytt eller klikk på tilbake-knappen",
      "subscriptionCreated": "Abonnement er opprettet. Vent litt …",
      "unableToCreate": "Kan ikke opprette abonnement, ta kontakt med kundestøtte",
      "perMonth": "per måned",
      "agreeToEnable": "Jeg samtykker i å aktivere oppføringer for denne kunden uten mersalg, og jeg erkjenner at jeg vil bli belastet",
      "deployDirectly": "Distribuer lister direkte",
      "deployDirectlyDesc": "Bruk dette alternativet hvis du tilbyr oppføringer som en del av tilbudet ditt, eller hvis du ønsker å fakturere kunden eksternt",
      "minimumCommitment": "med minimum 1 måneds bindingstid.",
      "offerListings": "Tilbudslister",
      "resellListings": "Videresalgsoppføringer",
      "subscribedInfo": "{withoutUpsell} uten mersalg, {withUpsell} med mersalg og {withSaas} med SaaS-pakke",
      "yourResellOffer": "Ditt tilbud om videresalg"
    }
  }
}
